// import React from "react";

// export default function MerchantFeedbackLog() {

//   const criticalFeedbacks = [
//     {
//       id: 1,
//       phone: "+91 9876543210",
//       rating: "2 Star",
//       complaint: "Food was cold and service was slow.",
//     },
//     {
//       id: 2,
//       phone: "+91 9988776655",
//       rating: "1 Star",
//       complaint: "Staff behaviour was not good.",
//     },
//     {
//       id: 3,
//       phone: "+91 9123456780",
//       rating: "3 Star",
//       complaint: "Waiting time was too long.",
//     },
//   ];

//   const customers = [
//     {
//       id: 1,
//       phone: "+91 9876543210",
//       visits: 12,
//       lastVisit: "25 May 2026",
//       coupons: "5 Redeemed",
//     },
//     {
//       id: 2,
//       phone: "+91 9988776655",
//       visits: 8,
//       lastVisit: "23 May 2026",
//       coupons: "2 Redeemed",
//     },
//     {
//       id: 3,
//       phone: "+91 9123456780",
//       visits: 15,
//       lastVisit: "24 May 2026",
//       coupons: "7 Redeemed",
//     },
//     {
//       id: 4,
//       phone: "+91 9011223344",
//       visits: 5,
//       lastVisit: "21 May 2026",
//       coupons: "1 Redeemed",
//     },
//   ];

//   return (
//     <>
//       <style>{`

//         *{
//           margin:0;
//           padding:0;
//           box-sizing:border-box;
//           font-family:'Poppins',sans-serif;
//         }

//         body{
//           background:#f5f7fb;
//         }

//         .analytics-page{
//           min-height:100vh;
//           padding:35px;
//           background:
//           linear-gradient(135deg,#fff7ed,#fff,#eef4ff);
//         }

//         /* HEADER */

//         .top-header{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           flex-wrap:wrap;
//           gap:20px;
//           margin-bottom:35px;
//         }

//         .top-header h1{
//           font-size:42px;
//           font-weight:800;
//           color:#111827;
//           margin-bottom:8px;
//         }

//         .top-header p{
//           color:#6b7280;
//           font-size:16px;
//         }

//         .header-icon{
//           width:75px;
//           height:75px;
//           border-radius:24px;
//           background:
//           linear-gradient(135deg,#ff8c42,#ff5e62);
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:34px;
//           color:white;
//           box-shadow:0 15px 30px rgba(255,94,98,0.3);
//         }

//         /* CHART GRID */

//         .chart-grid{
//           display:grid;
//           grid-template-columns:repeat(auto-fit,minmax(280px,1fr));
//           gap:25px;
//           margin-bottom:35px;
//         }

//         .chart-card{
//           background:white;
//           border-radius:32px;
//           padding:30px;
//           box-shadow:0 15px 40px rgba(0,0,0,0.05);
//           position:relative;
//           overflow:hidden;
//         }

//         .chart-card::before{
//           content:'';
//           position:absolute;
//           width:180px;
//           height:180px;
//           background:rgba(255,140,66,0.08);
//           border-radius:50%;
//           top:-60px;
//           right:-60px;
//         }

//         .chart-card h2{
//           font-size:22px;
//           margin-bottom:25px;
//           color:#111827;
//           position:relative;
//           z-index:2;
//         }

//         /* BAR CHART */

//         .bars{
//           display:flex;
//           align-items:flex-end;
//           gap:18px;
//           height:220px;
//           position:relative;
//           z-index:2;
//         }

//         .bar-item{
//           flex:1;
//           text-align:center;
//         }

//         .bar{
//           width:100%;
//           border-radius:18px 18px 8px 8px;
//           background:
//           linear-gradient(180deg,#ff8c42,#ff5e62);
//           margin-bottom:12px;
//           transition:0.3s;
//         }

//         .bar:hover{
//           transform:scaleY(1.05);
//         }

//         .bar-label{
//           font-size:14px;
//           color:#6b7280;
//           font-weight:600;
//         }

//         /* PIE */

//         .pie-wrapper{
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           flex-direction:column;
//           position:relative;
//           z-index:2;
//         }

//         .pie{
//           width:190px;
//           height:190px;
//           border-radius:50%;
//           background:
//           conic-gradient(
//             #ff8c42 0% 65%,
//             #ffd6b8 65% 100%
//           );
//           margin-bottom:20px;
//           position:relative;
//         }

//         .pie::after{
//           content:'';
//           position:absolute;
//           width:110px;
//           height:110px;
//           background:white;
//           border-radius:50%;
//           top:40px;
//           left:40px;
//         }

//         .pie-text{
//           position:absolute;
//           font-size:28px;
//           font-weight:800;
//           color:#111827;
//         }

//         .pie-info{
//           color:#6b7280;
//           font-size:15px;
//           text-align:center;
//           line-height:1.7;
//         }

//         /* PANELS */

//         .panel{
//           background:white;
//           border-radius:35px;
//           padding:35px;
//           margin-bottom:35px;
//           box-shadow:0 15px 40px rgba(0,0,0,0.05);
//         }

//         .panel h2{
//           font-size:32px;
//           margin-bottom:12px;
//           color:#111827;
//         }

//         .panel p{
//           color:#6b7280;
//           margin-bottom:30px;
//           line-height:1.8;
//         }

//         /* FEEDBACK */

//         .feedback-list{
//           display:flex;
//           flex-direction:column;
//           gap:22px;
//         }

//         .feedback-card{
//           background:#fff5f5;
//           border-left:6px solid #ef4444;
//           border-radius:24px;
//           padding:28px;
//           transition:0.3s;
//         }

//         .feedback-card:hover{
//           transform:translateY(-4px);
//         }

//         .feedback-top{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           flex-wrap:wrap;
//           gap:15px;
//           margin-bottom:15px;
//         }

//         .feedback-phone{
//           font-size:18px;
//           font-weight:700;
//           color:#111827;
//         }

//         .feedback-rating{
//           background:#fee2e2;
//           color:#dc2626;
//           padding:10px 16px;
//           border-radius:30px;
//           font-size:13px;
//           font-weight:700;
//         }

//         .feedback-card p{
//           margin:0;
//           color:#6b7280;
//           line-height:1.8;
//         }

//         /* TABLE */

//         .table-container{
//           overflow:auto;
//         }

//         table{
//           width:100%;
//           border-collapse:collapse;
//           min-width:850px;
//         }

//         th{
//           background:#fff7ed;
//           padding:18px;
//           text-align:left;
//           color:#111827;
//           font-size:15px;
//         }

//         td{
//           padding:20px 18px;
//           border-bottom:1px solid #eee;
//           color:#4b5563;
//           font-size:15px;
//         }

//         tr:hover{
//           background:#fafafa;
//         }

//         .visit-badge{
//           display:inline-block;
//           padding:10px 18px;
//           border-radius:30px;
//           background:#ecfdf5;
//           color:#059669;
//           font-size:13px;
//           font-weight:700;
//         }

//         /* RESPONSIVE */

//         @media(max-width:768px){

//           .analytics-page{
//             padding:20px;
//           }

//           .top-header h1{
//             font-size:30px;
//           }

//           .panel{
//             padding:25px;
//           }

//           .panel h2{
//             font-size:26px;
//           }

//           .chart-card{
//             padding:25px;
//           }

//         }

//       `}</style>

//       <div className="analytics-page">

//         {/* HEADER */}

//         <div className="top-header">

//           <div>

//             <h1>
//               Merchant Analytics Dashboard
//             </h1>

//             <p>
//               Track customer loyalty, feedback & restaurant performance
//             </p>

//           </div>

//           <div className="header-icon">
//             📊
//           </div>

//         </div>

//         {/* CHARTS */}

//         <div className="chart-grid">

//           {/* TOTAL SCANS */}

//           <div className="chart-card">

//             <h2>
//               Weekly Total Scans
//             </h2>

//             <div className="bars">

//               <div className="bar-item">
//                 <div
//                   className="bar"
//                   style={{ height: "60%" }}
//                 ></div>
//                 <div className="bar-label">
//                   Mon
//                 </div>
//               </div>

//               <div className="bar-item">
//                 <div
//                   className="bar"
//                   style={{ height: "80%" }}
//                 ></div>
//                 <div className="bar-label">
//                   Tue
//                 </div>
//               </div>

//               <div className="bar-item">
//                 <div
//                   className="bar"
//                   style={{ height: "55%" }}
//                 ></div>
//                 <div className="bar-label">
//                   Wed
//                 </div>
//               </div>

//               <div className="bar-item">
//                 <div
//                   className="bar"
//                   style={{ height: "95%" }}
//                 ></div>
//                 <div className="bar-label">
//                   Thu
//                 </div>
//               </div>

//               <div className="bar-item">
//                 <div
//                   className="bar"
//                   style={{ height: "70%" }}
//                 ></div>
//                 <div className="bar-label">
//                   Fri
//                 </div>
//               </div>

//             </div>

//           </div>

//           {/* RETURNING CUSTOMERS */}

//           <div className="chart-card">

//             <h2>
//               Returning Customers Ratio
//             </h2>

//             <div className="pie-wrapper">

//               <div className="pie"></div>

//               <div className="pie-text">
//                 65%
//               </div>

//               <div className="pie-info">
//                 Returning vs New Customers
//               </div>

//             </div>

//           </div>

//         </div>

//         {/* CRITICAL FEEDBACK */}

//         <div className="panel">

//           <h2>
//             Critical Feedback Escalation
//           </h2>

//           <p>
//             Customers who submitted 1-3 star ratings and require attention.
//           </p>

//           <div className="feedback-list">

//             {criticalFeedbacks.map((item) => (

//               <div
//                 key={item.id}
//                 className="feedback-card"
//               >

//                 <div className="feedback-top">

//                   <div className="feedback-phone">
//                     {item.phone}
//                   </div>

//                   <div className="feedback-rating">
//                     {item.rating}
//                   </div>

//                 </div>

//                 <p>
//                   {item.complaint}
//                 </p>

//               </div>

//             ))}

//           </div>

//         </div>

//         {/* CUSTOMER AUDIT */}

//         <div className="panel">

//           <h2>
//             Full Customer Audit Trail
//           </h2>

//           <p>
//             Complete customer database with visit history and reward usage.
//           </p>

//           <div className="table-container">

//             <table>

//               <thead>

//                 <tr>

//                   <th>Customer Phone</th>
//                   <th>Total Visits</th>
//                   <th>Last Visit</th>
//                   <th>Coupon Status</th>
//                   <th>Loyalty</th>

//                 </tr>

//               </thead>

//               <tbody>

//                 {customers.map((item) => (

//                   <tr key={item.id}>

//                     <td>
//                       {item.phone}
//                     </td>

//                     <td>
//                       {item.visits}
//                     </td>

//                     <td>
//                       {item.lastVisit}
//                     </td>

//                     <td>
//                       {item.coupons}
//                     </td>

//                     <td>

//                       <span className="visit-badge">
//                         Loyal Customer
//                       </span>

//                     </td>

//                   </tr>

//                 ))}

//               </tbody>

//             </table>

//           </div>

//         </div>

//       </div>
//     </>
//   );
// }



// import React, { useState, useEffect } from "react";

// export default function MerchantFeedbackLog() {
//   // Hardcoded Merchant ID as per your API structures
//   const MERCHANT_ID = "CMV9A117EAC";

//   // API Integrated States
//   const [analytics, setAnalytics] = useState({
//     total_customers: 0,
//     returning_customers: 0,
//     new_customers: 0,
//     returning_ratio: 0,
//     redeemed_rewards: 0,
//     total_visits: "0"
//   });
//   const [criticalFeedbacks, setCriticalFeedbacks] = useState([]);
//   const [customers, setCustomers] = useState([]);

//   // Search States
//   const [searchMobile, setSearchMobile] = useState("");
//   const [isSearching, setIsSearching] = useState(false);

//   // Loading & Error States
//   const [loading, setLoading] = useState(true);

//   // Helper to clean response prefix strings safely
//   const cleanAndParseJson = (text) => {
//     const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//     return JSON.parse(cleanString);
//   };

//   // 1. Fetch Dashboard Analytics
//   const fetchAnalytics = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/merchant_dashboard_analytics.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         setAnalytics(data);
//       }
//     } catch (error) {
//       console.error("Error fetching analytics:", error);
//     }
//   };

//   // 2. Fetch Critical Feedbacks / Alerts
//   const fetchFeedbacks = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688"); // Fallback customer token matching your signature
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/merchant_feedback_alerts.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         setCriticalFeedbacks(data.reviews || []);
//       }
//     } catch (error) {
//       console.error("Error fetching feedbacks:", error);
//     }
//   };

//   // 3. Fetch Full Customer Audit Trail
//   const fetchCustomerAuditTrail = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688");
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/customer_audit_trail.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         setCustomers(data.customers || []);
//       }
//     } catch (error) {
//       console.error("Error fetching audit trail:", error);
//     }
//   };

//   // 4. Handle Customer Live Search API
//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!searchMobile.trim()) {
//       setIsSearching(false);
//       fetchCustomerAuditTrail(); // Reset to original list if blank
//       return;
//     } 

//     setIsSearching(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       formdata.append("mobile", searchMobile.trim());

//       const response = await fetch(`https://countmyvisit.com/Apis/customer_search.php?mobile=${searchMobile.trim()}&merchant_id=${MERCHANT_ID}`, {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success && data.customer) {
//         // Map search single object to match standard table rows array schema
//         const singleCustomer = {
//           customer_id: data.customer.customer_id || "N/A",
//           name: data.customer.name,
//           mobile: data.customer.mobile,
//           total_visits: data.customer.total_visits,
//           used_rewards: data.customer.used_rewards,
//           unused_rewards: data.customer.unused_rewards,
//           loyalty_status: data.customer.loyalty_status
//         };
//         setCustomers([singleCustomer]);
//       } else {
//         setCustomers([]);
//       }
//     } catch (error) {
//       console.error("Search dynamic error:", error);
//       setCustomers([]);
//     }
//   };

//   // Load baseline arrays on mount
//   useEffect(() => {
//     const loadDashboardData = async () => {
//       setLoading(true);
//       await Promise.all([fetchAnalytics(), fetchFeedbacks(), fetchCustomerAuditTrail()]);
//       setLoading(false);
//     };
//     loadDashboardData();
//   }, []);

//   if (loading) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "18px", fontWeight: "600", color: "#ff8c42" }}>
//         Loading Merchant Dashboard Ecosystem...
//       </div>
//     );
//   }

//   return (
//     <>
//       <style>{`
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//           font-family: 'Poppins', sans-serif;
//         }

//         body {
//           background: #f5f7fb;
//         }

//         .analytics-page {
//           min-height: 100vh;
//           padding: 35px;
//           background: linear-gradient(135deg, #fff7ed, #fff, #eef4ff);
//         }

//         /* HEADER */
//         .top-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           flex-wrap: wrap;
//           gap: 20px;
//           margin-bottom: 35px;
//         }

//         .top-header h1 {
//           font-size: 42px;
//           font-weight: 800;
//           color: #111827;
//           margin-bottom: 8px;
//         }

//         .top-header p {
//           color: #6b7280;
//           font-size: 16px;
//         }

//         .header-icon {
//           width: 75px;
//           height: 75px;
//           border-radius: 24px;
//           background: linear-gradient(135deg, #ff8c42, #ff5e62);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 34px;
//           color: white;
//           box-shadow: 0 15px 30px rgba(255, 94, 98, 0.3);
//         }

//         /* SEARCH BAR SYSTEM */
//         .search-container {
//           background: white;
//           padding: 20px;
//           border-radius: 24px;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.03);
//           margin-bottom: 35px;
//           border: 1px solid #f1f5f9;
//         }

//         .search-form {
//           display: flex;
//           gap: 15px;
//         }

//         .search-input {
//           flex: 1;
//           padding: 16px 24px;
//           border: 2px solid #e2e8f0;
//           border-radius: 16px;
//           font-size: 16px;
//           outline: none;
//           transition: 0.2s;
//         }

//         .search-input:focus {
//           border-color: #ff8c42;
//         }

//         .search-btn {
//           padding: 16px 32px;
//           background: linear-gradient(135deg, #1e293b, #0f172a);
//           color: white;
//           border: none;
//           border-radius: 16px;
//           font-weight: 600;
//           cursor: pointer;
//           transition: 0.2s;
//         }

//         .search-btn:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 5px 15px rgba(0,0,0,0.1);
//         }

//         .reset-btn {
//           padding: 16px 24px;
//           background: #f1f5f9;
//           color: #475569;
//           border: none;
//           border-radius: 16px;
//           font-weight: 600;
//           cursor: pointer;
//         }

//         /* CHART GRID */
//         .chart-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//           gap: 25px;
//           margin-bottom: 35px;
//         }

//         .chart-card {
//           background: white;
//           border-radius: 32px;
//           padding: 30px;
//           box-shadow: 0 15px 40px rgba(0, 0, 0, 0.05);
//           position: relative;
//           overflow: hidden;
//         }

//         .chart-card::before {
//           content: '';
//           position: absolute;
//           width: 180px;
//           height: 180px;
//           background: rgba(255, 140, 66, 0.08);
//           border-radius: 50%;
//           top: -60px;
//           right: -60px;
//         }

//         .chart-card h2 {
//           font-size: 22px;
//           margin-bottom: 25px;
//           color: #111827;
//           position: relative;
//           z-index: 2;
//         }

//         /* BAR CHART */
//         .bars {
//           display: flex;
//           align-items: flex-end;
//           gap: 18px;
//           height: 220px;
//           position: relative;
//           z-index: 2;
//         }

//         .bar-item {
//           flex: 1;
//           text-align: center;
//         }

//         .bar {
//           width: 100%;
//           border-radius: 18px 18px 8px 8px;
//           background: linear-gradient(180deg, #ff8c42, #ff5e62);
//           margin-bottom: 12px;
//           transition: 0.3s;
//         }

//         .bar-label {
//           font-size: 14px;
//           color: #6b7280;
//           font-weight: 600;
//         }

//         /* PIE & RATIO TEXTS */
//         .pie-wrapper {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           flex-direction: column;
//           position: relative;
//           z-index: 2;
//         }

//         .pie {
//           width: 190px;
//           height: 190px;
//           border-radius: 50%;
//           margin-bottom: 20px;
//           position: relative;
//         }

//         .pie::after {
//           content: '';
//           position: absolute;
//           width: 110px;
//           height: 110px;
//           background: white;
//           border-radius: 50%;
//           top: 40px;
//           left: 40px;
//         }

//         .pie-text {
//           position: absolute;
//           font-size: 28px;
//           font-weight: 800;
//           color: #111827;
//         }

//         .pie-info {
//           color: #6b7280;
//           font-size: 15px;
//           text-align: center;
//           line-height: 1.7;
//         }

//         /* PANELS */
//         .panel {
//           background: white;
//           border-radius: 35px;
//           padding: 35px;
//           margin-bottom: 35px;
//           box-shadow: 0 15px 40px rgba(0, 0, 0, 0.05);
//         }

//         .panel h2 {
//           font-size: 32px;
//           margin-bottom: 12px;
//           color: #111827;
//         }

//         .panel p {
//           color: #6b7280;
//           margin-bottom: 30px;
//           line-height: 1.8;
//         }

//         /* FEEDBACK */
//         .feedback-list {
//           display: flex;
//           flex-direction: column;
//           gap: 22px;
//         }

//         .feedback-card {
//           background: #fff5f5;
//           border-left: 6px solid #ef4444;
//           border-radius: 24px;
//           padding: 28px;
//           transition: 0.3s;
//         }

//         .feedback-top {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           flex-wrap: wrap;
//           gap: 15px;
//           margin-bottom: 15px;
//         }

//         .feedback-phone {
//           font-size: 18px;
//           font-weight: 700;
//           color: #111827;
//         }

//         .feedback-rating {
//           background: #fee2e2;
//           color: #dc2626;
//           padding: 10px 16px;
//           border-radius: 30px;
//           font-size: 13px;
//           font-weight: 700;
//         }

//         /* TABLE */
//         .table-container {
//           overflow: auto;
//         }

//         table {
//           width: 100%;
//           border-collapse: collapse;
//           min-width: 850px;
//         }

//         th {
//           background: #fff7ed;
//           padding: 18px;
//           text-align: left;
//           color: #111827;
//           font-size: 15px;
//         }

//         td {
//           padding: 20px 18px;
//           border-bottom: 1px solid #eee;
//           color: #4b5563;
//           font-size: 15px;
//         }

//         tr:hover {
//           background: #fafafa;
//         }

//         .visit-badge {
//           display: inline-block;
//           padding: 10px 18px;
//           border-radius: 30px;
//           background: #ecfdf5;
//           color: #059669;
//           font-size: 13px;
//           font-weight: 700;
//         }

//         .status-badge {
//           padding: 6px 14px;
//           border-radius: 20px;
//           font-size: 13px;
//           font-weight: 600;
//           background: #eff6ff;
//           color: #2563eb;
//         }

//         @media(max-width: 768px) {
//           .analytics-page { padding: 20px; }
//           .top-header h1 { font-size: 30px; }
//           .panel { padding: 25px; }
//           .panel h2 { font-size: 26px; }
//           .search-form { flex-direction: column; }
//         }
//       `}</style>

//       <div className="analytics-page">

//         {/* HEADER */}
//         <div className="top-header">
//           <div>
//             <h1>Merchant Analytics Dashboard</h1>
//             <p>Live metrics from Merchant ID: {MERCHANT_ID}</p>
//           </div>
//           <div className="header-icon">📊</div>
//         </div>

//         {/* LIVE SEARCH COMPONENT */}
//         <div className="search-container">
//           <form onSubmit={handleSearch} className="search-form">
//             <input 
//               type="text" 
//               placeholder="Search Customer by Mobile Number..." 
//               className="search-input"
//               value={searchMobile}
//               onChange={(e) => setSearchMobile(e.target.value)}
//             />
//             <button type="submit" className="search-btn">🔍 Search Profile</button>
//             {isSearching && (
//               <button 
//                 type="button" 
//                 className="reset-btn" 
//                 onClick={() => {
//                   setSearchMobile("");
//                   setIsSearching(false);
//                   fetchCustomerAuditTrail();
//                 }}
//               >
//                 Clear
//               </button>
//             )}
//           </form>
//         </div>

//         {/* METRICS / CHARTS SYSTEM */}
//         <div className="chart-grid">

//           {/* TOTAL SCANS & VOLUMES */}
//           <div className="chart-card">
//             <h2>Overall Engagement Metrics</h2>
//             <div className="bars">
//               <div className="bar-item">
//                 <div className="bar" style={{ height: "45%" }}></div>
//                 <div className="bar-label">Cust: {analytics.total_customers}</div>
//               </div>
//               <div className="bar-item">
//                 <div className="bar" style={{ height: "75%" }}></div>
//                 <div className="bar-label">Visits: {analytics.total_visits}</div>
//               </div>
//               <div className="bar-item">
//                 <div className="bar" style={{ height: "60%" }}></div>
//                 <div className="bar-label">Redeemed: {analytics.redeemed_rewards}</div>
//               </div>
//             </div>
//           </div>

//           {/* RETURNING CUSTOMERS PIE GENERATOR */}
//           <div className="chart-card">
//             <h2>Returning Customers Ratio</h2>
//             <div className="pie-wrapper">
//               <div 
//                 className="pie" 
//                 style={{ 
//                   background: `conic-gradient(#ff8c42 0% ${analytics.returning_ratio}%, #ffd6b8 ${analytics.returning_ratio}% 100%)` 
//                 }}
//               ></div>
//               <div className="pie-text">{analytics.returning_ratio}%</div>
//               <div className="pie-info">
//                 New: {analytics.new_customers} | Returning: {analytics.returning_customers}
//               </div>
//             </div>
//           </div>

//         </div>

//         {/* CRITICAL FEEDBACK LOGS */}
//         <div className="panel">
//           <h2>Critical Feedback Escalation</h2>
//           <p>Real-time customer ratings and remarks that require operations review.</p>

//           <div className="feedback-list">
//             {criticalFeedbacks.length === 0 ? (
//               <p style={{ fontStyle: "italic", color: "#9ca3af" }}>No critical feedback alerts currently listed.</p>
//             ) : (
//               criticalFeedbacks.map((item, index) => (
//                 <div key={index} className="feedback-card">
//                   <div className="feedback-top">
//                     <div className="feedback-phone">👤 ID: {item.customer_id || "Anonymous"}</div>
//                     <div className="feedback-rating">⭐ Review Attached</div>
//                   </div>
//                   <p>{item.feedback_text || "No custom comment text shared."}</p>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>

//         {/* CUSTOMER AUDIT SYSTEM */}
//         <div className="panel">
//           <h2>{isSearching ? "Searched Customer Profile" : "Full Customer Audit Trail"}</h2>
//           <p>Complete structural breakdown of visitors, dynamic rewards scopes, and lifecycle tracking status.</p>

//           <div className="table-container">
//             <table>
//               <thead>
//                 <tr>
//                   <th>Customer Name</th>
//                   <th>Mobile Number</th>
//                   <th>Total Visits Done</th>
//                   <th>Unused Coupons</th>
//                   <th>Used Coupons</th>
//                   <th>Loyalty Milestone</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {customers.length === 0 ? (
//                   <tr>
//                     <td colSpan="6" style={{ textAlign: "center", padding: "30px", color: "#9ca3af" }}>
//                       No customers found matching the search criteria.
//                     </td>
//                   </tr>
//                 ) : (
//                   customers.map((item, idx) => (
//                     <tr key={idx}>
//                       <td style={{ fontWeight: "600", color: "#111827" }}>{item.name || "User"}</td>
//                       <td>{item.mobile}</td>
//                       <td>
//                         <span className="visit-badge">{item.total_visits} Visits</span>
//                       </td>
//                       <td style={{ color: "#d97706", fontWeight: "600" }}>{item.unused_rewards}</td>
//                       <td style={{ color: "#059669", fontWeight: "600" }}>{item.used_rewards}</td>
//                       <td>
//                         <span className="status-badge">{item.loyalty_status || "New Customer"}</span>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>

//       </div>
//     </>
//   );
// }




// import React, { useState, useEffect } from "react";

// export default function MerchantFeedbackLog() {
//   // Extract Dynamic Merchant ID from LocalStorage session string safely
//   const getDynamicMerchantId = () => {
//     try {
//       const savedDataString = localStorage.getItem("userData");
//       if (savedDataString) {
//         // Handle potential custom prefixes safely
//         const cleanDataStr = savedDataString.replace("DATABASE CONNECTED", "").trim();
//         const parsed = JSON.parse(cleanDataStr);
//         if (parsed?.merchant?.user_id) {
//           return parsed.merchant.user_id;
//         }
//       }
//     } catch (e) {
//       console.error("Error reading initial userData from localStorage:", e);
//     }
//     return "CMV9A117EAC"; // Global fallback token if session is cleared
//   };

//   const MERCHANT_ID = getDynamicMerchantId();

//   // API Caching Layer states initialized from storage fallback hooks
//   const [analytics, setAnalytics] = useState(() => {
//     const saved = localStorage.getItem(`analytics_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : {
//       total_customers: 0,
//       returning_customers: 0,
//       new_customers: 0,
//       returning_ratio: 0,
//       redeemed_rewards: 0,
//       total_visits: "0"
//     };
//   });

//   const [criticalFeedbacks, setCriticalFeedbacks] = useState(() => {
//     const saved = localStorage.getItem(`feedbacks_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : [];
//   });

//   const [customers, setCustomers] = useState(() => {
//     const saved = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : [];
//   });

//   // Search state contexts
//   const [searchMobile, setSearchMobile] = useState("");
//   const [isSearching, setIsSearching] = useState(false);

//   // Loading conditional flags (Cold setup optimizer)
//   const [loading, setLoading] = useState(() => {
//     const cacheExists = localStorage.getItem(`analytics_${MERCHANT_ID}`);
//     return !cacheExists;
//   });

//   // Safe cleaner logic for API stream headers
//   const cleanAndParseJson = (text) => {
//     const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//     return JSON.parse(cleanString);
//   };

//   // 1. Fetch Dashboard Analytics Engine
//   const fetchAnalytics = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/merchant_dashboard_analytics.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         setAnalytics(data);
//         localStorage.setItem(`analytics_${MERCHANT_ID}`, JSON.stringify(data));
//       }
//     } catch (error) {
//       console.error("Error fetching analytics metrics:", error);
//     }
//   };

//   // 2. Fetch Critical Feedbacks / Escalation Alert Matrices
//   const fetchFeedbacks = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688"); 
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/merchant_feedback_alerts.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         const reviewsData = data.reviews || [];
//         setCriticalFeedbacks(reviewsData);
//         localStorage.setItem(`feedbacks_${MERCHANT_ID}`, JSON.stringify(reviewsData));
//       }
//     } catch (error) {
//       console.error("Error fetching feedbacks logs:", error);
//     }
//   };

//   // 3. Fetch Full Customer Audit Ecosystem Trail
//   const fetchCustomerAuditTrail = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688");
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/customer_audit_trail.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         const customersData = data.customers || [];
//         setCustomers(customersData);
//         if (!isSearching) {
//           localStorage.setItem(`audit_trail_${MERCHANT_ID}`, JSON.stringify(customersData));
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching audit trail pools:", error);
//     }
//   };

//   // 4. Handle Live Search Filters
//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!searchMobile.trim()) {
//       setIsSearching(false);
//       const savedTrail = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//       if (savedTrail) {
//         setCustomers(JSON.parse(savedTrail));
//       } else {
//         fetchCustomerAuditTrail();
//       }
//       return;
//     } 

//     setIsSearching(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       formdata.append("mobile", searchMobile.trim());

//       const response = await fetch(`https://countmyvisit.com/Apis/customer_search.php?mobile=${searchMobile.trim()}&merchant_id=${MERCHANT_ID}`, {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success && data.customer) {
//         const singleCustomer = {
//           customer_id: data.customer.customer_id || "N/A",
//           name: data.customer.name,
//           mobile: data.customer.mobile,
//           total_visits: data.customer.total_visits,
//           used_rewards: data.customer.used_rewards,
//           unused_rewards: data.customer.unused_rewards,
//           loyalty_status: data.customer.loyalty_status
//         };
//         setCustomers([singleCustomer]);
//       } else {
//         setCustomers([]);
//       }
//     } catch (error) {
//       console.error("Search pipeline fault:", error);
//       setCustomers([]);
//     }
//   };

//   useEffect(() => {
//     const triggerDataHydration = async () => {
//       await Promise.all([fetchAnalytics(), fetchFeedbacks(), fetchCustomerAuditTrail()]);
//       setLoading(false);
//     };
//     triggerDataHydration();
//   }, [MERCHANT_ID]);

//   if (loading) {
//     return (
//       <div className="loader-container">
//         <style>{`
//           .loader-container {
//             display: flex;
//             flex-direction: column;
//             justify-content: center;
//             align-items: center;
//             height: 100vh;
//             background: #0f172a;
//             color: #ffffff;
//             font-family: 'Inter', sans-serif;
//           }
//           .spinner {
//             width: 50px;
//             height: 50px;
//             border: 4px solid rgba(255,255,255,0.1);
//             border-left-color: #3b82f6;
//             border-radius: 50%;
//             animation: spin 1s linear infinite;
//             margin-bottom: 20px;
//           }
//           .loader-text {
//             font-weight: 500;
//             letter-spacing: 0.5px;
//             color: #94a3b8;
//           }
//           @keyframes spin { to { transform: rotate(360deg); } }
//         `}</style>
//         <div className="spinner"></div>
//         <p className="loader-text">Assembling Live System Analytics Core...</p>
//       </div>
//     );
//   }

//   return (
//     <>
//      <style>{`
//   @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

//   * {
//     margin: 0;
//     padding: 0;
//     box-sizing: border-box;
//     font-family: 'Inter', sans-serif;
//   }

//   body {
//     background-color: #0b0f19;
//     color: #e2e8f0;
//     -webkit-font-smoothing: antialiased;
//   }

//   .dashboard-wrapper {
//     min-height: 100vh;
//     background: radial-gradient(circle at 50% -20%, #1e2640 0%, #0b0f19 70%);
//     padding: 40px;
//   }

//   .container {
//     max-width: 1400px;
//     margin: 0 auto;
//   }

//   /* PREMIUM HEADER */
//   .header-section {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     margin-bottom: 40px;
//     border-bottom: 1px solid rgba(255, 255, 255, 0.06);
//     padding-bottom: 28px;
//   }

//   .header-title h1 {
//     font-size: 34px;
//     font-weight: 800;
//     letter-spacing: -0.75px;
//     background: linear-gradient(135deg, #ffffff 30%, #94a3b8 100%);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//   }

//   .header-title p {
//     color: #64748b;
//     font-size: 14px;
//     margin-top: 6px;
//     font-weight: 400;
//   }

//   .merchant-badge {
//     background: rgba(99, 102, 241, 0.08);
//     border: 1px solid rgba(99, 102, 241, 0.25);
//     color: #818cf8;
//     padding: 7px 16px;
//     border-radius: 10px;
//     font-size: 13px;
//     font-weight: 600;
//     letter-spacing: 0.5px;
//     box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
//   }

//   /* METRIC CARDS ARCHITECTURE */
//   .metrics-grid {
//     display: grid;
//     grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
//     gap: 24px;
//     margin-bottom: 40px;
//   }

//   .stat-card {
//     background: #111827;
//     border: 1px solid rgba(255, 255, 255, 0.05);
//     border-radius: 16px;
//     padding: 26px;
//     position: relative;
//     transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
//     box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
//   }

//   .stat-card:hover {
//     transform: translateY(-4px);
//     border-color: rgba(255, 255, 255, 0.12);
//     box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);
//   }

//   .card-icon-wrapper {
//     width: 44px;
//     height: 44px;
//     border-radius: 12px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     margin-bottom: 20px;
//   }

//   /* Luxury Accent Color Accents */
//   .blue-icon { background: rgba(56, 189, 248, 0.08); color: #38bdf8; border: 1px solid rgba(56, 189, 248, 0.15); }
//   .orange-icon { background: rgba(251, 146, 60, 0.08); color: #fb923c; border: 1px solid rgba(251, 146, 60, 0.15); }
//   .green-icon { background: rgba(52, 211, 153, 0.08); color: #34d399; border: 1px solid rgba(52, 211, 153, 0.15); }
//   .purple-icon { background: rgba(167, 139, 250, 0.08); color: #a78bfa; border: 1px solid rgba(167, 139, 250, 0.15); }

//   .stat-label {
//     font-size: 13px;
//     color: #64748b;
//     font-weight: 500;
//     text-transform: uppercase;
//     letter-spacing: 0.5px;
//   }

//   .stat-value {
//     font-size: 34px;
//     font-weight: 700;
//     color: #ffffff;
//     margin-top: 6px;
//     letter-spacing: -0.5px;
//   }

//   .progress-container {
//     margin-top: 20px;
//     background: #1f2937;
//     height: 5px;
//     border-radius: 99px;
//     overflow: hidden;
//   }

//   .progress-fill {
//     height: 100%;
//     border-radius: 99px;
//     transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
//   }

//   .fill-full { width: 100%; background: linear-gradient(90deg, #0284c7, #38bdf8); }
//   .fill-high { width: 70%; background: linear-gradient(90deg, #ea580c, #fb923c); }
//   .fill-mid { width: 45%; background: linear-gradient(90deg, #059669, #34d399); }
//   .fill-dynamic { background: linear-gradient(90deg, #7c3aed, #a78bfa); width: ${analytics.returning_ratio}%; }

//   .card-footer-info {
//     display: flex;
//     justify-content: space-between;
//     font-size: 12px;
//     color: #4b5563;
//     margin-top: 10px;
//     font-weight: 500;
//   }

//   /* INPUT QUERY MODULE */
//   .search-wrapper {
//     background: #111827;
//     border: 1px solid rgba(255, 255, 255, 0.05);
//     padding: 24px;
//     border-radius: 16px;
//     margin-bottom: 40px;
//     box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
//   }

//   .search-inner {
//     display: flex;
//     gap: 16px;
//   }

//   .input-group {
//     position: relative;
//     flex: 1;
//   }

//   .search-icon-inline {
//     position: absolute;
//     left: 18px;
//     top: 50%;
//     transform: translateY(-50%);
//     color: #4b5563;
//   }

//   .modern-input {
//     width: 100%;
//     background: #0b0f19;
//     border: 1px solid #1f2937;
//     border-radius: 12px;
//     padding: 16px 16px 16px 52px;
//     color: #ffffff;
//     font-size: 15px;
//     outline: none;
//     transition: all 0.2s ease;
//   }

//   .modern-input:focus {
//     border-color: #6366f1;
//     box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
//     background: #0f1524;
//   }

//   .btn-primary {
//     background: #4f46e5;
//     color: #ffffff;
//     border: none;
//     padding: 0 28px;
//     border-radius: 12px;
//     font-weight: 600;
//     font-size: 15px;
//     cursor: pointer;
//     display: flex;
//     align-items: center;
//     gap: 10px;
//     transition: all 0.2s ease;
//     box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25);
//   }

//   .btn-primary:hover {
//     background: #4338ca;
//     transform: translateY(-1px);
//     box-shadow: 0 6px 16px rgba(79, 70, 229, 0.35);
//   }

//   .btn-secondary {
//     background: #1f2937;
//     color: #9ca3af;
//     border: 1px solid rgba(255, 255, 255, 0.05);
//     padding: 0 22px;
//     border-radius: 12px;
//     font-weight: 500;
//     font-size: 15px;
//     cursor: pointer;
//     transition: all 0.2s ease;
//   }

//   .btn-secondary:hover {
//     background: #374151;
//     color: #ffffff;
//   }

//   /* SYSTEM PANELS LAYOUT */
//   .panel-box {
//     background: #111827;
//     border: 1px solid rgba(255, 255, 255, 0.05);
//     border-radius: 18px;
//     padding: 32px;
//     margin-bottom: 40px;
//     box-shadow: 0 4px 25px rgba(0, 0, 0, 0.15);
//   }

//   .panel-header-title {
//     display: flex;
//     align-items: center;
//     gap: 14px;
//     margin-bottom: 8px;
//   }

//   .panel-box h2 {
//     font-size: 22px;
//     font-weight: 700;
//     color: #ffffff;
//     letter-spacing: -0.3px;
//   }

//   .panel-desc {
//     color: #4b5563;
//     font-size: 14px;
//     margin-bottom: 28px;
//     font-weight: 500;
//   }

//   /* SYSTEM INCIDENT TIMELINES */
//   .alerts-stack {
//     display: flex;
//     flex-direction: column;
//     gap: 16px;
//   }

//   .alert-row {
//     background: rgba(239, 68, 68, 0.02);
//     border: 1px solid rgba(239, 68, 68, 0.15);
//     border-radius: 14px;
//     padding: 22px;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     gap: 20px;
//   }

//   .alert-meta {
//     display: flex;
//     align-items: center;
//     gap: 12px;
//     color: #ef4444;
//     font-weight: 600;
//     font-size: 14px;
//     margin-bottom: 8px;
//   }

//   .alert-text {
//     color: #9ca3af;
//     font-size: 14.5px;
//     line-height: 1.6;
//   }

//   .alert-badge-danger {
//     background: rgba(239, 68, 68, 0.1);
//     color: #f87171;
//     border: 1px solid rgba(239, 68, 68, 0.2);
//     padding: 6px 14px;
//     border-radius: 8px;
//     font-size: 11px;
//     font-weight: 700;
//     text-transform: uppercase;
//     letter-spacing: 0.5px;
//   }

//   /* CORE DATA SHEET MATRIX */
//   .responsive-table-holder {
//     overflow-x: auto;
//     border-radius: 14px;
//     border: 1px solid #1f2937;
//     background: #0b0f19;
//   }

//   .modern-table {
//     width: 100%;
//     border-collapse: collapse;
//     text-align: left;
//     font-size: 14px;
//     min-width: 900px;
//   }

//   .modern-table th {
//     background: #111827;
//     padding: 18px 24px;
//     color: #64748b;
//     font-weight: 600;
//     border-bottom: 1px solid #1f2937;
//     text-transform: uppercase;
//     font-size: 11px;
//     letter-spacing: 0.75px;
//   }

//   .modern-table td {
//     padding: 20px 24px;
//     color: #9ca3af;
//     border-bottom: 1px solid #1f2937;
//   }

//   .td-center-log {
//     text-align: center;
//     padding: 48px;
//     color: #4b5563;
//     font-weight: 500;
//   }

//   .td-profile-item {
//     font-weight: 600;
//     color: #ffffff;
//   }

//   .td-network-mono {
//     color: #64748b;
//     font-family: monospace;
//     font-size: 13.5px;
//   }

//   .vouchers-unused-value { color: #fb923c; font-weight: 600; }
//   .vouchers-used-value { color: #34d399; font-weight: 600; }

//   .modern-table tr:last-child td { border-bottom: none; }
//   .modern-table tr:hover td { background: rgba(255, 255, 255, 0.01); }

//   /* COMPONENT STATUS BADGES */
//   .pill-badge {
//     display: inline-flex;
//     align-items: center;
//     padding: 5px 14px;
//     border-radius: 8px;
//     font-size: 12.5px;
//     font-weight: 600;
//   }

//   .pill-green { background: rgba(52, 211, 153, 0.06); color: #34d399; border: 1px solid rgba(52, 211, 153, 0.15); }
//   .pill-blue { background: rgba(56, 189, 248, 0.06); color: #38bdf8; border: 1px solid rgba(56, 189, 248, 0.15); }
//   .pill-orange { background: rgba(251, 146, 60, 0.06); color: #fb923c; border: 1px solid rgba(251, 146, 60, 0.15); }

//   .empty-state {
//     text-align: center;
//     padding: 48px 24px;
//     color: #4b5563;
//     font-size: 15px;
//     font-weight: 500;
//   }

//   @media (max-width: 768px) {
//     .dashboard-wrapper { padding: 20px; }
//     .header-section { flex-direction: column; align-items: flex-start; gap: 20px; }
//     .search-inner { flex-direction: column; }
//     .btn-primary { justify-content: center; padding: 16px; }
//   }
// `}</style>

//       <div className="dashboard-wrapper">
//         <div className="container">

//           {/* HEADER SECTOR */}
//           <header className="header-section">
//             <div className="header-title">
//               <h1>Merchant Control Center</h1>
//               <p>Dynamic engine context mapping validated sessions data channels</p>
//             </div>
//             <div className="merchant-badge">
//               Active ID: {MERCHANT_ID}
//             </div>
//           </header>

//           {/* PERFORMANCE CARDS ENGINE */}
//           <section className="metrics-grid">

//             <div className="stat-card">
//               <div className="card-icon-wrapper blue-icon">
//                 <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
//               </div>
//               <span className="stat-label">Total Registered Customers</span>
//               <div className="stat-value">{analytics.total_customers}</div>
//               <div className="progress-container">
//                 <div className="progress-fill fill-full"></div>
//               </div>
//               <div className="card-footer-info">
//                 <span>Baseline users</span>
//                 <span>Active</span>
//               </div>
//             </div>

//             <div className="stat-card">
//               <div className="card-icon-wrapper orange-icon">
//                 <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 12h-4l-3 9L9 3l-3 9H2"></path></svg>
//               </div>
//               <span className="stat-label">Overall Footfall Visits</span>
//               <div className="stat-value">{analytics.total_visits}</div>
//               <div className="progress-container">
//                 <div className="progress-fill fill-high"></div>
//               </div>
//               <div className="card-footer-info">
//                 <span>Total log counters</span>
//                 <span>Active Tracking</span>
//               </div>
//             </div>

//             <div className="stat-card">
//               <div className="card-icon-wrapper green-icon">
//                 <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
//               </div>
//               <span className="stat-label">Redeemed Voucher Perks</span>
//               <div className="stat-value">{analytics.redeemed_rewards}</div>
//               <div className="progress-container">
//                 <div className="progress-fill fill-mid"></div>
//               </div>
//               <div className="card-footer-info">
//                 <span>Claimed milestones</span>
//                 <span>Live Status</span>
//               </div>
//             </div>

//             <div className="stat-card">
//               <div className="card-icon-wrapper purple-icon">
//                 <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"></path></svg>
//               </div>
//               <span className="stat-label">Retention Index Score</span>
//               <div className="stat-value">{analytics.returning_ratio}%</div>
//               <div className="progress-container">
//                 <div className="progress-fill fill-dynamic"></div>
//               </div>
//               <div className="card-footer-info">
//                 <span>New: {analytics.new_customers}</span>
//                 <span>Returning: {analytics.returning_customers}</span>
//               </div>
//             </div>

//           </section>

//           {/* DYNAMIC FILTERS LAYER */}
//           <div className="search-wrapper">
//             <form onSubmit={handleSearch} className="search-inner">
//               <div className="input-group">
//                 <div className="search-icon-inline">
//                   <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
//                 </div>
//                 <input 
//                   type="text" 
//                   className="modern-input"
//                   placeholder="Enter customer's exact mobile number for complete audit..."
//                   value={searchMobile}
//                   onChange={(e) => setSearchMobile(e.target.value)}
//                 />
//               </div>
//               <button type="submit" className="btn-primary">
//                 Run Profile Query
//               </button>
//               {isSearching && (
//                 <button 
//                   type="button" 
//                   className="btn-secondary" 
//                   onClick={() => {
//                     setSearchMobile("");
//                     setIsSearching(false);
//                     const savedTrail = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//                     if (savedTrail) {
//                       setCustomers(JSON.parse(savedTrail));
//                     } else {
//                       fetchCustomerAuditTrail();
//                     }
//                   }}
//                 >
//                   Reset
//                 </button>
//               )}
//             </form>
//           </div>

//           {/* ESCALATIONS DECK */}
//           <div className="panel-box">
//             <div className="panel-header-title">
//               <svg width="22" height="22" fill="none" stroke="#ef4444" strokeWidth="2" viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
//               <h2>Critical Feedback &amp; Escalation Tracker</h2>
//             </div>
//             <p className="panel-desc">Real-time alerts identifying unsatisfactory operational touchpoints needing intervention.</p>

//             <div className="alerts-stack">
//               {criticalFeedbacks.length === 0 ? (
//                 <div className="empty-state">
//                   🎉 Fantastic! No critical incident triggers or negative loops flagged currently.
//                 </div>
//               ) : (
//                 criticalFeedbacks.map((item, index) => (
//                   <div key={index} className="alert-row">
//                     <div>
//                       <div className="alert-meta">
//                         <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
//                         <span>Customer Reference ID: {item.customer_id || "Anonymous Client"}</span>
//                       </div>
//                       <p className="alert-text">"{item.feedback_text || "No qualitative commentary statement uploaded."}"</p>
//                     </div>
//                     <span className="alert-badge-danger">Requires Action</span>
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>

//           {/* AUDIT TIMELINE SHEET */}
//           <div className="panel-box">
//             <div className="panel-header-title">
//               <svg width="22" height="22" fill="none" stroke="#3b82f6" strokeWidth="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
//               <h2>{isSearching ? "Target Query Results" : "Comprehensive Customer Audit Log"}</h2>
//             </div>
//             <p className="panel-desc">Structural profile matrices tracking active visitor cohorts and system milestones.</p>

//             <div className="responsive-table-holder">
//               <table className="modern-table">
//                 <thead>
//                   <tr>
//                     <th>Customer Persona</th>
//                     <th>Mobile Network</th>
//                     <th>Total Engagement Visits</th>
//                     <th>Unused Vouchers</th>
//                     <th>Claimed Vouchers</th>
//                     <th>System Standing Milestone</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {customers.length === 0 ? (
//                     <tr>
//                       <td colSpan="6" className="td-center-log">
//                         No consumer logs registered under specified parameters.
//                       </td>
//                     </tr>
//                   ) : (
//                     customers.map((item, idx) => (
//                       <tr key={idx}>
//                         <td className="td-profile-item">{item.name || "Anonymous Member"}</td>
//                         <td className="td-network-mono">{item.mobile || "—"}</td>
//                         <td>
//                           <span className="pill-badge pill-blue">{item.total_visits || 0} Registered Visits</span>
//                         </td>
//                         <td className="vouchers-unused-value">{item.unused_rewards}</td>
//                         <td className="vouchers-used-value">{item.used_rewards}</td>
//                         <td>
//                           <span className={`pill-badge ${item.loyalty_status?.toLowerCase().includes('gold') || item.loyalty_status?.toLowerCase().includes('premium') ? 'pill-orange' : 'pill-green'}`}>
//                             {item.loyalty_status || "Standard Tier"}
//                           </span>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//         </div>
//       </div>
//     </>
//   );
// }


// import React, { useState, useEffect } from "react";

// export default function MerchantFeedbackLog() {
//   // Extract Dynamic Merchant ID from LocalStorage session string safely
//   const getDynamicMerchantId = () => {
//     try {
//       const savedDataString = localStorage.getItem("userData");
//       if (savedDataString) {
//         // Handle potential custom prefixes safely
//         const cleanDataStr = savedDataString.replace("DATABASE CONNECTED", "").trim();
//         const parsed = JSON.parse(cleanDataStr);
//         if (parsed?.merchant?.user_id) {
//           return parsed.merchant.user_id;
//         }
//       }
//     } catch (e) {
//       console.error("Error reading initial userData from localStorage:", e);
//     }
//     return "CMV9A117EAC"; // Global fallback token if session is cleared
//   };

//   const MERCHANT_ID = getDynamicMerchantId();

//   // API Caching Layer states initialized from storage fallback hooks
//   const [analytics, setAnalytics] = useState(() => {
//     const saved = localStorage.getItem(`analytics_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : {
//       total_customers: 0,
//       returning_customers: 0,
//       new_customers: 0,
//       returning_ratio: 0,
//       redeemed_rewards: 0,
//       total_visits: "0"
//     };
//   });

//   const [criticalFeedbacks, setCriticalFeedbacks] = useState(() => {
//     const saved = localStorage.getItem(`feedbacks_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : [];
//   });

//   const [customers, setCustomers] = useState(() => {
//     const saved = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : [];
//   });

//   // Search state contexts
//   const [searchMobile, setSearchMobile] = useState("");
//   const [isSearching, setIsSearching] = useState(false);

//   // Loading conditional flags (Cold setup optimizer)
//   const [loading, setLoading] = useState(() => {
//     const cacheExists = localStorage.getItem(`analytics_${MERCHANT_ID}`);
//     return !cacheExists;
//   });

//   // Safe cleaner logic for API stream headers
//   const cleanAndParseJson = (text) => {
//     const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//     return JSON.parse(cleanString);
//   };

//   // 1. Fetch Dashboard Analytics Engine
//   const fetchAnalytics = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/merchant_dashboard_analytics.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         setAnalytics(data);
//         localStorage.setItem(`analytics_${MERCHANT_ID}`, JSON.stringify(data));
//       }
//     } catch (error) {
//       console.error("Error fetching analytics metrics:", error);
//     }
//   };

//   // 2. Fetch Critical Feedbacks / Escalation Alert Matrices
//   const fetchFeedbacks = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688"); 
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/merchant_feedback_alerts.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         const reviewsData = data.reviews || [];
//         setCriticalFeedbacks(reviewsData);
//         localStorage.setItem(`feedbacks_${MERCHANT_ID}`, JSON.stringify(reviewsData));
//       }
//     } catch (error) {
//       console.error("Error fetching feedbacks logs:", error);
//     }
//   };

//   // 3. Fetch Full Customer Audit Ecosystem Trail
//   const fetchCustomerAuditTrail = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688");
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/customer_audit_trail.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         const customersData = data.customers || [];
//         setCustomers(customersData);
//         if (!isSearching) {
//           localStorage.setItem(`audit_trail_${MERCHANT_ID}`, JSON.stringify(customersData));
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching audit trail pools:", error);
//     }
//   };

//   // 4. Handle Live Search Filters
//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!searchMobile.trim()) {
//       setIsSearching(false);
//       const savedTrail = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//       if (savedTrail) {
//         setCustomers(JSON.parse(savedTrail));
//       } else {
//         fetchCustomerAuditTrail();
//       }
//       return;
//     } 

//     setIsSearching(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       formdata.append("mobile", searchMobile.trim());

//       const response = await fetch(`https://countmyvisit.com/Apis/customer_search.php?mobile=${searchMobile.trim()}&merchant_id=${MERCHANT_ID}`, {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success && data.customer) {
//         const singleCustomer = {
//           customer_id: data.customer.customer_id || "N/A",
//           name: data.customer.name,
//           mobile: data.customer.mobile,
//           total_visits: data.customer.total_visits,
//           used_rewards: data.customer.used_rewards,
//           unused_rewards: data.customer.unused_rewards,
//           loyalty_status: data.customer.loyalty_status
//         };
//         setCustomers([singleCustomer]);
//       } else {
//         setCustomers([]);
//       }
//     } catch (error) {
//       console.error("Search pipeline fault:", error);
//       setCustomers([]);
//     }
//   };

//   useEffect(() => {
//     const triggerDataHydration = async () => {
//       await Promise.all([fetchAnalytics(), fetchFeedbacks(), fetchCustomerAuditTrail()]);
//       setLoading(false);
//     };
//     triggerDataHydration();
//   }, [MERCHANT_ID]);

//   if (loading) {
//     return (
//       <div className="loader-container">
//         <style>{`
//           .loader-container {
//             display: flex;
//             flex-direction: column;
//             justify-content: center;
//             align-items: center;
//             height: 100vh;
//             background: #f8fafc;
//             color: #1e293b;
//             font-family: 'Inter', sans-serif;
//           }
//           .spinner {
//             width: 44px;
//             height: 44px;
//             border: 4px solid #e2e8f0;
//             border-left-color: #2563eb;
//             border-radius: 50%;
//             animation: spin 0.8s linear infinite;
//             margin-bottom: 16px;
//           }
//           .loader-text {
//             font-weight: 500;
//             font-size: 15px;
//             color: #64748b;
//           }
//           @keyframes spin { to { transform: rotate(360deg); } }
//         `}</style>
//         <div className="spinner"></div>
//         <p className="loader-text">Assembling Live System Analytics Core...</p>
//       </div>
//     );
//   }

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//           font-family: 'Inter', sans-serif;
//         }

//         body {
//           background-color: #f8fafc;
//           color: #1e293b;
//           -webkit-font-smoothing: antialiased;
//         }

//         .dashboard-wrapper {
//           min-height: 100vh;
//           background: linear-gradient(180deg, #f1f5f9 0%, #f8fafc 100%);
//           padding: 40px;
//         }

//         .container {
//           max-width: 1400px;
//           margin: 0 auto;
//         }

//         /* PREMIUM LIGHT HEADER */
//         .header-section {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 36px;
//           border-bottom: 1px solid #e2e8f0;
//           padding-bottom: 24px;
//         }

//         .header-title h1 {
//           font-size: 32px;
//           font-weight: 800;
//           letter-spacing: -0.5px;
//           color: #0f172a;
//         }

//         .header-title p {
//           color: #64748b;
//           font-size: 14px;
//           margin-top: 4px;
//           font-weight: 400;
//         }

//         .merchant-badge {
//           background: #eff6ff;
//           border: 1px solid #bfdbfe;
//           color: #1d4ed8;
//           padding: 6px 14px;
//           border-radius: 8px;
//           font-size: 13px;
//           font-weight: 600;
//           letter-spacing: 0.25px;
//         }

//         /* METRIC CARDS ARCHITECTURE */
//         .metrics-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
//           gap: 24px;
//           margin-bottom: 36px;
//         }

//         .stat-card {
//           background: #ffffff;
//           border: 1px solid #e2e8f0;
//           border-radius: 14px;
//           padding: 24px;
//           position: relative;
//           transition: all 0.2s ease-in-out;
//           box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
//         }

//         .stat-card:hover {
//           transform: translateY(-2px);
//           border-color: #cbd5e1;
//           box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
//         }

//         .card-icon-wrapper {
//           width: 42px;
//           height: 42px;
//           border-radius: 10px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin-bottom: 16px;
//         }

//         /* Fresh Vibrant Accent Colors */
//         .blue-icon { background: #eff6ff; color: #2563eb; }
//         .orange-icon { background: #fff7ed; color: #ea580c; }
//         .green-icon { background: #f0fdf4; color: #16a34a; }
//         .purple-icon { background: #faf5ff; color: #7c3aed; }

//         .stat-label {
//           font-size: 13px;
//           color: #64748b;
//           font-weight: 600;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }

//         .stat-value {
//           font-size: 32px;
//           font-weight: 700;
//           color: #0f172a;
//           margin-top: 4px;
//           letter-spacing: -0.5px;
//         }

//         .progress-container {
//           margin-top: 16px;
//           background: #f1f5f9;
//           height: 6px;
//           border-radius: 99px;
//           overflow: hidden;
//         }

//         .progress-fill {
//           height: 100%;
//           border-radius: 99px;
//           transition: width 0.5s ease;
//         }

//         .fill-full { width: 100%; background: #2563eb; }
//         .fill-high { width: 70%; background: #ea580c; }
//         .fill-mid { width: 45%; background: #16a34a; }
//         .fill-dynamic { background: #7c3aed; width: ${analytics.returning_ratio}%; }

//         .card-footer-info {
//           display: flex;
//           justify-content: space-between;
//           font-size: 12px;
//           color: #94a3b8;
//           margin-top: 8px;
//           font-weight: 500;
//         }

//         /* INPUT QUERY MODULE */
//         .search-wrapper {
//           background: #ffffff;
//           border: 1px solid #e2e8f0;
//           padding: 20px;
//           border-radius: 14px;
//           margin-bottom: 36px;
//           box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
//         }

//         .search-inner {
//           display: flex;
//           gap: 12px;
//         }

//         .input-group {
//           position: relative;
//           flex: 1;
//         }

//         .search-icon-inline {
//           position: absolute;
//           left: 16px;
//           top: 50%;
//           transform: translateY(-50%);
//           color: #94a3b8;
//         }

//         .modern-input {
//           width: 100%;
//           background: #f8fafc;
//           border: 1px solid #e2e8f0;
//           border-radius: 10px;
//           padding: 14px 16px 14px 48px;
//           color: #0f172a;
//           font-size: 15px;
//           outline: none;
//           transition: all 0.2s;
//         }

//         .modern-input:focus {
//           border-color: #2563eb;
//           box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
//           background: #ffffff;
//         }

//         .btn-primary {
//           background: #2563eb;
//           color: #ffffff;
//           border: none;
//           padding: 0 24px;
//           border-radius: 10px;
//           font-weight: 600;
//           font-size: 15px;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//           transition: background 0.15s;
//         }

//         .btn-primary:hover {
//           background: #1d4ed8;
//         }

//         .btn-secondary {
//           background: #f1f5f9;
//           color: #475569;
//           border: 1px solid #e2e8f0;
//           padding: 0 20px;
//           border-radius: 10px;
//           font-weight: 500;
//           font-size: 15px;
//           cursor: pointer;
//           transition: all 0.15s;
//         }

//         .btn-secondary:hover {
//           background: #e2e8f0;
//           color: #0f172a;
//         }

//         /* SYSTEM PANELS LAYOUT */
//         .panel-box {
//           background: #ffffff;
//           border: 1px solid #e2e8f0;
//           border-radius: 14px;
//           padding: 28px;
//           margin-bottom: 36px;
//           box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
//         }

//         .panel-header-title {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           margin-bottom: 6px;
//         }

//         .panel-box h2 {
//           font-size: 20px;
//           font-weight: 700;
//           color: #0f172a;
//         }

//         .panel-desc {
//           color: #64748b;
//           font-size: 14px;
//           margin-bottom: 24px;
//         }

//         /* CRITICAL ALERTS TIMELINE */
//         .alerts-stack {
//           display: flex;
//           flex-direction: column;
//           gap: 14px;
//         }

//         .alert-row {
//           background: #fff5f5;
//           border: 1px solid #fee2e2;
//           border-radius: 10px;
//           padding: 18px;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           gap: 20px;
//         }

//         .alert-meta {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           color: #dc2626;
//           font-weight: 600;
//           font-size: 14px;
//           margin-bottom: 6px;
//         }

//         .alert-text {
//           color: #475569;
//           font-size: 14.5px;
//           line-height: 1.5;
//         }

//         .alert-badge-danger {
//           background: #fee2e2;
//           color: #ef4444;
//           border: 1px solid #fca5a5;
//           padding: 6px 12px;
//           border-radius: 6px;
//           font-size: 11px;
//           font-weight: 700;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }

//         /* CORE DATA SHEET MATRIX */
//         .responsive-table-holder {
//           overflow-x: auto;
//           border-radius: 10px;
//           border: 1px solid #e2e8f0;
//           background: #ffffff;
//         }

//         .modern-table {
//           width: 100%;
//           border-collapse: collapse;
//           text-align: left;
//           font-size: 14px;
//           min-width: 900px;
//         }

//         .modern-table th {
//           background: #f8fafc;
//           padding: 16px 20px;
//           color: #475569;
//           font-weight: 600;
//           border-bottom: 1px solid #e2e8f0;
//           text-transform: uppercase;
//           font-size: 11px;
//           letter-spacing: 0.5px;
//         }

//         .modern-table td {
//           padding: 16px 20px;
//           color: #475569;
//           border-bottom: 1px solid #e2e8f0;
//         }

//         .td-center-log {
//           text-align: center;
//           padding: 40px;
//           color: #94a3b8;
//           font-weight: 500;
//         }

//         .td-profile-item {
//           font-weight: 600;
//           color: #0f172a;
//         }

//         .td-network-mono {
//           color: #64748b;
//           font-family: monospace;
//           font-size: 13.5px;
//         }

//         .vouchers-unused-value { color: #ea580c; font-weight: 600; }
//         .vouchers-used-value { color: #16a34a; font-weight: 600; }

//         .modern-table tr:last-child td { border-bottom: none; }
//         .modern-table tr:hover td { background: #f8fafc; }

//         /* DATA BADGES */
//         .pill-badge {
//           display: inline-flex;
//           align-items: center;
//           padding: 4px 12px;
//           border-radius: 6px;
//           font-size: 12.5px;
//           font-weight: 600;
//         }

//         .pill-green { background: #dcfce7; color: #15803d; border: 1px solid #bbf7d0; }
//         .pill-blue { background: #eff6ff; color: #1d4ed8; border: 1px solid #bfdbfe; }
//         .pill-orange { background: #fef3c7; color: #b45309; border: 1px solid #fde68a; }

//         .empty-state {
//           text-align: center;
//           padding: 40px 20px;
//           color: #64748b;
//           font-size: 15px;
//           font-weight: 500;
//         }

//         @media (max-width: 768px) {
//           .dashboard-wrapper { padding: 20px; }
//           .header-section { flex-direction: column; align-items: flex-start; gap: 16px; }
//           .search-inner { flex-direction: column; }
//           .btn-primary { justify-content: center; padding: 14px; }
//         }
//       `}</style>

//       <div className="dashboard-wrapper">
//         <div className="container">

//           {/* HEADER SECTOR */}
//           <header className="header-section">
//             <div className="header-title">
//               <h1>Merchant Control Center</h1>
//               <p>Dynamic engine context mapping validated sessions data channels</p>
//             </div>
//             <div className="merchant-badge">
//               Active ID: {MERCHANT_ID}
//             </div>
//           </header>

//           {/* PERFORMANCE CARDS ENGINE */}
//           <section className="metrics-grid">

//             <div className="stat-card">
//               <div className="card-icon-wrapper blue-icon">
//                 <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
//               </div>
//               <span className="stat-label">Total Registered Customers</span>
//               <div className="stat-value">{analytics.total_customers}</div>
//               <div className="progress-container">
//                 <div className="progress-fill fill-full"></div>
//               </div>
//               <div className="card-footer-info">
//                 <span>Baseline users</span>
//                 <span>Active</span>
//               </div>
//             </div>

//             <div className="stat-card">
//               <div className="card-icon-wrapper orange-icon">
//                 <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 12h-4l-3 9L9 3l-3 9H2"></path></svg>
//               </div>
//               <span className="stat-label">Overall Footfall Visits</span>
//               <div className="stat-value">{analytics.total_visits}</div>
//               <div className="progress-container">
//                 <div className="progress-fill fill-high"></div>
//               </div>
//               <div className="card-footer-info">
//                 <span>Total log counters</span>
//                 <span>Active Tracking</span>
//               </div>
//             </div>

//             <div className="stat-card">
//               <div className="card-icon-wrapper green-icon">
//                 <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
//               </div>
//               <span className="stat-label">Redeemed Voucher Perks</span>
//               <div className="stat-value">{analytics.redeemed_rewards}</div>
//               <div className="progress-container">
//                 <div className="progress-fill fill-mid"></div>
//               </div>
//               <div className="card-footer-info">
//                 <span>Claimed milestones</span>
//                 <span>Live Status</span>
//               </div>
//             </div>

//             <div className="stat-card">
//               <div className="card-icon-wrapper purple-icon">
//                 <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"></path></svg>
//               </div>
//               <span className="stat-label">Retention Index Score</span>
//               <div className="stat-value">{analytics.returning_ratio}%</div>
//               <div className="progress-container">
//                 <div className="progress-fill fill-dynamic"></div>
//               </div>
//               <div className="card-footer-info">
//                 <span>New: {analytics.new_customers}</span>
//                 <span>Returning: {analytics.returning_customers}</span>
//               </div>
//             </div>

//           </section>

//           {/* DYNAMIC FILTERS LAYER */}
//           <div className="search-wrapper">
//             <form onSubmit={handleSearch} className="search-inner">
//               <div className="input-group">
//                 <div className="search-icon-inline">
//                   <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
//                 </div>
//                 <input 
//                   type="text" 
//                   className="modern-input"
//                   placeholder="Enter customer's exact mobile number for complete audit..."
//                   value={searchMobile}
//                   onChange={(e) => setSearchMobile(e.target.value)}
//                 />
//               </div>
//               <button type="submit" className="btn-primary">
//                 Run Profile Query
//               </button>
//               {isSearching && (
//                 <button 
//                   type="button" 
//                   className="btn-secondary" 
//                   onClick={() => {
//                     setSearchMobile("");
//                     setIsSearching(false);
//                     const savedTrail = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//                     if (savedTrail) {
//                       setCustomers(JSON.parse(savedTrail));
//                     } else {
//                       fetchCustomerAuditTrail();
//                     }
//                   }}
//                 >
//                   Reset
//                 </button>
//               )}
//             </form>
//           </div>

//           {/* ESCALATIONS DECK */}
//           <div className="panel-box">
//             <div className="panel-header-title">
//               <svg width="22" height="22" fill="none" stroke="#ef4444" strokeWidth="2" viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
//               <h2>Critical Feedback &amp; Escalation Tracker</h2>
//             </div>
//             <p className="panel-desc">Real-time alerts identifying unsatisfactory operational touchpoints needing intervention.</p>

//             <div className="alerts-stack">
//               {criticalFeedbacks.length === 0 ? (
//                 <div className="empty-state">
//                   🎉 Fantastic! No critical incident triggers or negative loops flagged currently.
//                 </div>
//               ) : (
//                 criticalFeedbacks.map((item, index) => (
//                   <div key={index} className="alert-row">
//                     <div>
//                       <div className="alert-meta">
//                         <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
//                         <span>Customer Reference ID: {item.customer_id || "Anonymous Client"}</span>
//                       </div>
//                       <p className="alert-text">"{item.feedback_text || "No qualitative commentary statement uploaded."}"</p>
//                     </div>
//                     <span className="alert-badge-danger">Requires Action</span>
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>

//           {/* AUDIT TIMELINE SHEET */}
//           <div className="panel-box">
//             <div className="panel-header-title">
//               <svg width="22" height="22" fill="none" stroke="#2563eb" strokeWidth="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
//               <h2>{isSearching ? "Target Query Results" : "Comprehensive Customer Audit Log"}</h2>
//             </div>
//             <p className="panel-desc">Structural profile matrices tracking active visitor cohorts and system milestones.</p>

//             <div className="responsive-table-holder">
//               <table className="modern-table">
//                 <thead>
//                   <tr>
//                     <th>Customer Persona</th>
//                     <th>Mobile Network</th>
//                     <th>Total Engagement Visits</th>
//                     <th>Unused Vouchers</th>
//                     <th>Claimed Vouchers</th>
//                     <th>System Standing Milestone</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {customers.length === 0 ? (
//                     <tr>
//                       <td colSpan="6" className="td-center-log">
//                         No consumer logs registered under specified parameters.
//                       </td>
//                     </tr>
//                   ) : (
//                     customers.map((item, idx) => (
//                       <tr key={idx}>
//                         <td className="td-profile-item">{item.name || "Anonymous Member"}</td>
//                         <td className="td-network-mono">{item.mobile || "—"}</td>
//                         <td>
//                           <span className="pill-badge pill-blue">{item.total_visits || 0} Registered Visits</span>
//                         </td>
//                         <td className="vouchers-unused-value">{item.unused_rewards}</td>
//                         <td className="vouchers-used-value">{item.used_rewards}</td>
//                         <td>
//                           <span className={`pill-badge ${item.loyalty_status?.toLowerCase().includes('gold') || item.loyalty_status?.toLowerCase().includes('premium') ? 'pill-orange' : 'pill-green'}`}>
//                             {item.loyalty_status || "Standard Tier"}
//                           </span>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//         </div>
//       </div>
//     </>
//   );
// }


// import React, { useState, useEffect } from "react";

// export default function MerchantFeedbackLog() {
//   // Extract Dynamic Merchant ID safely
//   const getDynamicMerchantId = () => {
//     try {
//       const savedDataString = localStorage.getItem("userData");
//       if (savedDataString) {
//         const cleanDataStr = savedDataString.replace("DATABASE CONNECTED", "").trim();
//         const parsed = JSON.parse(cleanDataStr);
//         if (parsed?.merchant?.user_id) {
//           return parsed.merchant.user_id;
//         }
//       }
//     } catch (e) {
//       console.error("Error reading initial userData from localStorage:", e);
//     }
//     return "CMV9A117EAC";
//   };

//   const MERCHANT_ID = getDynamicMerchantId();

//   // Subscription Control State
//   const [isSubscribed, setIsSubscribed] = useState(true);

//   // States initialized from storage fallbacks
//   const [analytics, setAnalytics] = useState(() => {
//     const saved = localStorage.getItem(`analytics_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : {
//       total_customers: 0,
//       returning_customers: 0,
//       new_customers: 0,
//       returning_ratio: 0,
//       redeemed_rewards: 0,
//       total_visits: "0"
//     };
//   });

//   const [criticalFeedbacks, setCriticalFeedbacks] = useState(() => {
//     const saved = localStorage.getItem(`feedbacks_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : [];
//   });

//   const [customers, setCustomers] = useState(() => {
//     const saved = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : [];
//   });

//   const [searchMobile, setSearchMobile] = useState("");
//   const [isSearching, setIsSearching] = useState(false);

//   const [loading, setLoading] = useState(() => {
//     const cacheExists = localStorage.getItem(`analytics_${MERCHANT_ID}`);
//     return !cacheExists;
//   });

//   const cleanAndParseJson = (text) => {
//     const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//     return JSON.parse(cleanString);
//   };

//   // 1. Fetch Dashboard Analytics Engine
//   const fetchAnalytics = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/merchant_dashboard_analytics.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         if (data.subscription === "inactive" || data.is_subscribed === false) {
//           setIsSubscribed(false);
//         } else {
//           setIsSubscribed(true);
//         }
//         setAnalytics(data);
//         localStorage.setItem(`analytics_${MERCHANT_ID}`, JSON.stringify(data));
//       }
//     } catch (error) {
//       console.error("Error fetching analytics metrics:", error);
//     }
//   };

//   // 2. Fetch Critical Feedbacks
//   const fetchFeedbacks = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688"); 
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/merchant_feedback_alerts.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         const reviewsData = data.reviews || [];
//         setCriticalFeedbacks(reviewsData);
//         localStorage.setItem(`feedbacks_${MERCHANT_ID}`, JSON.stringify(reviewsData));
//       }
//     } catch (error) {
//       console.error("Error fetching feedbacks logs:", error);
//     }
//   };

//   // 3. Fetch Customer Audit Trail
//   const fetchCustomerAuditTrail = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688");
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/customer_audit_trail.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         const customersData = data.customers || [];
//         setCustomers(customersData);
//         if (!isSearching) {
//           localStorage.setItem(`audit_trail_${MERCHANT_ID}`, JSON.stringify(customersData));
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching audit trail pools:", error);
//     }
//   };

//   // 4. Handle Live Search Filters
//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!searchMobile.trim()) {
//       setIsSearching(false);
//       const savedTrail = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//       if (savedTrail) {
//         setCustomers(JSON.parse(savedTrail));
//       } else {
//         fetchCustomerAuditTrail();
//       }
//       return;
//     } 

//     setIsSearching(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       formdata.append("mobile", searchMobile.trim());

//       const response = await fetch(`https://countmyvisit.com/Apis/customer_search.php?mobile=${searchMobile.trim()}&merchant_id=${MERCHANT_ID}`, {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success && data.customer) {
//         const singleCustomer = {
//           customer_id: data.customer.customer_id || "N/A",
//           name: data.customer.name,
//           mobile: data.customer.mobile,
//           total_visits: data.customer.total_visits,
//           used_rewards: data.customer.used_rewards,
//           unused_rewards: data.customer.unused_rewards,
//           loyalty_status: data.customer.loyalty_status
//         };
//         setCustomers([singleCustomer]);
//       } else {
//         setCustomers([]);
//       }
//     } catch (error) {
//       console.error("Search pipeline fault:", error);
//       setCustomers([]);
//     }
//   };

//   useEffect(() => {
//     const triggerDataHydration = async () => {
//       await Promise.all([fetchAnalytics(), fetchFeedbacks(), fetchCustomerAuditTrail()]);
//       setLoading(false);
//     };
//     triggerDataHydration();
//   }, [MERCHANT_ID]);

//   if (loading) {
//     return (
//       <div className="loader-container">
//         <style>{`
//           .loader-container {
//             display: flex;
//             flex-direction: column;
//             justify-content: center;
//             align-items: center;
//             height: 100vh;
//             background: #f8fafc;
//             color: #1e293b;
//             font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
//           }
//           .spinner {
//             width: 44px;
//             height: 44px;
//             border: 3px solid rgba(255, 140, 66, 0.1);
//             border-left-color: #ff8c42;
//             border-radius: 50%;
//             animation: spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite;
//             margin-bottom: 16px;
//           }
//           .loader-text {
//             font-weight: 600;
//             font-size: 14px;
//             color: #64748b;
//             letter-spacing: 0.5px;
//           }
//           @keyframes spin { to { transform: rotate(360deg); } }
//         `}</style>
//         <div className="spinner"></div>
//         <p className="loader-text">SYNCING SECURE DATA PIECE...</p>
//       </div>
//     );
//   }

//   return (
//     <>
//       <style>{`
//         * { margin: 0; padding: 0; box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
//         body { background: #f8fafc; color: #1e293b; }
//         .merchant-page { min-height: 100vh; padding: 32px; background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); position: relative; }

//         /* SUBSCRIPTION PLATFORM SYSTEM WALL */
//         .subscription-lock-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(241, 245, 249, 0.9);
//           backdrop-filter: blur(16px);
//           z-index: 9999;
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           padding: 24px;
//         }

//         .lock-card {
//           background: #ffffff;
//           border: 1px solid #e2e8f0;
//           padding: 40px;
//           border-radius: 24px;
//           max-width: 480px;
//           width: 100%;
//           text-align: center;
//           box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);
//         }

//         .lock-icon-box {
//           width: 56px;
//           height: 56px;
//           background: #fee2e2;
//           border-radius: 16px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin: 0 auto 20px auto;
//           color: #ef4444;
//         }

//         .lock-card h2 {
//           font-size: 22px;
//           font-weight: 800;
//           color: #0f172a;
//           margin-bottom: 10px;
//         }

//         .lock-card p {
//           color: #64748b;
//           font-size: 14px;
//           line-height: 1.5;
//           margin-bottom: 28px;
//         }

//         /* Subscription Alert Trackers */
//         .sub-status-bar { display: flex; justify-content: space-between; align-items: center; padding: 14px 24px; border-radius: 16px; margin-bottom: 24px; font-weight: 600; font-size: 15px; box-shadow: 0 4px 15px rgba(0,0,0,0.02); }
//         .sub-active-bar { background: #ecfdf5; border: 1px solid #a7f3d0; color: #065f46; }
//         .sub-expired-bar { background: #fef2f2; border: 1px solid #fecaca; color: #991b1b; }
//         .sub-days-count { background: #10b981; color: white; padding: 4px 12px; border-radius: 20px; font-size: 13px; }
//         .sub-renew-btn { background: #ef4444; color: white; border: none; padding: 8px 18px; border-radius: 10px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 10px rgba(239, 68, 68, 0.2); }
//         .sub-renew-btn:hover { background: #dc2626; transform: translateY(-1px); }

//         /* Premium Dynamic Navigation Bar */
//         .premium-nav {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           background: #ffffff;
//           padding: 16px 32px;
//           border-radius: 20px;
//           box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.05);
//           margin-bottom: 30px;
//           border: 1px solid rgba(255, 255, 255, 0.8);
//         }
//         .nav-logo-side { display: flex; align-items: center; gap: 14px; }
//         .nav-brand { font-size: 22px; font-weight: 800; background: linear-gradient(135deg, #ff8c42, #ff5e62); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
//         .nav-actions { display: flex; gap: 12px; align-items: center; }

//         /* Nav Buttons */
//         .nav-btn {
//           padding: 10px 20px;
//           font-size: 14px;
//           font-weight: 600;
//           border-radius: 12px;
//           cursor: pointer;
//           transition: all 0.2s ease;
//           border: none;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }
//         .btn-primary-nav { background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.25); }
//         .btn-primary-nav:hover { opacity: 0.95; transform: translateY(-1px); }
//         .btn-secondary-nav { background: #f1f5f9; color: #475569; }
//         .btn-secondary-nav:hover { background: #e2e8f0; color: #0f172a; }

//         /* Dashboard Top Info Card */
//         .top-header {
//           background: #ffffff;
//           padding: 30px;
//           border-radius: 24px;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.02);
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 30px;
//           border-left: 6px solid #ff8c42;
//         }
//         .merchant-title { font-size: 28px; font-weight: 800; color: #0f172a; text-transform: capitalize; }
//         .merchant-sub { font-size: 14px; color: #64748b; margin-top: 4px; }
//         .merchant-logo { width: 60px; height: 60px; border-radius: 18px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; display: flex; align-items: center; justify-content: center; font-size: 22px; font-weight: 700; box-shadow: 0 10px 20px rgba(255,94,98,0.2); }

//         /* Grid Rules Layout */
//         .main-grid { display: grid; grid-template-columns: 1fr; gap: 30px; }
//         .metrics-summary-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 24px; margin-bottom: 12px; }

//         .card { background: white; border-radius: 24px; padding: 28px; box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #e2e8f0; }
//         .card.is-zero-metric { background: #f8fafc; border-color: #e2e8f0; }
//         .card.is-zero-metric .metric-huge { color: #94a3b8; }

//         .card h2 { font-size: 20px; margin-bottom: 6px; color: #0f172a; font-weight: 700; }
//         .card p { color: #64748b; font-size: 13.5px; margin-bottom: 20px; }

//         .metric-huge { font-size: 38px; font-weight: 800; color: #0f172a; letter-spacing: -1px; margin-bottom: 4px; }

//         /* Optimization Progress Bar */
//         .metric-progress-track { background: #f1f5f9; height: 6px; border-radius: 10px; overflow: hidden; margin-top: 14px; }
//         .metric-progress-bar { height: 100%; border-radius: 10px; transition: width 0.5s ease; }
//         .bg-coral { background: linear-gradient(90deg, #ff8c42, #ff5e62); }
//         .bg-neutral-zero { background: #cbd5e1; width: 0% !important; }

//         /* Inputs Control styling */
//         .search-engine-box { background: white; border-radius: 20px; padding: 24px; border: 1px solid #e2e8f0; margin-bottom: 30px; }
//         .search-flex-row { display: flex; gap: 14px; }
//         .input-group { flex: 1; margin-bottom: 0; position: relative; }
//         .input-group input { width: 100%; height: 50px; border: 1px solid #cbd5e1; background: #f8fafc; border-radius: 14px; padding: 0 16px; font-size: 15px; outline: none; transition: all 0.25s ease; }
//         .input-group input:focus { background: white; border-color: #ff8c42; box-shadow: 0 0 0 4px rgba(255,140,66,0.15); }

//         .save-btn { height: 50px; padding: 0 28px; border: none; border-radius: 14px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.2); whitespace: nowrap; }
//         .save-btn:hover { transform: translateY(-1px); opacity: 0.95; }

//         /* Tables Core Engine */
//         .table-container { overflow-x: auto; border-radius: 16px; border: 1px solid #e2e8f0; background: white; }
//         table { width: 100%; border-collapse: collapse; min-width: 800px; text-align: left; }
//         th { background: #f8fafc; color: #475569; padding: 16px 24px; font-size: 13px; font-weight: 700; border-bottom: 2px solid #e2e8f0; text-transform: uppercase; letter-spacing: 0.5px; }
//         td { padding: 18px 24px; border-bottom: 1px solid #f1f5f9; color: #334155; font-size: 14px; }
//         tr:hover { background: #f8fafc; }

//         /* Badges & Actions UI */
//         .badge { display: inline-block; padding: 5px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; }
//         .badge-neutral { background: #f1f5f9; color: #475569; }
//         .badge-active { background: #ecfdf5; color: #047857; border: 1px solid #a7f3d0; }

//         /* Escalations Stack */
//         .alert-item-card { background: #fff5f5; border: 1px solid #fee2e2; border-left: 4px solid #ef4444; padding: 20px; border-radius: 16px; margin-bottom: 12px; display: flex; justify-content: space-between; align-items: center; }
//         .alert-item-card h4 { font-size: 14px; color: #991b1b; font-weight: 700; margin-bottom: 4px; }
//         .alert-item-card p { font-size: 14px; color: #531212; line-height: 1.5; }
//         .alert-badge-pill { background: #fee2e2; color: #ef4444; font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 8px; text-transform: uppercase; }

//         .empty-placeholder { padding: 40px; text-align: center; color: #94a3b8; font-size: 14px; font-weight: 500; }

//         @media(max-width: 1100px){ .main-grid { grid-template-columns: 1fr; } }
//         @media(max-width: 768px){ 
//           .premium-nav { padding: 16px; flex-direction: column; gap: 16px; text-align: center; } 
//           .search-flex-row { flex-direction: column; }
//           .save-btn { width: 100%; }
//         }
//       `}</style>

//       {/* SUBSCRIPTION SECURITY LOCK OVERLAY */}
//       {!isSubscribed && (
//         <div className="subscription-lock-overlay">
//           <div className="lock-card">
//             <div className="lock-icon-box">
//               <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
//                 <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//                 <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//               </svg>
//             </div>
//             <h2>Premium Subscription Locked</h2>
//             <p>Your current merchant plan activation status is inactive. Please process plan validation to access telemetry logs and analytics data.</p>
//             <button className="save-btn" style={{ width: '100%' }} onClick={() => alert("Initiating Core Payment Gateway...")}>
//               Activate Premium Plan
//             </button>
//           </div>
//         </div>
//       )}

//       <div className="merchant-page">

//         {/* PREMIUM NAVIGATION */}
//         <nav className="premium-nav">
//           <div className="nav-logo-side">
//             <span className="nav-brand">CountMyVisit</span>
//           </div>
//           <div className="nav-actions">
//             <span className="badge badge-neutral" style={{fontFamily: 'monospace'}}>ID: {MERCHANT_ID}</span>
//           </div>
//         </nav>

//         {/* STATUS ACCELERATOR BAR */}
//         <div className={`sub-status-bar ${isSubscribed ? "sub-active-bar" : "sub-expired-bar"}`}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//             <span className="sub-days-count">{isSubscribed ? "Active" : "Locked"}</span>
//             <span>Premium Merchant Analytics Channel Stream</span>
//           </div>
//           {!isSubscribed && (
//             <button className="sub-renew-btn" onClick={() => alert("Redirecting...")}>Renew Layout</button>
//           )}
//         </div>

//         {/* TOP COMPONENT HEADER */}
//         <header className="top-header">
//           <div>
//             <div className="merchant-title">Merchant Dashboard Logs</div>
//             <div className="merchant-sub">Operational metrics and user feedback pipelines</div>
//           </div>
//           <div className="merchant-logo">M</div>
//         </header>

//         {/* DYNAMIC METRIC MATRIX ROW (Zero-state checked) */}
//         <div className="metrics-summary-row">

//           {/* Box 1 */}
//           <div className={`card ${Number(analytics.total_customers) === 0 ? "is-zero-metric" : ""}`}>
//             <h2>Total Customers</h2>
//             <div className="metric-huge">{analytics.total_customers}</div>
//             <div className="metric-progress-track">
//               <div className={`metric-progress-bar ${Number(analytics.total_customers) === 0 ? "bg-neutral-zero" : "bg-coral"}`} style={{ width: '100%' }}></div>
//             </div>
//           </div>

//           {/* Box 2 */}
//           <div className={`card ${Number(analytics.total_visits) === 0 ? "is-zero-metric" : ""}`}>
//             <h2>Total Visits</h2>
//             <div className="metric-huge">{analytics.total_visits}</div>
//             <div className="metric-progress-track">
//               <div className={`metric-progress-bar ${Number(analytics.total_visits) === 0 ? "bg-neutral-zero" : "bg-coral"}`} style={{ width: '100%' }}></div>
//             </div>
//           </div>

//           {/* Box 3 */}
//           <div className={`card ${Number(analytics.redeemed_rewards) === 0 ? "is-zero-metric" : ""}`}>
//             <h2>Redeemed Rewards</h2>
//             <div className="metric-huge">{analytics.redeemed_rewards}</div>
//             <div className="metric-progress-track">
//               <div className={`metric-progress-bar ${Number(analytics.redeemed_rewards) === 0 ? "bg-neutral-zero" : "bg-coral"}`} style={{ width: '100%' }}></div>
//             </div>
//           </div>

//           {/* Box 4 */}
//           <div className={`card ${Number(analytics.returning_ratio) === 0 ? "is-zero-metric" : ""}`}>
//             <h2>Retention Score</h2>
//             <div className="metric-huge">{analytics.returning_ratio}%</div>
//             <div className="metric-progress-track">
//               <div className={`metric-progress-bar ${Number(analytics.returning_ratio) === 0 ? "bg-neutral-zero" : "bg-coral"}`} style={{ width: `${analytics.returning_ratio}%` }}></div>
//             </div>
//           </div>

//         </div>

//         {/* SEARCH FILTER INTEGRATION BOX */}
//         <div className="search-engine-box">
//           <form onSubmit={handleSearch} className="search-flex-row">
//             <div className="input-group">
//               <input 
//                 type="text" 
//                 placeholder="Search precise customer profile logs via mobile number..."
//                 value={searchMobile}
//                 onChange={(e) => setSearchMobile(e.target.value)}
//               />
//             </div>
//             <button type="submit" className="save-btn">Query System Logs</button>
//             {isSearching && (
//               <button 
//                 type="button" 
//                 className="nav-btn btn-secondary-nav"
//                 onClick={() => {
//                   setSearchMobile("");
//                   setIsSearching(false);
//                   const savedTrail = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//                   if (savedTrail) {
//                     setCustomers(JSON.parse(savedTrail));
//                   } else {
//                     fetchCustomerAuditTrail();
//                   }
//                 }}
//               >
//                 Reset
//               </button>
//             )}
//           </form>
//         </div>

//         {/* CORE WORKSPACE GRID */}
//         <main className="main-grid">

//           {/* Section: Escalation Alerts */}
//           <div className="card">
//             <h2>Critical Escalation Alerts</h2>
//             <p>Immediate operational customer triggers loop events</p>

//             <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//               {criticalFeedbacks.length === 0 ? (
//                 <div className="empty-placeholder">No negative alerts or service loops discovered.</div>
//               ) : (
//                 criticalFeedbacks.map((item, index) => (
//                   <div key={index} className="alert-item-card">
//                     <div>
//                       <h4>ID: {item.customer_id || "Anonymous"}</h4>
//                       <p>"{item.feedback_text || "No descriptive log provided."}"</p>
//                     </div>
//                     <span className="alert-badge-pill">Action</span>
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>

//           {/* Section: Complete Logs Table */}
//           <div className="card">
//             <h2>{isSearching ? "Filtered Profile Results" : "Customer Retention Audit Log"}</h2>
//             <p>Active live visitor parameters database map metrics</p>

//             <div className="table-container">
//               <table>
//                 <thead>
//                   <tr>
//                     <th>Customer Persona</th>
//                     <th>Mobile Identifier</th>
//                     <th>Total Engagement Visits</th>
//                     <th>Unused Rewards</th>
//                     <th>Claimed Rewards</th>
//                     <th>Loyalty Standing</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {customers.length === 0 ? (
//                     <tr>
//                       <td colSpan="6" className="empty-placeholder">
//                         No target logs mapped under the specified query pipeline.
//                       </td>
//                     </tr>
//                   ) : (
//                     customers.map((item, idx) => (
//                       <tr key={idx}>
//                         <td style={{ fontWeight: '700', color: '#0f172a' }}>{item.name || "Anonymous Member"}</td>
//                         <td style={{ fontFamily: 'monospace', color: '#64748b' }}>{item.mobile || "—"}</td>
//                         <td>
//                           <span className={`badge ${Number(item.total_visits) > 0 ? "badge-active" : "badge-neutral"}`}>
//                             {item.total_visits || 0} Visits
//                           </span>
//                         </td>
//                         <td style={{ fontWeight: '700', color: Number(item.unused_rewards) > 0 ? '#ff8c42' : '#94a3b8' }}>
//                           {item.unused_rewards}
//                         </td>
//                         <td style={{ fontWeight: '700', color: Number(item.used_rewards) > 0 ? '#10b981' : '#94a3b8' }}>
//                           {item.used_rewards}
//                         </td>
//                         <td>
//                           <span className="badge badge-neutral">{item.loyalty_status || "Standard Tier"}</span>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//         </main>
//       </div>
//     </>
//   );
// }

// import React, { useState, useEffect } from "react";

// export default function MerchantFeedbackLog() {
//   // Extract Dynamic Merchant ID safely
//   const getDynamicMerchantId = () => {
//     try {
//       const savedDataString = localStorage.getItem("userData");
//       if (savedDataString) {
//         const cleanDataStr = savedDataString.replace("DATABASE CONNECTED", "").trim();
//         const parsed = JSON.parse(cleanDataStr);
//         if (parsed?.merchant?.user_id) {
//           return parsed.merchant.user_id;
//         }
//       }
//     } catch (e) {
//       console.error("Error reading initial userData from localStorage:", e);
//     }
//     return "CMV9A117EAC";
//   };

//   const MERCHANT_ID = getDynamicMerchantId();

//   // Subscription Control State
//   const [isSubscribed, setIsSubscribed] = useState(true);

//   // States initialized from storage fallbacks
//   const [analytics, setAnalytics] = useState(() => {
//     const saved = localStorage.getItem(`analytics_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : {
//       total_customers: 0,
//       returning_customers: 0,
//       new_customers: 0,
//       returning_ratio: 0,
//       redeemed_rewards: 0,
//       total_visits: "0"
//     };
//   });

//   const [criticalFeedbacks, setCriticalFeedbacks] = useState(() => {
//     const saved = localStorage.getItem(`feedbacks_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : [];
//   });

//   const [customers, setCustomers] = useState(() => {
//     const saved = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : [];
//   });

//   // New States for Reviews API integration
//   const [reviewsSummary, setReviewsSummary] = useState(() => {
//     const saved = localStorage.getItem(`reviews_summary_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : { total_reviews: 0, average_rating: 0 };
//   });

//   const [allReviews, setAllReviews] = useState(() => {
//     const saved = localStorage.getItem(`all_reviews_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : [];
//   });

//   const [searchMobile, setSearchMobile] = useState("");
//   const [isSearching, setIsSearching] = useState(false);

//   const [loading, setLoading] = useState(() => {
//     const cacheExists = localStorage.getItem(`analytics_${MERCHANT_ID}`);
//     return !cacheExists;
//   });

//   const cleanAndParseJson = (text) => {
//     const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//     return JSON.parse(cleanString);
//   };

//   // 1. Fetch Dashboard Analytics Engine
//   const fetchAnalytics = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/merchant_dashboard_analytics.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         if (data.subscription === "inactive" || data.is_subscribed === false) {
//           setIsSubscribed(false);
//         } else {
//           setIsSubscribed(true);
//         }
//         setAnalytics(data);
//         localStorage.setItem(`analytics_${MERCHANT_ID}`, JSON.stringify(data));
//       }
//     } catch (error) {
//       console.error("Error fetching analytics metrics:", error);
//     }
//   };

//   // 2. Fetch Critical Feedbacks
//   const fetchFeedbacks = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688"); 
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/merchant_feedback_alerts.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         const reviewsData = data.reviews || [];
//         setCriticalFeedbacks(reviewsData);
//         localStorage.setItem(`feedbacks_${MERCHANT_ID}`, JSON.stringify(reviewsData));
//       }
//     } catch (error) {
//       console.error("Error fetching feedbacks logs:", error);
//     }
//   };

//   // 3. Fetch Customer Audit Trail
//   const fetchCustomerAuditTrail = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688");
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/customer_audit_trail.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         const customersData = data.customers || [];
//         setCustomers(customersData);
//         if (!isSearching) {
//           localStorage.setItem(`audit_trail_${MERCHANT_ID}`, JSON.stringify(customersData));
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching audit trail pools:", error);
//     }
//   };

//   // 4. Fetch Customer Reviews & Ratings
//   const fetchAllReviews = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/get_reviews.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         setReviewsSummary({
//           total_reviews: data.total_reviews || 0,
//           average_rating: data.average_rating || 0
//         });
//         setAllReviews(data.reviews || []);

//         localStorage.setItem(`reviews_summary_${MERCHANT_ID}`, JSON.stringify({
//           total_reviews: data.total_reviews || 0,
//           average_rating: data.average_rating || 0
//         }));
//         localStorage.setItem(`all_reviews_${MERCHANT_ID}`, JSON.stringify(data.reviews || []));
//       }
//     } catch (error) {
//       console.error("Error fetching shopkeeper reviews:", error);
//     }
//   };

//   // 5. Handle Live Search Filters
//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!searchMobile.trim()) {
//       setIsSearching(false);
//       const savedTrail = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//       if (savedTrail) {
//         setCustomers(JSON.parse(savedTrail));
//       } else {
//         fetchCustomerAuditTrail();
//       }
//       return;
//     } 

//     setIsSearching(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       formdata.append("mobile", searchMobile.trim());

//       const response = await fetch(`https://countmyvisit.com/Apis/customer_search.php?mobile=${searchMobile.trim()}&merchant_id=${MERCHANT_ID}`, {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success && data.customer) {
//         const singleCustomer = {
//           customer_id: data.customer.customer_id || "N/A",
//           name: data.customer.name,
//           mobile: data.customer.mobile,
//           total_visits: data.customer.total_visits,
//           used_rewards: data.customer.used_rewards,
//           unused_rewards: data.customer.unused_rewards,
//           loyalty_status: data.customer.loyalty_status
//         };
//         setCustomers([singleCustomer]);
//       } else {
//         setCustomers([]);
//       }
//     } catch (error) {
//       console.error("Search pipeline fault:", error);
//       setCustomers([]);
//     }
//   };

//   useEffect(() => {
//     const triggerDataHydration = async () => {
//       await Promise.all([fetchAnalytics(), fetchFeedbacks(), fetchCustomerAuditTrail(), fetchAllReviews()]);
//       setLoading(false);
//     };
//     triggerDataHydration();
//   }, [MERCHANT_ID]);

//   // Star Generator Utility
//   const renderStars = (rating) => {
//     const count = Math.round(Number(rating || 0));
//     return "★".repeat(count) + "☆".repeat(5 - count);
//   };

//   if (loading) {
//     return (
//       <div className="loader-container">
//         <style>{`
//           .loader-container {
//             display: flex;
//             flex-direction: column;
//             justify-content: center;
//             align-items: center;
//             height: 100vh;
//             background: #f8fafc;
//             color: #1e293b;
//             font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
//           }
//           .spinner {
//             width: 44px;
//             height: 44px;
//             border: 3px solid rgba(255, 140, 66, 0.1);
//             border-left-color: #ff8c42;
//             border-radius: 50%;
//             animation: spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite;
//             margin-bottom: 16px;
//           }
//           .loader-text {
//             font-weight: 600;
//             font-size: 14px;
//             color: #64748b;
//             letter-spacing: 0.5px;
//           }
//           @keyframes spin { to { transform: rotate(360deg); } }
//         `}</style>
//         <div className="spinner"></div>
//         <p className="loader-text">SYNCING SECURE DATA PIECE...</p>
//       </div>
//     );
//   }

//   return (
//     <>
//       <style>{`
//         * { margin: 0; padding: 0; box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
//         body { background: #f8fafc; color: #1e293b; }
//         .merchant-page { min-height: 100vh; padding: 32px; background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); position: relative; }

//         /* SUBSCRIPTION PLATFORM SYSTEM WALL */
//         .subscription-lock-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(241, 245, 249, 0.9);
//           backdrop-filter: blur(16px);
//           z-index: 9999;
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           padding: 24px;
//         }

//         .lock-card {
//           background: #ffffff;
//           border: 1px solid #e2e8f0;
//           padding: 40px;
//           border-radius: 24px;
//           max-width: 480px;
//           width: 100%;
//           text-align: center;
//           box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);
//         }

//         .lock-icon-box {
//           width: 56px;
//           height: 56px;
//           background: #fee2e2;
//           border-radius: 16px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin: 0 auto 20px auto;
//           color: #ef4444;
//         }

//         .lock-card h2 {
//           font-size: 22px;
//           font-weight: 800;
//           color: #0f172a;
//           margin-bottom: 10px;
//         }

//         .lock-card p {
//           color: #64748b;
//           font-size: 14px;
//           line-height: 1.5;
//           margin-bottom: 28px;
//         }

//         /* Subscription Alert Trackers */
//         .sub-status-bar { display: flex; justify-content: space-between; align-items: center; padding: 14px 24px; border-radius: 16px; margin-bottom: 24px; font-weight: 600; font-size: 15px; box-shadow: 0 4px 15px rgba(0,0,0,0.02); }
//         .sub-active-bar { background: #ecfdf5; border: 1px solid #a7f3d0; color: #065f46; }
//         .sub-expired-bar { background: #fef2f2; border: 1px solid #fecaca; color: #991b1b; }
//         .sub-days-count { background: #10b981; color: white; padding: 4px 12px; border-radius: 20px; font-size: 13px; }
//         .sub-renew-btn { background: #ef4444; color: white; border: none; padding: 8px 18px; border-radius: 10px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 10px rgba(239, 68, 68, 0.2); }
//         .sub-renew-btn:hover { background: #dc2626; transform: translateY(-1px); }

//         /* Premium Dynamic Navigation Bar */
//         .premium-nav {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           background: #ffffff;
//           padding: 16px 32px;
//           border-radius: 20px;
//           box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.05);
//           margin-bottom: 30px;
//           border: 1px solid rgba(255, 255, 255, 0.8);
//         }
//         .nav-logo-side { display: flex; align-items: center; gap: 14px; }
//         .nav-brand { font-size: 22px; font-weight: 800; background: linear-gradient(135deg, #ff8c42, #ff5e62); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
//         .nav-actions { display: flex; gap: 12px; align-items: center; }

//         /* Nav Buttons */
//         .nav-btn {
//           padding: 10px 20px;
//           font-size: 14px;
//           font-weight: 600;
//           border-radius: 12px;
//           cursor: pointer;
//           transition: all 0.2s ease;
//           border: none;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }
//         .btn-primary-nav { background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.25); }
//         .btn-primary-nav:hover { opacity: 0.95; transform: translateY(-1px); }
//         .btn-secondary-nav { background: #f1f5f9; color: #475569; }
//         .btn-secondary-nav:hover { background: #e2e8f0; color: #0f172a; }

//         /* Dashboard Top Info Card */
//         .top-header {
//           background: #ffffff;
//           padding: 30px;
//           border-radius: 24px;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.02);
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 30px;
//           border-left: 6px solid #ff8c42;
//         }
//         .merchant-title { font-size: 28px; font-weight: 800; color: #0f172a; text-transform: capitalize; }
//         .merchant-sub { font-size: 14px; color: #64748b; margin-top: 4px; }
//         .merchant-logo { width: 60px; height: 60px; border-radius: 18px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; display: flex; align-items: center; justify-content: center; font-size: 22px; font-weight: 700; box-shadow: 0 10px 20px rgba(255,94,98,0.2); }

//         /* Grid Rules Layout */
//         .main-grid { display: grid; grid-template-columns: 1fr; gap: 30px; }
//         .metrics-summary-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 24px; margin-bottom: 12px; }

//         .card { background: white; border-radius: 24px; padding: 28px; box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #e2e8f0; }
//         .card.is-zero-metric { background: #f8fafc; border-color: #e2e8f0; }
//         .card.is-zero-metric .metric-huge { color: #94a3b8; }

//         .card h2 { font-size: 20px; margin-bottom: 6px; color: #0f172a; font-weight: 700; }
//         .card p { color: #64748b; font-size: 13.5px; margin-bottom: 20px; }

//         .metric-huge { font-size: 38px; font-weight: 800; color: #0f172a; letter-spacing: -1px; margin-bottom: 4px; }
//         .metric-star-color { color: #f59e0b; }

//         /* Optimization Progress Bar */
//         .metric-progress-track { background: #f1f5f9; height: 6px; border-radius: 10px; overflow: hidden; margin-top: 14px; }
//         .metric-progress-bar { height: 100%; border-radius: 10px; transition: width 0.5s ease; }
//         .bg-coral { background: linear-gradient(90deg, #ff8c42, #ff5e62); }
//         .bg-gold { background: linear-gradient(90deg, #f59e0b, #eab308); }
//         .bg-neutral-zero { background: #cbd5e1; width: 0% !important; }

//         /* Inputs Control styling */
//         .search-engine-box { background: white; border-radius: 20px; padding: 24px; border: 1px solid #e2e8f0; margin-bottom: 30px; }
//         .search-flex-row { display: flex; gap: 14px; }
//         .input-group { flex: 1; margin-bottom: 0; position: relative; }
//         .input-group input { width: 100%; height: 50px; border: 1px solid #cbd5e1; background: #f8fafc; border-radius: 14px; padding: 0 16px; font-size: 15px; outline: none; transition: all 0.25s ease; }
//         .input-group input:focus { background: white; border-color: #ff8c42; box-shadow: 0 0 0 4px rgba(255,140,66,0.15); }

//         .save-btn { height: 50px; padding: 0 28px; border: none; border-radius: 14px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.2); white-space: nowrap; }
//         .save-btn:hover { transform: translateY(-1px); opacity: 0.95; }

//         /* Tables Core Engine */
//         .table-container { overflow-x: auto; border-radius: 16px; border: 1px solid #e2e8f0; background: white; }
//         table { width: 100%; border-collapse: collapse; min-width: 800px; text-align: left; }
//         th { background: #f8fafc; color: #475569; padding: 16px 24px; font-size: 13px; font-weight: 700; border-bottom: 2px solid #e2e8f0; text-transform: uppercase; letter-spacing: 0.5px; }
//         td { padding: 18px 24px; border-bottom: 1px solid #f1f5f9; color: #334155; font-size: 14px; }
//         tr:hover { background: #f8fafc; }

//         /* Badges & Actions UI */
//         .badge { display: inline-block; padding: 5px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; }
//         .badge-neutral { background: #f1f5f9; color: #475569; }
//         .badge-active { background: #ecfdf5; color: #047857; border: 1px solid #a7f3d0; }
//         .badge-star { background: #fffbeb; color: #b45309; border: 1px solid #fde68a; font-family: monospace; }

//         /* Escalations Stack & Review Row cards */
//         .alert-item-card { background: #fff5f5; border: 1px solid #fee2e2; border-left: 4px solid #ef4444; padding: 20px; border-radius: 16px; margin-bottom: 12px; display: flex; justify-content: space-between; align-items: center; }
//         .alert-item-card h4 { font-size: 14px; color: #991b1b; font-weight: 700; margin-bottom: 4px; }
//         .alert-item-card p { font-size: 14px; color: #531212; line-height: 1.5; }
//         .alert-badge-pill { background: #fee2e2; color: #ef4444; font-size: 11px; font-weight: 700; padding: 4px 10px; border-radius: 8px; text-transform: uppercase; }

//         /* Store Reviews Design Upgrades */
//         .review-panel-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); gap: 20px; }
//         .review-row-card { background: #ffffff; border: 1px solid #e2e8f0; padding: 20px; border-radius: 18px; display: flex; flex-direction: column; justify-content: space-between; transition: all 0.2s ease; box-shadow: 0 4px 12px rgba(0,0,0,0.01); }
//         .review-row-card:hover { transform: translateY(-2px); box-shadow: 0 10px 20px rgba(15, 23, 42, 0.04); }
//         .review-header-flex { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
//         .review-user-name { font-weight: 700; color: #0f172a; font-size: 15px; }
//         .review-user-phone { font-size: 12px; color: #94a3b8; font-family: monospace; }
//         .review-text-content { font-size: 14px; color: #475569; line-height: 1.6; font-style: italic; margin-bottom: 14px; }
//         .review-stars-indicator { color: #f59e0b; font-size: 14px; font-weight: bold; letter-spacing: 1px; }

//         .empty-placeholder { padding: 40px; text-align: center; color: #94a3b8; font-size: 14px; font-weight: 500; }

//         @media(max-width: 1100px){ .main-grid { grid-template-columns: 1fr; } }
//         @media(max-width: 768px) { 
//           .premium-nav { padding: 16px; flex-direction: column; gap: 16px; text-align: center; } 
//           .search-flex-row { flex-direction: column; }
//           .save-btn { width: 100%; }
//         }
//       `}</style>

//       {/* SUBSCRIPTION SECURITY LOCK OVERLAY */}
//       {!isSubscribed && (
//         <div className="subscription-lock-overlay">
//           <div className="lock-card">
//             <div className="lock-icon-box">
//               <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
//                 <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//                 <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//               </svg>
//             </div>
//             <h2>Premium Subscription Locked</h2>
//             <p>Your current merchant plan activation status is inactive. Please process plan validation to access telemetry logs and analytics data.</p>
//             <button className="save-btn" style={{ width: '100%' }} onClick={() => alert("Initiating Core Payment Gateway...")}>
//               Activate Premium Plan
//             </button>
//           </div>
//         </div>
//       )}

//       <div className="merchant-page">

//         {/* PREMIUM NAVIGATION */}
//         <nav className="premium-nav">
//           <div className="nav-logo-side">
//             <span className="nav-brand">CountMyVisit</span>
//           </div>
//           <div className="nav-actions">
//             <span className="badge badge-neutral" style={{fontFamily: 'monospace'}}>ID: {MERCHANT_ID}</span>
//           </div>
//         </nav>

//         {/* STATUS ACCELERATOR BAR */}
//         <div className={`sub-status-bar ${isSubscribed ? "sub-active-bar" : "sub-expired-bar"}`}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//             <span className="sub-days-count">{isSubscribed ? "Active" : "Locked"}</span>
//             <span>Premium Merchant Analytics Channel Stream</span>
//           </div>
//           {!isSubscribed && (
//             <button className="sub-renew-btn" onClick={() => alert("Redirecting...")}>Renew Layout</button>
//           )}
//         </div>

//         {/* TOP COMPONENT HEADER */}
//         <header className="top-header">
//           <div>
//             <div className="merchant-title">Merchant Dashboard Logs</div>
//             <div className="merchant-sub">Operational metrics, real-time reviews, and visitor logs</div>
//           </div>
//           <div className="merchant-logo">M</div>
//         </header>

//         {/* DYNAMIC METRIC MATRIX ROW */}
//         <div className="metrics-summary-row">

//           {/* Box 1 */}
//           <div className={`card ${Number(analytics.total_customers) === 0 ? "is-zero-metric" : ""}`}>
//             <h2>Total Customers</h2>
//             <div className="metric-huge">{analytics.total_customers}</div>
//             <div className="metric-progress-track">
//               <div className={`metric-progress-bar ${Number(analytics.total_customers) === 0 ? "bg-neutral-zero" : "bg-coral"}`} style={{ width: '100%' }}></div>
//             </div>
//           </div>

//           {/* Box 2 */}
//           <div className={`card ${Number(analytics.total_visits) === 0 ? "is-zero-metric" : ""}`}>
//             <h2>Total Visits</h2>
//             <div className="metric-huge">{analytics.total_visits}</div>
//             <div className="metric-progress-track">
//               <div className={`metric-progress-bar ${Number(analytics.total_visits) === 0 ? "bg-neutral-zero" : "bg-coral"}`} style={{ width: '100%' }}></div>
//             </div>
//           </div>

//           {/* Box 3 */}
//           <div className={`card ${Number(reviewsSummary.average_rating) === 0 ? "is-zero-metric" : ""}`}>
//             <h2>Average Rating</h2>
//             <div className="metric-huge metric-star-color">
//               {reviewsSummary.average_rating} <span style={{fontSize: '22px'}}>★</span>
//             </div>
//             <div className="metric-progress-track">
//               <div className={`metric-progress-bar ${Number(reviewsSummary.average_rating) === 0 ? "bg-neutral-zero" : "bg-gold"}`} style={{ width: `${(reviewsSummary.average_rating / 5) * 100}%` }}></div>
//             </div>
//           </div>

//           {/* Box 4 */}
//           <div className={`card ${Number(analytics.returning_ratio) === 0 ? "is-zero-metric" : ""}`}>
//             <h2>Retention Score</h2>
//             <div className="metric-huge">{analytics.returning_ratio}%</div>
//             <div className="metric-progress-track">
//               <div className={`metric-progress-bar ${Number(analytics.returning_ratio) === 0 ? "bg-neutral-zero" : "bg-coral"}`} style={{ width: `${analytics.returning_ratio}%` }}></div>
//             </div>
//           </div>

//         </div>

//         {/* SEARCH FILTER INTEGRATION BOX */}
//         <div className="search-engine-box">
//           <form onSubmit={handleSearch} className="search-flex-row">
//             <div className="input-group">
//               <input 
//                 type="text" 
//                 placeholder="Search precise customer profile logs via mobile number..."
//                 value={searchMobile}
//                 onChange={(e) => setSearchMobile(e.target.value)}
//               />
//             </div>
//             <button type="submit" className="save-btn">Query System Logs</button>
//             {isSearching && (
//               <button 
//                 type="button" 
//                 className="nav-btn btn-secondary-nav"
//                 onClick={() => {
//                   setSearchMobile("");
//                   setIsSearching(false);
//                   const savedTrail = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//                   if (savedTrail) {
//                     setCustomers(JSON.parse(savedTrail));
//                   } else {
//                     fetchCustomerAuditTrail();
//                   }
//                 }}
//               >
//                 Reset
//               </button>
//             )}
//           </form>
//         </div>

//         {/* CORE WORKSPACE GRID */}
//         <main className="main-grid">

//           {/* SECTION: NEW CUSTOMER RATINGS & REVIEWS LOGS */}
//           <div className="card">
//             <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px'}}>
//               <h2>Customer Reviews & Feedbacks</h2>
//               <span className="badge badge-star">{reviewsSummary.total_reviews} Total Reviews</span>
//             </div>
//             <p>Live storefront testimonials and verified metrics streaming instantly</p>

//             {allReviews.length === 0 ? (
//               <div className="empty-placeholder">No store ratings or customer feedback parsed yet.</div>
//             ) : (
//               <div className="review-panel-grid">
//                 {allReviews.map((item) => (
//                   <div key={item.id} className="review-row-card">
//                     <div>
//                       <div className="review-header-flex">
//                         <span className="review-user-name">{item.customer_name || "Anonymous Guest"}</span>
//                         <span className="review-user-phone">{item.mobile ? `+91 ${item.mobile}` : "Hidden System Log"}</span>
//                       </div>
//                       <p className="review-text-content">"{item.review || "No custom log commentary written."}"</p>
//                     </div>
//                     <div className="review-stars-indicator">
//                       {renderStars(item.rating)} <span style={{fontSize: '12px', color: '#64748b', marginLeft: '6px'}}>({item.rating}/5)</span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>

//           {/* Section: Escalation Alerts */}
//           <div className="card">
//             <h2>Critical Escalation Alerts</h2>
//             <p>Immediate operational customer triggers loop events</p>

//             <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//               {criticalFeedbacks.length === 0 ? (
//                 <div className="empty-placeholder">No negative alerts or service loops discovered.</div>
//               ) : (
//                 criticalFeedbacks.map((item, index) => (
//                   <div key={index} className="alert-item-card">
//                     <div>
//                       <h4>ID: {item.customer_id || "Anonymous"}</h4>
//                       <p>"{item.feedback_text || "No descriptive log provided."}"</p>
//                     </div>
//                     <span className="alert-badge-pill">Action</span>
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>

//           {/* Section: Complete Logs Table */}
//           <div className="card">
//             <h2>{isSearching ? "Filtered Profile Results" : "Customer Retention Audit Log"}</h2>
//             <p>Active live visitor parameters database map metrics</p>

//             <div className="table-container">
//               <table>
//                 <thead>
//                   <tr>
//                     <th>Customer Persona</th>
//                     <th>Mobile Identifier</th>
//                     <th>Total Engagement Visits</th>
//                     <th>Unused Rewards</th>
//                     <th>Claimed Rewards</th>
//                     <th>Loyalty Standing</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {customers.length === 0 ? (
//                     <tr>
//                       <td colSpan="6" className="empty-placeholder">
//                         No target logs mapped under the specified query pipeline.
//                       </td>
//                     </tr>
//                   ) : (
//                     customers.map((item, idx) => (
//                       <tr key={idx}>
//                         <td style={{ fontWeight: '700', color: '#0f172a' }}>{item.name || "Anonymous Member"}</td>
//                         <td style={{ fontFamily: 'monospace', color: '#64748b' }}>{item.mobile || "—"}</td>
//                         <td>
//                           <span className={`badge ${Number(item.total_visits) > 0 ? "badge-active" : "badge-neutral"}`}>
//                             {item.total_visits || 0} Visits
//                           </span>
//                         </td>
//                         <td style={{ fontWeight: '700', color: Number(item.unused_rewards) > 0 ? '#ff8c42' : '#94a3b8' }}>
//                           {item.unused_rewards}
//                         </td>
//                         <td style={{ fontWeight: '700', color: Number(item.used_rewards) > 0 ? '#10b981' : '#94a3b8' }}>
//                           {item.used_rewards}
//                         </td>
//                         <td>
//                           <span className="badge badge-neutral">{item.loyalty_status || "Standard Tier"}</span>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//         </main>
//       </div>
//     </>
//   );
// }
 
 
// import React, { useEffect, useMemo, useState } from "react";

// const API_URL =
//   "https://countmyvisit.com/Apis/visit_sale_today.php";

// const MERCHANT_ID = "CMV9A117EAC";

// export default function VisitsSales() {
//   const [period, setPeriod] = useState("today");
//   const [performance, setPerformance] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // ==============================
//   // FETCH API
//   // ==============================
//   const fetchPerformance = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const formData = new FormData();
//       formData.append("merchant_id", MERCHANT_ID);

//       const response = await fetch(API_URL, {
//         method: "POST",
//         body: formData,
//       });

//       if (!response.ok) {
//         throw new Error("Unable to connect with server");
//       }

//       const data = await response.json();

//       console.log("VISITS & SALES API:", data);

//       if (!data.success) {
//         throw new Error(
//           data.message || "Unable to load performance data"
//         );
//       }

//       setPerformance(data);
//     } catch (err) {
//       console.error("Performance API Error:", err);
//       setError(err.message || "Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPerformance();
//   }, []);

//   // ==============================
//   // FORMAT DATE
//   // ==============================
//   const formatDate = (dateString) => {
//     if (!dateString) return "";

//     const date = new Date(
//       dateString.replace(" ", "T")
//     );

//     return date.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   // ==============================
//   // FORMAT NUMBER
//   // ==============================
//   const formatNumber = (value) => {
//     return Number(value || 0).toLocaleString("en-IN");
//   };

//   // ==============================
//   // GET SELECTED PERIOD
//   // ==============================
//   const selectedPeriod = useMemo(() => {
//     return performance?.periods?.[period] || null;
//   }, [performance, period]);

//   // ==============================
//   // GET DATE RANGE
//   // ==============================
//   const getDateRangeText = () => {
//     if (!selectedPeriod) {
//       return "";
//     }

//     const fromDate = formatDate(selectedPeriod.from);

//     if (period === "today") {
//       return fromDate;
//     }

//     if (!selectedPeriod.to) {
//       return fromDate;
//     }

//     /*
//       API ka "to" exclusive hai.

//       Example:
//       Today:
//       from = 03 Oct 2026 00:00
//       to   = 04 Oct 2026 00:00

//       Actual display:
//       03 Oct 2026

//       Isliye 1 day minus kar rahe hain.
//     */

//     const toDate = new Date(
//       selectedPeriod.to.replace(" ", "T")
//     );

//     toDate.setDate(toDate.getDate() - 1);

//     const toFormatted = toDate.toLocaleDateString(
//       "en-IN",
//       {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       }
//     );

//     return `${fromDate} – ${toFormatted}`;
//   };

//   // ==============================
//   // CURRENT VALUES
//   // ==============================
//   const currentVisits =
//     performance?.visits?.[period] ?? 0;

//   const currentSale =
//     performance?.sales?.[period] ?? 0;

//   const currentCustomers =
//     selectedPeriod?.unique_customers ?? 0;

//   const currentBills =
//     selectedPeriod?.bills ?? 0;

//   const newCustomers =
//     selectedPeriod?.new_customers ?? 0;

//   const returningCustomers =
//     selectedPeriod?.returning_customers ?? 0;

//   const discountTotal =
//     selectedPeriod?.discount_total ?? 0;

//   // ==============================
//   // DAILY DATA
//   // ==============================
//   const dailyData =
//     period === "week"
//       ? performance?.daily?.week || []
//       : period === "month"
//       ? performance?.daily?.month || []
//       : [];

//   // ==============================
//   // PERIOD LABEL
//   // ==============================
//   const periodLabel =
//     period === "today"
//       ? "Today"
//       : period === "week"
//       ? "This Week"
//       : "This Month";

//   // ==============================
//   // LOADING
//   // ==============================
//   if (loading) {
//     return (
//       <div className="vs-page">
//         <div className="vs-loading">
//           <div className="vs-spinner"></div>
//           <p>Loading visits & sales...</p>
//         </div>

//         <style>{styles}</style>
//       </div>
//     );
//   }

//   // ==============================
//   // ERROR
//   // ==============================
//   if (error) {
//     return (
//       <div className="vs-page">
//         <div className="vs-error">
//           <div className="vs-error-icon">!</div>

//           <h3>Unable to load data</h3>

//           <p>{error}</p>

//           <button
//             className="vs-retry"
//             onClick={fetchPerformance}
//           >
//             Try Again
//           </button>
//         </div>

//         <style>{styles}</style>
//       </div>
//     );
//   }

//   return (
//     <div className="vs-page">

//       {/* =========================
//           HEADER
//       ========================= */}
//       <div className="vs-header">

//         <div>
//           <div className="vs-title-row">
//             <div className="vs-title-icon">
//               ₹
//             </div>

//             <div>
//               <h1>Visits & Sales</h1>

//               <p>
//                 View your merchant performance
//                 by selected period
//               </p>
//             </div>
//           </div>

//           {/* EXACT DATE RANGE */}
//           {selectedPeriod && (
//             <div className="vs-date-info">
//               <span className="vs-calendar">
//                 📅
//               </span>

//               <span>
//                 Data for{" "}
//                 <strong>
//                   {getDateRangeText()}
//                 </strong>
//               </span>
//             </div>
//           )}
//         </div>

//         {/* REFRESH */}
//         <button
//           className="vs-refresh"
//           onClick={fetchPerformance}
//           title="Refresh data"
//         >
//           ↻
//           <span>Refresh</span>
//         </button>
//       </div>

//       {/* =========================
//           PERIOD TABS
//       ========================= */}
//       <div className="vs-period-wrapper">

//         <div className="vs-period-tabs">

//           <button
//             className={
//               period === "today"
//                 ? "vs-period active"
//                 : "vs-period"
//             }
//             onClick={() => setPeriod("today")}
//           >
//             Today
//           </button>

//           <button
//             className={
//               period === "week"
//                 ? "vs-period active"
//                 : "vs-period"
//             }
//             onClick={() => setPeriod("week")}
//           >
//             This Week
//           </button>

//           <button
//             className={
//               period === "month"
//                 ? "vs-period active"
//                 : "vs-period"
//             }
//             onClick={() => setPeriod("month")}
//           >
//             This Month
//           </button>

//         </div>

//       </div>

//       {/* =========================
//           SELECTED PERIOD
//       ========================= */}
//       <div className="vs-selected-period">
//         <span className="vs-live-dot"></span>

//         Showing:
//         <strong>{periodLabel}</strong>

//         <span className="vs-separator">
//           •
//         </span>

//         <strong>
//           {getDateRangeText()}
//         </strong>
//       </div>

//       {/* =========================
//           MAIN STATS
//       ========================= */}
//       <div className="vs-stats-grid">

//         {/* CUSTOMERS */}
//         <div className="vs-card customer-card">

//           <div className="vs-card-top">
//             <div>
//               <p className="vs-card-label">
//                 Total Customers
//               </p>

//               <h2>
//                 {formatNumber(currentCustomers)}
//               </h2>

//               <p className="vs-card-description">
//                 Unique customers
//               </p>
//             </div>

//             <div className="vs-card-icon">
//               👥
//             </div>
//           </div>

//           <div className="vs-card-footer">
//             <span>
//               New: <strong>{newCustomers}</strong>
//             </span>

//             <span>
//               Returning:{" "}
//               <strong>{returningCustomers}</strong>
//             </span>
//           </div>

//         </div>

//         {/* VISITS */}
//         <div className="vs-card visit-card">

//           <div className="vs-card-top">
//             <div>
//               <p className="vs-card-label">
//                 {period === "today"
//                   ? "Today Visits"
//                   : period === "week"
//                   ? "Week Visits"
//                   : "Month Visits"}
//               </p>

//               <h2>
//                 {formatNumber(currentVisits)}
//               </h2>

//               <p className="vs-card-description">
//                 Customer visits
//               </p>
//             </div>

//             <div className="vs-card-icon">
//               👣
//             </div>
//           </div>

//           <div className="vs-card-footer">
//             <span>
//               Bills:{" "}
//               <strong>{currentBills}</strong>
//             </span>
//           </div>

//         </div>

//         {/* SALES */}
//         <div className="vs-card sales-card">

//           <div className="vs-card-top">
//             <div>
//               <p className="vs-card-label">
//                 {period === "today"
//                   ? "Today Sale"
//                   : period === "week"
//                   ? "Week Sale"
//                   : "Month Sale"}
//               </p>

//               <h2>
//                 ₹ {formatNumber(currentSale)}
//               </h2>

//               <p className="vs-card-description">
//                 Sales generated
//               </p>
//             </div>

//             <div className="vs-card-icon">
//               ₹
//             </div>
//           </div>

//           <div className="vs-card-footer">
//             <span>
//               Discount:{" "}
//               <strong>
//                 ₹ {formatNumber(discountTotal)}
//               </strong>
//             </span>
//           </div>

//         </div>

//         {/* RATING */}
//         <div className="vs-card rating-card">

//           <div className="vs-card-top">
//             <div>
//               <p className="vs-card-label">
//                 Average Rating
//               </p>

//               <h2>
//                 4<span className="rating-star">★</span>
//               </h2>

//               <p className="vs-card-description">
//                 Customer feedback rating
//               </p>
//             </div>

//             <div className="vs-card-icon">
//               ★
//             </div>
//           </div>

//           <div className="vs-card-footer">
//             <span>
//               Based on customer feedback
//             </span>
//           </div>

//         </div>

//       </div>

//       {/* =========================
//           PERIOD SUMMARY
//       ========================= */}
//       {selectedPeriod && (
//         <div className="vs-summary">

//           <div className="vs-section-title">
//             <div>
//               <h2>{periodLabel} Summary</h2>

//               <p>
//                 Performance from{" "}
//                 <strong>
//                   {getDateRangeText()}
//                 </strong>
//               </p>
//             </div>
//           </div>

//           <div className="vs-summary-grid">

//             <div className="vs-summary-item">
//               <span>Visits</span>
//               <strong>
//                 {formatNumber(
//                   selectedPeriod.visits
//                 )}
//               </strong>
//             </div>

//             <div className="vs-summary-item">
//               <span>Unique Customers</span>
//               <strong>
//                 {formatNumber(
//                   selectedPeriod.unique_customers
//                 )}
//               </strong>
//             </div>

//             <div className="vs-summary-item">
//               <span>New Customers</span>
//               <strong>
//                 {formatNumber(
//                   selectedPeriod.new_customers
//                 )}
//               </strong>
//             </div>

//             <div className="vs-summary-item">
//               <span>Returning Customers</span>
//               <strong>
//                 {formatNumber(
//                   selectedPeriod.returning_customers
//                 )}
//               </strong>
//             </div>

//             <div className="vs-summary-item">
//               <span>Total Bills</span>
//               <strong>
//                 {formatNumber(
//                   selectedPeriod.bills
//                 )}
//               </strong>
//             </div>

//             <div className="vs-summary-item">
//               <span>Bill Total</span>
//               <strong>
//                 ₹{" "}
//                 {formatNumber(
//                   selectedPeriod.bill_total
//                 )}
//               </strong>
//             </div>

//             <div className="vs-summary-item">
//               <span>Discount</span>
//               <strong>
//                 ₹{" "}
//                 {formatNumber(
//                   selectedPeriod.discount_total
//                 )}
//               </strong>
//             </div>

//             <div className="vs-summary-item highlight">
//               <span>Total Sale</span>
//               <strong>
//                 ₹{" "}
//                 {formatNumber(
//                   selectedPeriod.sale
//                 )}
//               </strong>
//             </div>

//           </div>
//         </div>
//       )}

//       {/* =========================
//           DAILY PERFORMANCE
//       ========================= */}
//       {dailyData.length > 0 && (
//         <div className="vs-daily-section">

//           <div className="vs-section-title">
//             <div>
//               <h2>
//                 {period === "week"
//                   ? "Weekly Performance"
//                   : "Monthly Performance"}
//               </h2>

//               <p>
//                 Daily visits and sales
//               </p>
//             </div>
//           </div>

//           <div className="vs-daily-list">

//             {dailyData.map((item, index) => {

//               const isToday =
//                 performance?.date === item.date;

//               return (
//                 <div
//                   className={
//                     isToday
//                       ? "vs-day-row today"
//                       : "vs-day-row"
//                   }
//                   key={item.date || index}
//                 >

//                   <div className="vs-day-date">

//                     <div className="vs-day-name">
//                       {item.day}
//                     </div>

//                     <div className="vs-full-date">
//                       {formatDate(item.date)}
//                     </div>

//                     {isToday && (
//                       <span className="vs-today-badge">
//                         TODAY
//                       </span>
//                     )}

//                   </div>

//                   <div className="vs-day-stat">
//                     <span>Visits</span>
//                     <strong>
//                       {formatNumber(item.visits)}
//                     </strong>
//                   </div>

//                   <div className="vs-day-stat">
//                     <span>Sale</span>
//                     <strong>
//                       ₹ {formatNumber(item.sale)}
//                     </strong>
//                   </div>

//                 </div>
//               );
//             })}

//           </div>
//         </div>
//       )}

//       {/* =========================
//           TODAY TRANSACTIONS
//       ========================= */}
//       {period === "today" &&
//         performance?.today_rows?.length > 0 && (
//           <div className="vs-transactions">

//             <div className="vs-section-title">
//               <div>
//                 <h2>Today's Sales</h2>

//                 <p>
//                   Transactions for{" "}
//                   <strong>
//                     {formatDate(
//                       performance.date
//                     )}
//                   </strong>
//                 </p>
//               </div>
//             </div>

//             <div className="vs-table-wrapper">

//               <table className="vs-table">

//                 <thead>
//                   <tr>
//                     <th>Customer</th>
//                     <th>Time</th>
//                     <th>Amount</th>
//                   </tr>
//                 </thead>

//                 <tbody>

//                   {performance.today_rows.map(
//                     (row, index) => {

//                       const created =
//                         new Date(
//                           row.created_at.replace(
//                             " ",
//                             "T"
//                           )
//                         );

//                       const time =
//                         created.toLocaleTimeString(
//                           "en-IN",
//                           {
//                             hour: "2-digit",
//                             minute: "2-digit",
//                           }
//                         );

//                       return (
//                         <tr key={row.id || index}>

//                           <td>
//                             <div className="customer-info">
//                               <div className="customer-avatar">
//                                 👤
//                               </div>

//                               <div>
//                                 <strong>
//                                   {row.customer_id}
//                                 </strong>

//                                 <small>
//                                   Customer
//                                 </small>
//                               </div>
//                             </div>
//                           </td>

//                           <td>
//                             {time}
//                           </td>

//                           <td>
//                             <strong className="amount">
//                               ₹{" "}
//                               {formatNumber(
//                                 row.payable_amount
//                               )}
//                             </strong>
//                           </td>

//                         </tr>
//                       );
//                     }
//                   )}

//                 </tbody>

//               </table>

//             </div>
//           </div>
//         )}

//       {/* =========================
//           API DATE / TIME INFO
//       ========================= */}
//       {performance?.debug && (
//         <div className="vs-api-info">

//           <span>
//             Last updated:{" "}
//             {formatDate(
//               performance.date
//             )}
//           </span>

//           <span>
//             Server time:{" "}
//             {performance.debug.server_now}
//           </span>

//           <span>
//             Timezone:{" "}
//             {performance.debug.timezone}
//           </span>

//         </div>
//       )}

//       <style>{styles}</style>
//     </div>
//   );
// }

// // =====================================================
// // CSS
// // =====================================================

// const styles = `

// * {
//   box-sizing: border-box;
// }

// .vs-page {
//   width: 100%;
//   min-height: 100%;
//   padding: 28px;
//   background: #f8fafc;
//   color: #111827;
//   font-family:
//     Inter,
//     -apple-system,
//     BlinkMacSystemFont,
//     "Segoe UI",
//     sans-serif;
// }

// /* ==============================
//    HEADER
// ============================== */

// .vs-header {
//   display: flex;
//   justify-content: space-between;
//   align-items: flex-start;
//   gap: 20px;
//   margin-bottom: 20px;
// }

// .vs-title-row {
//   display: flex;
//   align-items: center;
//   gap: 14px;
// }

// .vs-title-icon {
//   width: 48px;
//   height: 48px;
//   border-radius: 14px;
//   background: #1A237E;
//   color: white;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-size: 22px;
//   font-weight: 800;
//   box-shadow:
//     0 8px 20px rgba(26, 35, 126, 0.2);
// }

// .vs-header h1 {
//   margin: 0;
//   font-size: 26px;
//   font-weight: 800;
//   color: #111827;
// }

// .vs-header p {
//   margin: 4px 0 0;
//   font-size: 14px;
//   color: #6b7280;
// }

// /* ==============================
//    DATE
// ============================== */

// .vs-date-info {
//   display: inline-flex;
//   align-items: center;
//   gap: 7px;
//   margin-top: 14px;
//   padding: 8px 13px;
//   background: white;
//   border: 1px solid #e5e7eb;
//   border-radius: 9px;
//   color: #4b5563;
//   font-size: 13px;
//   box-shadow: 0 2px 6px rgba(0,0,0,0.03);
// }

// .vs-calendar {
//   font-size: 15px;
// }

// .vs-date-info strong {
//   color: #1A237E;
// }

// /* ==============================
//    REFRESH
// ============================== */

// .vs-refresh {
//   border: 1px solid #dbe1ea;
//   background: white;
//   color: #1A237E;
//   border-radius: 9px;
//   padding: 9px 14px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   gap: 7px;
//   font-weight: 600;
//   font-size: 13px;
// }

// .vs-refresh:hover {
//   background: #f8fafc;
// }

// /* ==============================
//    PERIOD
// ============================== */

// .vs-period-wrapper {
//   margin-bottom: 12px;
// }

// .vs-period-tabs {
//   display: inline-flex;
//   padding: 4px;
//   background: #eef2f7;
//   border-radius: 11px;
//   gap: 3px;
// }

// .vs-period {
//   border: none;
//   background: transparent;
//   color: #64748b;
//   padding: 10px 18px;
//   border-radius: 8px;
//   cursor: pointer;
//   font-weight: 700;
//   font-size: 13px;
//   transition: 0.2s;
// }

// .vs-period:hover {
//   color: #1A237E;
// }

// .vs-period.active {
//   background: #1A237E;
//   color: white;
//   box-shadow:
//     0 4px 10px rgba(26, 35, 126, 0.2);
// }

// /* ==============================
//    SELECTED PERIOD
// ============================== */

// .vs-selected-period {
//   display: flex;
//   align-items: center;
//   flex-wrap: wrap;
//   gap: 6px;
//   margin-bottom: 22px;
//   font-size: 13px;
//   color: #64748b;
// }

// .vs-selected-period strong {
//   color: #1f2937;
// }

// .vs-live-dot {
//   width: 7px;
//   height: 7px;
//   background: #16a34a;
//   border-radius: 50%;
//   display: inline-block;
// }

// .vs-separator {
//   color: #cbd5e1;
//   margin: 0 2px;
// }

// /* ==============================
//    STATS
// ============================== */

// .vs-stats-grid {
//   display: grid;
//   grid-template-columns:
//     repeat(4, minmax(0, 1fr));
//   gap: 16px;
//   margin-bottom: 24px;
// }

// .vs-card {
//   background: white;
//   border: 1px solid #e8ebf0;
//   border-radius: 16px;
//   padding: 20px;
//   min-width: 0;
//   box-shadow:
//     0 3px 12px rgba(15, 23, 42, 0.04);
// }

// .vs-card-top {
//   display: flex;
//   justify-content: space-between;
//   align-items: flex-start;
//   gap: 10px;
// }

// .vs-card-label {
//   margin: 0 0 8px;
//   font-size: 13px;
//   color: #64748b;
//   font-weight: 600;
// }

// .vs-card h2 {
//   margin: 0;
//   font-size: 29px;
//   line-height: 1.1;
//   color: #111827;
// }

// .vs-card-description {
//   margin: 7px 0 0;
//   color: #94a3b8;
//   font-size: 12px;
// }

// .vs-card-icon {
//   width: 42px;
//   height: 42px;
//   border-radius: 12px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: #f1f5f9;
//   font-size: 18px;
// }

// .vs-card-footer {
//   display: flex;
//   gap: 12px;
//   flex-wrap: wrap;
//   margin-top: 18px;
//   padding-top: 13px;
//   border-top: 1px solid #f1f5f9;
//   color: #64748b;
//   font-size: 11px;
// }

// .vs-card-footer strong {
//   color: #334155;
// }

// .sales-card .vs-card-icon {
//   color: #15803d;
//   background: #f0fdf4;
// }

// .visit-card .vs-card-icon {
//   color: #1A237E;
//   background: #eef2ff;
// }

// .customer-card .vs-card-icon {
//   background: #fff7ed;
// }

// .rating-card .vs-card-icon {
//   color: #ca8a04;
//   background: #fefce8;
// }

// .rating-star {
//   color: #eab308;
//   font-size: 21px;
// }

// /* ==============================
//    SUMMARY
// ============================== */

// .vs-summary,
// .vs-daily-section,
// .vs-transactions {
//   background: white;
//   border: 1px solid #e8ebf0;
//   border-radius: 16px;
//   padding: 22px;
//   margin-bottom: 20px;
//   box-shadow:
//     0 3px 12px rgba(15, 23, 42, 0.035);
// }

// .vs-section-title {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   margin-bottom: 18px;
// }

// .vs-section-title h2 {
//   margin: 0;
//   font-size: 18px;
//   font-weight: 800;
// }

// .vs-section-title p {
//   margin: 5px 0 0;
//   color: #64748b;
//   font-size: 12px;
// }

// .vs-section-title strong {
//   color: #1A237E;
// }

// .vs-summary-grid {
//   display: grid;
//   grid-template-columns:
//     repeat(4, minmax(0, 1fr));
//   gap: 10px;
// }

// .vs-summary-item {
//   padding: 15px;
//   border-radius: 11px;
//   background: #f8fafc;
//   border: 1px solid #eef2f7;
// }

// .vs-summary-item span {
//   display: block;
//   color: #64748b;
//   font-size: 11px;
//   margin-bottom: 7px;
// }

// .vs-summary-item strong {
//   font-size: 18px;
//   color: #111827;
// }

// .vs-summary-item.highlight {
//   background: #eef2ff;
//   border-color: #c7d2fe;
// }

// .vs-summary-item.highlight strong {
//   color: #1A237E;
// }

// /* ==============================
//    DAILY
// ============================== */

// .vs-daily-list {
//   display: flex;
//   flex-direction: column;
//   gap: 7px;
// }

// .vs-day-row {
//   display: grid;
//   grid-template-columns:
//     1.5fr 1fr 1fr;
//   align-items: center;
//   gap: 20px;
//   padding: 13px 15px;
//   border: 1px solid #eef2f7;
//   border-radius: 10px;
// }

// .vs-day-row.today {
//   background: #f8f9ff;
//   border-color: #c7d2fe;
// }

// .vs-day-date {
//   display: flex;
//   align-items: center;
//   gap: 9px;
//   flex-wrap: wrap;
// }

// .vs-day-name {
//   font-weight: 800;
//   color: #111827;
//   width: 38px;
// }

// .vs-full-date {
//   color: #64748b;
//   font-size: 12px;
// }

// .vs-today-badge {
//   padding: 3px 7px;
//   border-radius: 5px;
//   background: #1A237E;
//   color: white;
//   font-size: 9px;
//   font-weight: 800;
// }

// .vs-day-stat {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 8px;
// }

// .vs-day-stat span {
//   color: #64748b;
//   font-size: 12px;
// }

// .vs-day-stat strong {
//   color: #111827;
//   font-size: 14px;
// }

// /* ==============================
//    TABLE
// ============================== */

// .vs-table-wrapper {
//   width: 100%;
//   overflow-x: auto;
// }

// .vs-table {
//   width: 100%;
//   border-collapse: collapse;
// }

// .vs-table th {
//   text-align: left;
//   padding: 11px 10px;
//   background: #f8fafc;
//   color: #64748b;
//   font-size: 11px;
//   font-weight: 700;
// }

// .vs-table td {
//   padding: 13px 10px;
//   border-bottom: 1px solid #f1f5f9;
//   color: #475569;
//   font-size: 13px;
// }

// .customer-info {
//   display: flex;
//   align-items: center;
//   gap: 10px;
// }

// .customer-avatar {
//   width: 34px;
//   height: 34px;
//   border-radius: 9px;
//   background: #eef2ff;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }

// .customer-info strong {
//   display: block;
//   color: #111827;
//   font-size: 12px;
// }

// .customer-info small {
//   color: #94a3b8;
//   font-size: 10px;
// }

// .amount {
//   color: #15803d;
// }

// /* ==============================
//    API INFO
// ============================== */

// .vs-api-info {
//   display: flex;
//   justify-content: center;
//   flex-wrap: wrap;
//   gap: 10px;
//   margin-top: 4px;
//   color: #94a3b8;
//   font-size: 10px;
// }

// /* ==============================
//    LOADING
// ============================== */

// .vs-loading {
//   min-height: 400px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   color: #64748b;
// }

// .vs-spinner {
//   width: 34px;
//   height: 34px;
//   border: 3px solid #e2e8f0;
//   border-top-color: #1A237E;
//   border-radius: 50%;
//   animation: vs-spin 0.8s linear infinite;
// }

// @keyframes vs-spin {
//   to {
//     transform: rotate(360deg);
//   }
// }

// /* ==============================
//    ERROR
// ============================== */

// .vs-error {
//   min-height: 400px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   text-align: center;
// }

// .vs-error-icon {
//   width: 45px;
//   height: 45px;
//   border-radius: 50%;
//   background: #fee2e2;
//   color: #dc2626;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-size: 24px;
//   font-weight: 800;
// }

// .vs-error h3 {
//   margin: 14px 0 5px;
// }

// .vs-error p {
//   color: #64748b;
//   font-size: 13px;
// }

// .vs-retry {
//   border: none;
//   background: #1A237E;
//   color: white;
//   padding: 10px 18px;
//   border-radius: 8px;
//   cursor: pointer;
//   font-weight: 700;
// }

// /* ==============================
//    MOBILE
// ============================== */

// @media (max-width: 1100px) {

//   .vs-stats-grid {
//     grid-template-columns:
//       repeat(2, minmax(0, 1fr));
//   }

//   .vs-summary-grid {
//     grid-template-columns:
//       repeat(2, minmax(0, 1fr));
//   }

// }

// @media (max-width: 700px) {

//   .vs-page {
//     padding: 16px;
//   }

//   .vs-header {
//     flex-direction: column;
//   }

//   .vs-refresh {
//     width: 100%;
//     justify-content: center;
//   }

//   .vs-title-row {
//     align-items: flex-start;
//   }

//   .vs-header h1 {
//     font-size: 21px;
//   }

//   .vs-period-tabs {
//     width: 100%;
//   }

//   .vs-period {
//     flex: 1;
//     padding: 9px 5px;
//     font-size: 11px;
//   }

//   .vs-selected-period {
//     font-size: 11px;
//   }

//   .vs-stats-grid {
//     grid-template-columns: 1fr;
//   }

//   .vs-card {
//     padding: 17px;
//   }

//   .vs-card h2 {
//     font-size: 26px;
//   }

//   .vs-summary,
//   .vs-daily-section,
//   .vs-transactions {
//     padding: 16px;
//   }

//   .vs-summary-grid {
//     grid-template-columns: 1fr 1fr;
//   }

//   .vs-day-row {
//     grid-template-columns: 1fr;
//     gap: 9px;
//   }

//   .vs-day-stat {
//     border-top: 1px solid #f1f5f9;
//     padding-top: 8px;
//   }

//   .vs-section-title {
//     align-items: flex-start;
//   }

// }

// @media (max-width: 430px) {

//   .vs-summary-grid {
//     grid-template-columns: 1fr;
//   }

//   .vs-date-info {
//     font-size: 11px;
//   }

// }
// `;
 
import React, { useState, useEffect } from "react";

// ---------- Visits & Sales constants / helpers (outside component) ----------
const VISIT_SALES_API = "https://countmyvisit.com/Apis/visit_sale_today.php";

const VS_PERIODS = [
  { key: "today", label: "Today", short: "Today", detailLabel: "Today Details" },
  { key: "week", label: "This Week", short: "Week", detailLabel: "This Week Details" },
  { key: "month", label: "This Month", short: "Month", detailLabel: "This Month Details" }
];

const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const formatINR = (v) => `₹${toNum(v).toLocaleString("en-IN")}`;

// retention = returning_customers / unique_customers * 100 (0% if no unique customers)
const calcRetention = (period) => {
  const unique = toNum(period?.unique_customers);
  const returning = toNum(period?.returning_customers);
  if (unique <= 0) return "0%";
  return `${Number(((returning / unique) * 100).toFixed(1))}%`;
};

// API "to" date is exclusive (next day 00:00:00), so show the last included day
const dateMinusOne = (s) => {
  const raw = String(s || "").slice(0, 10);
  const [y, m, d] = raw.split("-").map(Number);
  if (!y || !m || !d) return raw;
  return new Date(Date.UTC(y, m - 1, d - 1)).toISOString().slice(0, 10);
};

const isValidVisitSales = (d) =>
  !!d && d.success === true && !!d.periods && !!d.visits && !!d.sales;

export default function MerchantFeedbackLog() {
  // Extract Dynamic Merchant ID safely

  const getDynamicMerchantId = () => {
    try {
      const savedDataString = localStorage.getItem("marchentdata");
      // console.log('i am merchent',savedDataString)
      if (savedDataString) {
        const cleanDataStr = savedDataString.replace("DATABASE CONNECTED", "").trim();
        const parsed = JSON.parse(cleanDataStr);
        if (parsed?.merchant?.user_id) {
          return parsed.merchant.user_id;
        }
      }
    } catch (e) {
      console.error("Error reading initial userData from localStorage:", e);
    }
    return "CMV9A117EAC";
  };

  const MERCHANT_ID = getDynamicMerchantId();

  // Subscription Control State
  const [isSubscribed, setIsSubscribed] = useState(true);

  // Filter State: 'today', 'week', ya 'month' (Visits & Sales period)
  const [salesFilter, setSalesFilter] = useState("today");

  // Old analytics API is now used ONLY for subscription status (not for visits/sales)
  const [, setAnalytics] = useState(null);

  // ---------- Visits & Sales states (fed ONLY by visit_sale_today.php) ----------
  const [vsData, setVsData] = useState(() => {
    try {
      const saved = localStorage.getItem(`visit_sales_${MERCHANT_ID}`);
      if (saved) {
        const parsed = JSON.parse(saved);
        if (isValidVisitSales(parsed)) return parsed;
      }
    } catch (e) {
      console.error("Error reading visit/sales cache:", e);
    }
    return null;
  });
  // "idle" | "live" | "cache" | "error"
  const [vsStatus, setVsStatus] = useState(() => (vsData ? "cache" : "idle"));
  const [vsLoading, setVsLoading] = useState(true);
  const [vsError, setVsError] = useState("");
  const [detailPeriod, setDetailPeriod] = useState(null); // null | 'today' | 'week' | 'month'

  const [customers, setCustomers] = useState(() => {
    const saved = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
    return saved ? JSON.parse(saved) : [];
  });

  const [reviewsSummary, setReviewsSummary] = useState(() => {
    const saved = localStorage.getItem(`reviews_summary_${MERCHANT_ID}`);
    return saved ? JSON.parse(saved) : { total_reviews: 0, average_rating: 0 };
  });

  const [allReviews, setAllReviews] = useState(() => {
    const saved = localStorage.getItem(`all_reviews_${MERCHANT_ID}`);
    return saved ? JSON.parse(saved) : [];
  });

  const [searchMobile, setSearchMobile] = useState("");
  const [isSearching, setIsSearching] = useState(false);

  // Modal Control States for Active Customer Details
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [loading, setLoading] = useState(() => {
    const cacheExists = localStorage.getItem(`analytics_${MERCHANT_ID}`);
    return !cacheExists;
  });

  const cleanAndParseJson = (text) => {
    const cleanString = text.replace("DATABASE CONNECTED", "").trim();
    return JSON.parse(cleanString);
  };

  // 1. Fetch Dashboard Analytics Engine (SUBSCRIPTION STATUS ONLY)
  const fetchAnalytics = async () => {
    try {
      const formdata = new FormData();
      formdata.append("merchant_id", MERCHANT_ID);

      const response = await fetch("https://countmyvisit.com/Apis/merchant_dashboard_analytics.php", {
        method: "POST",
        body: formdata,
        redirect: "follow"
      });
      const resText = await response.text();
      console.log('hereis merchan', resText)
      const data = cleanAndParseJson(resText);
      if (data.success) {
        if (data.plan_status === "inactive" || data.is_subscribed === false) {
          setIsSubscribed(false);
        } else {
          setIsSubscribed(true);
        }
        setAnalytics(data);
        localStorage.setItem(`analytics_${MERCHANT_ID}`, JSON.stringify(data));
      }
    } catch (error) {
      console.error("Error fetching analytics metrics:", error);
    }
  };

  // 1b. Fetch Visits & Sales (ONLY source for visits / customers / bills / sales)
  const fetchVisitsSales = async () => {
    setVsLoading(true);
    try {
      const formData = new FormData();
      formData.append("merchant_id", MERCHANT_ID);

      // NOTE: Content-Type header manually set nahi kiya - browser khud boundary banayega
      const response = await fetch(VISIT_SALES_API, {
        method: "POST",
        body: formData
      });
      const resText = await response.text();
      const data = cleanAndParseJson(resText);
      console.log("Visit & Sales API:", data);

      if (!isValidVisitSales(data)) {
        throw new Error("Invalid Visits & Sales response");
      }

      // Fresh API data always wins over cache
      setVsData(data);
      setVsStatus("live");
      setVsError("");
      try {
        localStorage.setItem(`visit_sales_${MERCHANT_ID}`, JSON.stringify(data));
      } catch (e) {
        console.error("Could not cache visit/sales data:", e);
      }
    } catch (error) {
      console.error("Error fetching visits & sales:", error);
      setVsError("Visits & Sales data load nahi ho paya. Please retry karein.");
      setVsStatus((prev) => (prev === "idle" || prev === "error" ? "error" : "cache"));
    } finally {
      setVsLoading(false);
    }
  };

  // 2. Fetch Customer Audit Trail
  const fetchCustomerAuditTrail = async () => {
    try {
      const formdata = new FormData();
      formdata.append("customer_id", "CMVC497B3A688");
      formdata.append("merchant_id", MERCHANT_ID);

      const response = await fetch("https://countmyvisit.com/Apis/customer_audit_trail.php", {
        method: "POST",
        body: formdata,
        redirect: "follow"
      });
      const resText = await response.text();
      console.log('hereis merchan', resText)
      const data = cleanAndParseJson(resText);
      if (data.success) {
        const customersData = data.customers || [];
        setCustomers(customersData);
        if (!isSearching) {
          localStorage.setItem(`audit_trail_${MERCHANT_ID}`, JSON.stringify(customersData));
        }
      }
    } catch (error) {
      console.error("Error fetching audit trail pools:", error);
    }
  };

  // 3. Fetch Customer Reviews & Ratings
  const fetchAllReviews = async () => {
    try {
      const formdata = new FormData();
      formdata.append("merchant_id", MERCHANT_ID);

      const response = await fetch("https://countmyvisit.com/Apis/get_reviews.php", {
        method: "POST",
        body: formdata,
        redirect: "follow"
      });
      const resText = await response.text();
      const data = cleanAndParseJson(resText);

      if (data.success) {
        setReviewsSummary({
          total_reviews: data.total_reviews || 0,
          average_rating: data.average_rating || 0
        });
        setAllReviews(data.reviews || []);

        localStorage.setItem(`reviews_summary_${MERCHANT_ID}`, JSON.stringify({
          total_reviews: data.total_reviews || 0,
          average_rating: data.average_rating || 0
        }));
        localStorage.setItem(`all_reviews_${MERCHANT_ID}`, JSON.stringify(data.reviews || []));
      }
    } catch (error) {
      console.error("Error fetching shopkeeper reviews:", error);
    }
  };

  // 4. Handle Live Search Filters
  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchMobile.trim()) {
      setIsSearching(false);
      const savedTrail = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
      if (savedTrail) {
        setCustomers(JSON.parse(savedTrail));
      } else {
        fetchCustomerAuditTrail();
      }
      return;
    }

    setIsSearching(true);
    try {
      const formdata = new FormData();
      formdata.append("merchant_id", MERCHANT_ID);
      formdata.append("mobile", searchMobile.trim());

      const response = await fetch(`https://countmyvisit.com/Apis/customer_search.php?mobile=${searchMobile.trim()}&merchant_id=${MERCHANT_ID}`, {
        method: "POST",
        body: formdata,
        redirect: "follow"
      });
      const resText = await response.text();
      const data = cleanAndParseJson(resText);

      if (data.success && data.customer) {
        const singleCustomer = {
          customer_id: data.customer.customer_id || "N/A",
          name: data.customer.name,
          mobile: data.customer.mobile,
          total_visits: data.customer.total_visits,
          used_rewards: data.customer.used_rewards,
          unused_rewards: data.customer.unused_rewards,
          loyalty_status: data.customer.loyalty_status
        };
        setCustomers([singleCustomer]);
      } else {
        setCustomers([]);
      }
    } catch (error) {
      console.error("Search pipeline fault:", error);
      setCustomers([]);
    }
  };

  // Open full details profile modal
  const openCustomerDetails = (customer) => {
    // Find matching rating/review if available for this specific user via customer_id or phone match fallback
    const matchedReview = allReviews.find(
      (r) => r.customer_id === customer.customer_id || r.mobile === customer.mobile
    );

    setSelectedCustomer({
      ...customer,
      rating: matchedReview ? matchedReview.rating : "No Rating Yet",
      review_text: matchedReview ? matchedReview.review : "No review message recorded for this user."
    });
    setIsModalOpen(true);
  };

  useEffect(() => {
    const triggerDataHydration = async () => {
      await Promise.all([fetchAnalytics(), fetchCustomerAuditTrail(), fetchAllReviews()]);
      setLoading(false);
    };
    triggerDataHydration();
    // Visits & Sales loads independently so it never blocks the rest of the page
    fetchVisitsSales();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [MERCHANT_ID]);

  // Close Visits & Sales popup with Escape key
  useEffect(() => {
    if (!detailPeriod) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setDetailPeriod(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [detailPeriod]);

  // Star Generator Utility
  const renderStars = (rating) => {
    if (isNaN(rating)) return "—";
    const count = Math.round(Number(rating || 0));
    return "★".repeat(count) + "☆".repeat(5 - count);
  };

  if (loading) {
    return (
      <div className="loader-container">
        <style>{`
          .loader-container { display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100vh; background: #f8fafc; color: #1e293b; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
          .spinner { width: 44px; height: 44px; border: 3px solid rgba(255, 140, 66, 0.1); border-left-color: #ff8c42; border-radius: 50%; animation: spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite; margin-bottom: 16px; }
          .loader-text { font-weight: 600; font-size: 14px; color: #64748b; letter-spacing: 0.5px; }
          @keyframes spin { to { transform: rotate(360deg); } }
        `}</style>
        <div className="spinner"></div>
        <p className="loader-text">SYNCING SECURE DATA PIECE...</p>
      </div>
    );
  }

  // ---------- Visits & Sales derived values (exact API fields, no mixing) ----------
  const activePeriodMeta = VS_PERIODS.find((p) => p.key === salesFilter) || VS_PERIODS[0];
  const activePeriod = vsData?.periods?.[salesFilter] || {};
  const vsCustomers = toNum(activePeriod.unique_customers);
  const vsVisits = toNum(vsData?.visits?.[salesFilter]);
  const vsSale = toNum(vsData?.sales?.[salesFilter]);
  const vsRetention = calcRetention(activePeriod);

  const statusMap = {
    live: { cls: "vs-status-live", text: "Live API Data" },
    cache: { cls: "vs-status-cache", text: "Saved Data (Offline)" },
    error: { cls: "vs-status-error", text: "API Error" },
    idle: { cls: "vs-status-loading", text: "Connecting..." }
  };
  const statusView = vsLoading && vsStatus !== "live"
    ? { cls: "vs-status-loading", text: vsData ? "Refreshing..." : "Loading..." }
    : statusMap[vsStatus] || statusMap.idle;

  // Popup renderer (Today / Week / Month)
  const renderVsModal = () => {
    const key = detailPeriod;
    const meta = VS_PERIODS.find((p) => p.key === key) || VS_PERIODS[0];
    const period = vsData?.periods?.[key] || {};
    const dailyRows = key === "today" ? [] : (vsData?.daily?.[key] || []);

    let items;
    if (key === "today") {
      items = [
        ["Date", vsData?.date || String(period.from || "").slice(0, 10) || "—"],
        ["Visits", toNum(vsData?.visits?.today)],
        ["Unique Customers", toNum(period.unique_customers)],
        ["New Customers", toNum(period.new_customers)],
        ["Returning Customers", toNum(period.returning_customers)],
        ["Bills", toNum(period.bills)],
        ["Bill Total", formatINR(period.bill_total)],
        ["Discount", formatINR(period.discount_total)],
        ["Sale", formatINR(vsData?.sales?.today)],
        ["From", period.from || "—"],
        ["To", period.to || "—"]
      ];
    } else {
      items = [
        ["Total Visits", toNum(vsData?.visits?.[key])],
        ["Unique Customers", toNum(period.unique_customers)],
        ["New Customers", toNum(period.new_customers)],
        ["Returning Customers", toNum(period.returning_customers)],
        ["Bills", toNum(period.bills)],
        ["Bill Total", formatINR(period.bill_total)],
        ["Discount", formatINR(period.discount_total)],
        ["Total Sale", formatINR(vsData?.sales?.[key])],
        ["Retention %", calcRetention(period)]
      ];
    }

    const rangeText = period.from
      ? `${String(period.from).slice(0, 10)}  →  ${dateMinusOne(period.to)}`
      : "—";

    return (
      <div className="vs-modal-overlay" onClick={() => setDetailPeriod(null)}>
        <div className="vs-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
          <div className="vs-modal-head">
            <button className="modal-close-btn" onClick={() => setDetailPeriod(null)} aria-label="Close">✕</button>
            <div className="modal-hero-title">
              {key === "today" ? "Today Performance" : `${meta.short} Performance`}
            </div>
            <div className="modal-hero-subtitle">
              {key === "today" ? `Date: ${vsData?.date || "—"}` : `Period: ${rangeText}`}
            </div>
          </div>

          <div className="vs-modal-body">
            <div className="vs-modal-grid">
              {items.map(([label, value]) => (
                <div className="vs-modal-item" key={label}>
                  <div className="insight-label">{label}</div>
                  <div className="vs-modal-value">{value}</div>
                </div>
              ))}
            </div>

            {key !== "today" && (
              <>
                <div className="vs-section-label">Daily Breakdown</div>
                {dailyRows.length === 0 ? (
                  <div className="empty-placeholder" style={{ padding: "24px" }}>No daily data available.</div>
                ) : (
                  <div className="vs-table-wrap">
                    <table className="vs-table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Day</th>
                          <th style={{ textAlign: "right" }}>Visits</th>
                          <th style={{ textAlign: "right" }}>Sale</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dailyRows.map((row, i) => (
                          <tr key={`${row.date}-${i}`}>
                            <td>{row.date}</td>
                            <td>{row.day}</td>
                            <td style={{ textAlign: "right" }}>{toNum(row.visits)}</td>
                            <td style={{ textAlign: "right", fontWeight: 700 }}>{formatINR(row.sale)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
        body { background: #f8fafc; color: #1e293b; -webkit-font-smoothing: antialiased; }
        .merchant-page { min-height: 100vh; padding: 24px; background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); position: relative; }
        
        /* SUBSCRIPTION PLATFORM SYSTEM WALL */
        .subscription-lock-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(241, 245, 249, 0.9); backdrop-filter: blur(16px); z-index: 9999; display: flex; justify-content: center; align-items: center; padding: 24px; }
        .lock-card { background: #ffffff; border: 1px solid #e2e8f0; padding: 40px; border-radius: 24px; max-width: 480px; width: 100%; text-align: center; box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08); }
        .lock-icon-box { width: 56px; height: 56px; background: #fee2e2; border-radius: 16px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px auto; color: #ef4444; }
        .lock-card h2 { font-size: 22px; font-weight: 800; color: #0f172a; margin-bottom: 10px; }
        .lock-card p { color: #64748b; font-size: 14px; line-height: 1.5; margin-bottom: 28px; }

        /* Subscription Alert Trackers */
        .sub-status-bar { display: flex; justify-content: space-between; align-items: center; padding: 14px 24px; border-radius: 16px; margin-bottom: 24px; font-weight: 600; font-size: 15px; box-shadow: 0 4px 15px rgba(0,0,0,0.02); gap: 12px; }
        .sub-active-bar { background: #ecfdf5; border: 1px solid #a7f3d0; color: #065f46; }
        .sub-expired-bar { background: #fef2f2; border: 1px solid #fecaca; color: #991b1b; }
        .sub-days-count { background: #10b981; color: white; padding: 4px 12px; border-radius: 20px; font-size: 13px; }
        
        /* Premium Dynamic Navigation Bar */
        .premium-nav { display: flex; justify-content: space-between; align-items: center; background: #ffffff; padding: 16px 32px; border-radius: 20px; box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.05); margin-bottom: 24px; border: 1px solid rgba(255, 255, 255, 0.8); }
        .nav-brand { font-size: 22px; font-weight: 800; background: linear-gradient(135deg, #ff8c42, #ff5e62); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
        .nav-btn { padding: 10px 20px; font-size: 14px; font-weight: 600; border-radius: 12px; cursor: pointer; transition: all 0.2s ease; border: none; display: flex; align-items: center; gap: 8px; }
        .btn-secondary-nav { background: #f1f5f9; color: #475569; }
        .btn-secondary-nav:hover { background: #e2e8f0; color: #0f172a; }

        /* Dashboard Top Info Card */
        .top-header { background: #ffffff; padding: 24px 30px; border-radius: 24px; box-shadow: 0 10px 30px rgba(0,0,0,0.02); display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; border-left: 6px solid #ff8c42; gap: 16px; }
        .merchant-title { font-size: 26px; font-weight: 800; color: #0f172a; }
        .merchant-sub { font-size: 14px; color: #64748b; margin-top: 4px; }
        .merchant-logo { width: 54px; height: 54px; border-radius: 16px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; display: flex; align-items: center; justify-content: center; font-size: 20px; font-weight: 700; box-shadow: 0 10px 20px rgba(255,94,98,0.2); flex-shrink: 0; }
        
        /* Grid Rules Layout */
        .main-grid { display: grid; grid-template-columns: 1fr; gap: 24px; }
        .metrics-summary-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 20px; margin-bottom: 4px; }

        .card { background: white; border-radius: 24px; padding: 24px; box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #e2e8f0; }
        .card h2 { font-size: 18px; margin-bottom: 6px; color: #0f172a; font-weight: 700; }
        .card p { color: #64748b; font-size: 13.5px; margin-bottom: 18px; }
        
        .metric-huge { font-size: 34px; font-weight: 800; color: #0f172a; letter-spacing: -1px; margin-bottom: 4px; }
        .metric-star-color { color: #f59e0b; }
        
        .metric-progress-track { background: #f1f5f9; height: 6px; border-radius: 10px; overflow: hidden; margin-top: 12px; }
        .metric-progress-bar { height: 100%; border-radius: 10px; transition: width 0.5s ease; }
        .bg-coral { background: linear-gradient(90deg, #ff8c42, #ff5e62); }
        .bg-gold { background: linear-gradient(90deg, #f59e0b, #eab308); }
        .bg-neutral-zero { background: #cbd5e1; width: 0% !important; }

        /* ================= VISITS & SALES SECTION ================= */
        .vs-section { background: #ffffff; border-radius: 24px; padding: 24px; border: 1px solid #e2e8f0; box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); margin-bottom: 24px; }
        .vs-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; flex-wrap: wrap; margin-bottom: 18px; }
        .vs-title { font-size: 20px; font-weight: 800; color: #0f172a; letter-spacing: -0.5px; }
        .vs-sub { font-size: 13px; color: #64748b; margin-top: 4px; }

        .vs-status { display: inline-flex; align-items: center; gap: 7px; font-size: 12px; font-weight: 700; padding: 6px 12px; border-radius: 100px; border: 1px solid transparent; white-space: nowrap; }
        .vs-dot { width: 8px; height: 8px; border-radius: 50%; background: currentColor; }
        .vs-status-live { background: #ecfdf5; color: #047857; border-color: #a7f3d0; }
        .vs-status-live .vs-dot { background: #10b981; animation: vsPulse 1.6s ease-in-out infinite; }
        .vs-status-cache { background: #fffbeb; color: #b45309; border-color: #fde68a; }
        .vs-status-error { background: #fef2f2; color: #b91c1c; border-color: #fecaca; }
        .vs-status-loading { background: #f1f5f9; color: #475569; border-color: #e2e8f0; }
        .vs-status-loading .vs-dot { animation: vsPulse 1s ease-in-out infinite; }

        .vs-toolbar { display: flex; justify-content: space-between; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 18px; }
        .vs-tabs { display: inline-flex; background: #f1f5f9; padding: 4px; border-radius: 14px; gap: 4px; }
        .vs-tab { border: none; background: transparent; padding: 9px 18px; border-radius: 10px; font-size: 13.5px; font-weight: 700; color: #64748b; cursor: pointer; transition: all 0.2s ease; white-space: nowrap; }
        .vs-tab:hover { color: #0f172a; }
        .vs-tab.active { background: #ffffff; color: #ea580c; box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08); }
        .vs-refresh-btn { border: 1px solid #e2e8f0; background: #ffffff; color: #475569; padding: 9px 16px; border-radius: 12px; font-size: 13px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; }
        .vs-refresh-btn:hover { background: #f8fafc; border-color: #cbd5e1; color: #0f172a; }
        .vs-refresh-btn:disabled { opacity: 0.6; cursor: not-allowed; }

        .vs-cards { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }
        .vs-card { background: #ffffff; border: 1px solid #e2e8f0; border-radius: 18px; padding: 18px; text-align: left; width: 100%; display: block; position: relative; min-width: 0; }
        .vs-card-click { cursor: pointer; transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease; }
        .vs-card-click:hover { transform: translateY(-3px); border-color: #ff8c42; box-shadow: 0 10px 24px rgba(255, 140, 66, 0.15); }
        .vs-card-click:active { transform: scale(0.98); }
        .vs-card-label { font-size: 12.5px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.4px; }
        .vs-card-value { font-size: 30px; font-weight: 800; color: #0f172a; letter-spacing: -1px; margin-top: 6px; word-break: break-word; }
        .vs-card-hint { font-size: 11.5px; font-weight: 700; color: #ea580c; margin-top: 6px; }
        .vs-card-hint-muted { color: #94a3b8; }

        .vs-summary { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-top: 16px; }
        .vs-summary-item { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 14px; padding: 12px 14px; }
        .vs-summary-value { font-size: 20px; font-weight: 800; color: #0f172a; margin-top: 2px; }

        .vs-detail-btns { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 16px; }
        .vs-detail-btn { border: 1px solid #fed7aa; background: #fff7ed; color: #c2410c; padding: 10px 16px; border-radius: 12px; font-size: 13px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; }
        .vs-detail-btn:hover { background: #ffedd5; transform: translateY(-1px); }

        .vs-error-box { display: flex; justify-content: space-between; align-items: center; gap: 12px; flex-wrap: wrap; background: #fef2f2; border: 1px solid #fecaca; color: #991b1b; padding: 12px 16px; border-radius: 14px; font-size: 13.5px; font-weight: 600; margin-bottom: 16px; }
        .vs-warn-box { background: #fffbeb; border: 1px solid #fde68a; color: #92400e; padding: 10px 14px; border-radius: 12px; font-size: 13px; font-weight: 600; margin-bottom: 16px; }
        .vs-retry-btn { border: none; background: #ef4444; color: #fff; padding: 8px 14px; border-radius: 10px; font-size: 13px; font-weight: 700; cursor: pointer; }

        .vs-skel { height: 104px; border-radius: 18px; background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 37%, #f1f5f9 63%); background-size: 400% 100%; animation: vsShimmer 1.4s ease infinite; }

        /* Visits & Sales popup */
        .vs-modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(15, 23, 42, 0.45); backdrop-filter: blur(8px); z-index: 10001; display: flex; justify-content: center; align-items: center; padding: 20px; }
        .vs-modal { background: #ffffff; width: 100%; max-width: 720px; max-height: 90vh; border-radius: 24px; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.2); border: 1px solid #e2e8f0; display: flex; flex-direction: column; overflow: hidden; animation: modalSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
        .vs-modal-head { background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%); color: white; padding: 22px 24px; position: relative; flex-shrink: 0; }
        .vs-modal-body { padding: 20px 24px 24px; overflow-y: auto; -webkit-overflow-scrolling: touch; flex: 1; min-height: 0; }
        .vs-modal-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }
        .vs-modal-item { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; padding: 12px 14px; min-width: 0; }
        .vs-modal-value { font-size: 16px; font-weight: 800; color: #0f172a; word-break: break-word; }
        .vs-section-label { font-size: 13px; font-weight: 800; color: #0f172a; text-transform: uppercase; letter-spacing: 0.5px; margin: 22px 0 10px; }
        .vs-table-wrap { border: 1px solid #e2e8f0; border-radius: 14px; overflow: auto; max-height: 340px; background: #ffffff; }
        .vs-table { min-width: 0; width: 100%; }
        .vs-table th { position: sticky; top: 0; z-index: 1; padding: 12px 16px; }
        .vs-table td { padding: 12px 16px; font-size: 13.5px; }

        /* Inputs Control styling */
        .search-engine-box { background: white; border-radius: 20px; padding: 20px; border: 1px solid #e2e8f0; margin-bottom: 4px; }
        .search-flex-row { display: flex; gap: 12px; }
        .input-group { flex: 1; }
        .input-group input { width: 100%; height: 48px; border: 1px solid #cbd5e1; background: #f8fafc; border-radius: 12px; padding: 0 16px; font-size: 14px; outline: none; transition: all 0.25s ease; }
        .input-group input:focus { background: white; border-color: #ff8c42; box-shadow: 0 0 0 4px rgba(255,140,66,0.15); }
        
        .save-btn { height: 48px; padding: 0 24px; border: none; border-radius: 12px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.2); white-space: nowrap; }
        .save-btn:hover { transform: translateY(-1px); opacity: 0.95; }
        
        /* Tables Core Engine */
        .table-container { overflow-x: auto; border-radius: 16px; border: 1px solid #e2e8f0; background: white; }
        table { width: 100%; border-collapse: collapse; min-width: 750px; text-align: left; }
        th { background: #f8fafc; color: #475569; padding: 14px 20px; font-size: 12px; font-weight: 700; border-bottom: 2px solid #e2e8f0; text-transform: uppercase; letter-spacing: 0.5px; }
        td { padding: 16px 20px; border-bottom: 1px solid #f1f5f9; color: #334155; font-size: 14px; }
        
        /* Clickable Row Animation Effect */
        .clickable-row { cursor: pointer; transition: all 0.2s ease; }
        .clickable-row:hover { background: #f0f4f8; transform: scale(0.998); }
        
        /* Badges & Actions UI */
        .badge { display: inline-block; padding: 4px 10px; border-radius: 20px; font-size: 12px; font-weight: 700; }
        .badge-neutral { background: #f1f5f9; color: #475569; }
        .badge-active { background: #ecfdf5; color: #047857; border: 1px solid #a7f3d0; }
        .badge-star { background: #fffbeb; color: #b45309; border: 1px solid #fde68a; font-family: monospace; }
        
        /* Store Reviews Panel Design Upgrades */
        .review-panel-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 16px; }
        .review-row-card { background: #ffffff; border: 1px solid #e2e8f0; padding: 18px; border-radius: 16px; display: flex; flex-direction: column; justify-content: space-between; box-shadow: 0 4px 12px rgba(0,0,0,0.01); }
        .review-header-flex { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
        .review-user-name { font-weight: 700; color: #0f172a; font-size: 14px; }
        .review-user-phone { font-size: 12px; color: #94a3b8; font-family: monospace; }
        .review-text-content { font-size: 13.5px; color: #475569; line-height: 1.5; font-style: italic; margin-bottom: 12px; }
        .review-stars-indicator { color: #f59e0b; font-size: 13px; font-weight: bold; }

        /* ABSOLUTE MODAL PROFILE POPUP DESIGN */
        .modal-blur-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(15, 23, 42, 0.4); backdrop-filter: blur(8px); z-index: 10000; display: flex; justify-content: center; align-items: center; padding: 20px; }
        .modal-profile-box { background: #ffffff; width: 100%; max-width: 520px; border-radius: 24px; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15); border: 1px solid #e2e8f0; overflow: hidden; animation: modalSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
        .modal-hero-header { background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%); color: white; padding: 24px; position: relative; }
        .modal-hero-title { font-size: 20px; font-weight: 800; margin-bottom: 4px; letter-spacing: -0.3px; }
        .modal-hero-subtitle { color: #94a3b8; font-size: 13px; font-family: monospace; }
        .modal-close-btn { position: absolute; top: 22px; right: 22px; background: rgba(255, 255, 255, 0.1); border: none; color: white; width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 16px; font-weight: bold; transition: background 0.2s; }
        .modal-close-btn:hover { background: rgba(255, 255, 255, 0.2); }
        
        .modal-body-content { padding: 24px; }
        .modal-insights-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin-bottom: 20px; }
        .insight-data-card { background: #f8fafc; border: 1px solid #e2e8f0; padding: 14px; border-radius: 12px; }
        .insight-label { font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px; }
        .insight-value { font-size: 16px; font-weight: 800; color: #0f172a; }
        
        .modal-rating-segment { background: #fffbeb; border: 1px solid #fde68a; border-radius: 14px; padding: 16px; }
        .modal-rating-stars { color: #f59e0b; font-size: 16px; margin-bottom: 6px; font-weight: bold; }
        .modal-review-msg { font-size: 13.5px; color: #b45309; font-style: italic; line-height: 1.5; }

        .empty-placeholder { padding: 40px; text-align: center; color: #94a3b8; font-size: 14px; font-weight: 500; }

        @keyframes modalSlideUp {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes vsPulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.45; transform: scale(0.8); }
        }
        @keyframes vsShimmer {
          0% { background-position: 100% 50%; }
          100% { background-position: 0 50%; }
        }

        /* TABLET: Visits & Sales */
        @media(max-width: 1024px) {
          .vs-cards { grid-template-columns: repeat(2, 1fr); }
        }

        /* MOBILE RESPONSIVE OPTIMIZATION OVERRIDES */
        @media(max-width: 768px) {
          .merchant-page { padding: 14px; }
          .premium-nav { padding: 14px 20px; flex-direction: column; gap: 12px; text-align: center; }
          .top-header { padding: 18px; flex-direction: column; text-align: center; }
          .search-flex-row { flex-direction: column; gap: 10px; }
          .save-btn { width: 100%; }
          .metrics-summary-row { grid-template-columns: 1fr 1fr; gap: 12px; }
          .metric-huge { font-size: 26px; }
          .card { padding: 16px; border-radius: 18px; }
          .modal-insights-grid { grid-template-columns: 1fr; gap: 10px; }
          .sub-status-bar { flex-direction: column; text-align: center; font-size: 13px; padding: 12px; }

          .vs-section { padding: 16px; border-radius: 18px; }
          .vs-cards { gap: 12px; }
          .vs-card { padding: 14px; border-radius: 14px; }
          .vs-card-value { font-size: 24px; }
          .vs-summary { grid-template-columns: repeat(2, 1fr); gap: 10px; }
          .vs-tabs { width: 100%; }
          .vs-tab { flex: 1; padding: 9px 8px; font-size: 13px; }
          .vs-detail-btn { flex: 1 1 100%; text-align: center; }
          .vs-modal-overlay { padding: 10px; align-items: flex-end; }
          .vs-modal { max-height: 92vh; border-radius: 20px; }
          .vs-modal-body { padding: 16px; }
          .vs-modal-grid { grid-template-columns: repeat(2, 1fr); gap: 10px; }
        }

        @media(max-width: 360px) {
          .vs-cards { grid-template-columns: 1fr; }
          .vs-modal-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      {/* SUBSCRIPTION SECURITY LOCK OVERLAY */}
      {!isSubscribed && (
        <div className="subscription-lock-overlay">
          <div className="lock-card">
            <div className="lock-icon-box">
              <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
            <h2>Premium Subscription Locked</h2>
            <p>Your current merchant plan activation status is inactive. Please process plan validation to access telemetry logs and analytics data.</p>
            <button className="save-btn" style={{ width: '100%' }} onClick={() => alert("Initiating Core Payment Gateway...")}>
              Activate Premium Plan
            </button>
          </div>
        </div>
      )}

      {/* DYNAMIC FULL INSIGHT CUSTOMER PROFILE POPUP (MODAL) */}
      {isModalOpen && selectedCustomer && (
        <div className="modal-blur-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-profile-box" onClick={(e) => e.stopPropagation()}>
            <div className="modal-hero-header">
              <button className="modal-close-btn" onClick={() => setIsModalOpen(false)}>✕</button>
              <div className="modal-hero-title">{selectedCustomer.name || "Anonymous Member"}</div>
              <div className="modal-hero-subtitle">ID: {selectedCustomer.customer_id || "N/A"}</div>
            </div>

            <div className="modal-body-content">
              <div className="modal-insights-grid">
                <div className="insight-data-card">
                  <div className="insight-label">Mobile Number</div>
                  <div className="insight-value">{selectedCustomer.mobile || "—"}</div>
                </div>
                <div className="insight-data-card">
                  <div className="insight-label">Loyalty Tier Standing</div>
                  <div className="insight-value" style={{ color: '#ff8c42' }}>{selectedCustomer.loyalty_status || "Standard Tier"}</div>
                </div>
                <div className="insight-data-card">
                  <div className="insight-label">Total Visits</div>
                  <div className="insight-value">{selectedCustomer.total_visits || 0} Engagement Logs</div>
                </div>
                <div className="insight-data-card">
                  <div className="insight-label">Total Visits</div>
                  <div className="insight-value">{selectedCustomer.total_visits || 0} Engagement Logs</div>
                </div>
                <div className="insight-data-card">
                  <div className="insight-label">Claimed vs Unused Rewards</div>
                  <div className="insight-value" style={{ fontSize: '14px' }}>
                    <span style={{ color: '#10b981' }}>{selectedCustomer.used_rewards || 0} Used</span> / <span style={{ color: '#ff8c42' }}>{selectedCustomer.unused_rewards || 0} Pending</span>
                  </div>
                </div>
              </div>

              {/* Verified Customer Feedback Engine Section */}
              <div className="modal-rating-segment">
                <div className="insight-label" style={{ color: '#b45309' }}>Storefront Feedback Assessment</div>
                <div className="modal-rating-stars">
                  {isNaN(selectedCustomer.rating) ? "No Star Rating" : renderStars(selectedCustomer.rating)}
                  <span style={{ fontSize: '12px', color: '#64748b', marginLeft: '6px' }}>({selectedCustomer.rating})</span>
                </div>
                <p className="modal-review-msg">"{selectedCustomer.review_text}"</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* VISITS & SALES DETAIL POPUP (Today / Week / Month) */}
      {detailPeriod && vsData && renderVsModal()}

      <div className="merchant-page">

        {/* PREMIUM NAVIGATION */}
        <nav className="premium-nav">
          <div className="nav-logo-side">
            <span className="nav-brand">CountMyVisit</span>
          </div>
          <div className="nav-actions">
            <span className="badge badge-neutral" style={{ fontFamily: 'monospace' }}>ID: {MERCHANT_ID}</span>
          </div>
        </nav>

        {/* STATUS ACCELERATOR BAR */}
        <div className={`sub-status-bar ${isSubscribed ? "sub-active-bar" : "sub-expired-bar"}`}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span className="sub-days-count">{isSubscribed ? "Active" : "Locked"}</span>
            <span>Premium Merchant Analytics Channel Stream</span>
          </div>
        </div>

        {/* TOP COMPONENT HEADER */}
        <header className="top-header">
          <div>
            <div className="merchant-title">Merchant Dashboard Logs</div>
            <div className="merchant-sub">Operational metrics, real-time reviews, and visitor profiles</div>
          </div>
          <div className="merchant-logo">M</div>
        </header>

        {/* ================= VISITS & SALES SECTION ================= */}
        <section className="vs-section">
          <div className="vs-head">
            <div>
              <h2 className="vs-title">Visits &amp; Sales</h2>
              <p className="vs-sub">
                {vsData?.date ? `Report date: ${vsData.date} · ` : ""}
                Customers, visits and sales for the selected period
              </p>
            </div>
            <span className={`vs-status ${statusView.cls}`}>
              <span className="vs-dot"></span>
              {statusView.text}
            </span>
          </div>

          <div className="vs-toolbar">
            <div className="vs-tabs" role="tablist">
              {VS_PERIODS.map((p) => (
                <button
                  key={p.key}
                  type="button"
                  role="tab"
                  aria-selected={salesFilter === p.key}
                  className={`vs-tab ${salesFilter === p.key ? "active" : ""}`}
                  onClick={() => setSalesFilter(p.key)}
                >
                  {p.label}
                </button>
              ))}
            </div>
            <button
              type="button"
              className="vs-refresh-btn"
              onClick={fetchVisitsSales}
              disabled={vsLoading}
            >
              {vsLoading ? "Refreshing..." : "↻ Refresh"}
            </button>
          </div>

          {/* Error states */}
          {vsStatus === "error" && !vsData && (
            <div className="vs-error-box">
              <span>⚠️ {vsError || "Visits & Sales data unavailable."}</span>
              <button type="button" className="vs-retry-btn" onClick={fetchVisitsSales}>Retry</button>
            </div>
          )}
          {vsStatus === "cache" && vsError && (
            <div className="vs-warn-box">
              ⚠️ Fresh data load nahi hua - last saved data dikh raha hai.
            </div>
          )}

          {/* Loading skeleton (first load, no cache) */}
          {vsLoading && !vsData ? (
            <div className="vs-cards">
              {[0, 1, 2, 3].map((i) => (
                <div className="vs-skel" key={i}></div>
              ))}
            </div>
          ) : vsData ? (
            <>
              <div className="vs-cards">
                {/* 1. Total Customers -> periods[selected].unique_customers */}
                <div className="vs-card">
                  <div className="vs-card-label">Total Customers</div>
                  <div className="vs-card-value">{vsCustomers}</div>
                  <div className="vs-card-hint vs-card-hint-muted">{activePeriodMeta.label}</div>
                </div>

                {/* 2. Visits -> visits[selected] (clickable) */}
                <button
                  type="button"
                  className="vs-card vs-card-click"
                  onClick={() => setDetailPeriod(salesFilter)}
                >
                  <div className="vs-card-label">{activePeriodMeta.short} Visits</div>
                  <div className="vs-card-value">{vsVisits}</div>
                  <div className="vs-card-hint">View details →</div>
                </button>

                {/* 3. Sale -> sales[selected] (clickable) */}
                <button
                  type="button"
                  className="vs-card vs-card-click"
                  onClick={() => setDetailPeriod(salesFilter)}
                >
                  <div className="vs-card-label">{activePeriodMeta.short} Sale</div>
                  <div className="vs-card-value">{formatINR(vsSale)}</div>
                  <div className="vs-card-hint">View details →</div>
                </button>

                {/* 4. Average Rating -> existing reviews API (unchanged) */}
                <div className="vs-card">
                  <div className="vs-card-label">Average Rating</div>
                  <div className="vs-card-value metric-star-color">
                    {reviewsSummary.average_rating} <span style={{ fontSize: '20px' }}>★</span>
                  </div>
                  <div className="metric-progress-track" style={{ marginTop: '10px' }}>
                    <div className="metric-progress-bar bg-gold" style={{ width: `${Math.min(100, (toNum(reviewsSummary.average_rating) / 5) * 100)}%` }}></div>
                  </div>
                </div>
              </div>

              {/* Additional summary for selected period */}
              <div className="vs-summary">
                <div className="vs-summary-item">
                  <div className="insight-label">New Customers</div>
                  <div className="vs-summary-value">{toNum(activePeriod.new_customers)}</div>
                </div>
                <div className="vs-summary-item">
                  <div className="insight-label">Returning Customers</div>
                  <div className="vs-summary-value">{toNum(activePeriod.returning_customers)}</div>
                </div>
                <div className="vs-summary-item">
                  <div className="insight-label">Bills</div>
                  <div className="vs-summary-value">{toNum(activePeriod.bills)}</div>
                </div>
                <div className="vs-summary-item">
                  <div className="insight-label">Retention %</div>
                  <div className="vs-summary-value">{vsRetention}</div>
                </div>
              </div>

              <div className="vs-detail-btns">
                {VS_PERIODS.map((p) => (
                  <button
                    key={p.key}
                    type="button"
                    className="vs-detail-btn"
                    onClick={() => setDetailPeriod(p.key)}
                  >
                    📊 {p.detailLabel}
                  </button>
                ))}
              </div>
            </>
          ) : null}
        </section>

        {/* SEARCH FILTER INTEGRATION BOX */}
        <div className="search-engine-box">
          <form onSubmit={handleSearch} className="search-flex-row">
            <div className="input-group">
              <input
                type="text"
                placeholder="Search precise customer profile logs via mobile number..."
                value={searchMobile}
                onChange={(e) => setSearchMobile(e.target.value)}
              />
            </div>
            <button type="submit" className="save-btn">Query System Logs</button>
            {isSearching && (
              <button
                type="button"
                className="nav-btn btn-secondary-nav"
                onClick={() => {
                  setSearchMobile("");
                  setIsSearching(false);
                  const savedTrail = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
                  if (savedTrail) {
                    setCustomers(JSON.parse(savedTrail));
                  } else {
                    fetchCustomerAuditTrail();
                  }
                }}
              >
                Reset
              </button>
            )}
          </form>
        </div>

        {/* CORE WORKSPACE GRID */}
        <main className="main-grid" style={{
          display: "flex",
          flexDirection: "column",
          gap: "28px",
          padding: "16px",
          maxWidth: "1280px",
          width: "100%",
          margin: "0 auto",
          boxSizing: "border-box",
          fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          background: "#f8fafc"
        }}>

          {/* CSS Styles injection for total responsiveness */}
          <style>{`
    /* Global Card Structure */
    .custom-dashboard-card {
      background: #ffffff;
      border-radius: 24px;
      padding: 24px;
      border: 1px solid #e2e8f0;
      box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.01), 0 8px 10px -6px rgba(0, 0, 0, 0.01);
    }
    
    .card-header-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 16px;
      margin-bottom: 20px;
    }

    .card-title {
      font-size: 20px;
      font-weight: 800;
      color: #0f172a;
      margin: 0;
      letter-spacing: -0.5px;
    }

    .card-subtitle {
      font-size: 13.5px;
      color: #64748b;
      margin: 4px 0 0 0;
      line-height: 1.5;
    }

    /* Unified Response Grids */
    .dynamic-dashboard-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr); /* Computer / Desktop: 4 Columns */
      gap: 16px;
      max-height: 520px;
      overflow-y: auto;
      padding-right: 6px;
      padding-bottom: 6px;
    }

    /* Modern Minimalist Scrollbar */
    .dynamic-dashboard-grid::-webkit-scrollbar {
      width: 6px;
    }
    .dynamic-dashboard-grid::-webkit-scrollbar-track {
      background: #f1f5f9;
      border-radius: 8px;
    }
    .dynamic-dashboard-grid::-webkit-scrollbar-thumb {
      background: #cbd5e1;
      border-radius: 8px;
    }
    .dynamic-dashboard-grid::-webkit-scrollbar-thumb:hover {
      background: #94a3b8;
    }

    /* Audit Customer Clickable Card Item */
    .audit-profile-card {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 16px;
      padding: 16px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      cursor: pointer;
      transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
    }
    .audit-profile-card:hover {
      transform: translateY(-2px);
      border-color: #cbd5e1;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
    }

    /* Utilities & Badges */
    .status-pill {
      display: inline-flex;
      align-items: center;
      padding: 4px 10px;
      border-radius: 8px;
      font-size: 12px;
      font-weight: 600;
    }
    .status-pill-active { background: #e0f2fe; color: #0369a1; }
    .status-pill-neutral { background: #f1f5f9; color: #475569; }

    .reward-box {
      background: #f8fafc;
      border-radius: 10px;
      padding: 8px 12px;
      text-align: center;
      flex: 1;
      border: 1px solid #f1f5f9;
    }

    /* ================= BREAKPOINTS (Laptop, Tab, Mobile) ================= */

    @media (max-width: 1120px) {
      .dynamic-dashboard-grid {
        grid-template-columns: repeat(3, 1fr) !important; /* 3 Columns on smaller screens */
      }
    }

    @media (max-width: 768px) {
      .custom-dashboard-card { padding: 20px; }
      .dynamic-dashboard-grid {
        grid-template-columns: repeat(2, 1fr) !important; /* 2 Columns on Tablet */
        gap: 12px;
        max-height: 460px;
      }
    }

    @media (max-width: 480px) {
      .custom-dashboard-card { padding: 16px; border-radius: 16px; }
      .card-header-wrapper { flex-direction: column; align-items: stretch; gap: 10px; }
      .mobile-full-badge { width: 100%; text-align: center; justify-content: center; }
      .dynamic-dashboard-grid {
        grid-template-columns: 1fr !important; /* 1 Column on Mobile Phones */
        max-height: 400px;
        gap: 12px;
      }
    }

    * {
  -webkit-user-select: none;  /* Safari */
  -moz-user-select: none;     /* Firefox */
  -ms-user-select: none;      /* IE10+ */
  user-select: none;          /* Standard */
  -webkit-user-drag: none;    /* इमेजेस या एलिमेंट्स को ड्रैग करने से रोकने के लिए */
}
  `}</style>

          {/* ================= SECTION 1: CUSTOMER AUDIT LOG (UPDATED TO GRID CARDS) ================= */}
          <div className="custom-dashboard-card">
            <div className="card-header-wrapper">
              <div>
                <h2 className="card-title">
                  {isSearching ? "Filtered Profile Results" : "Customer Retention Audit Log"}
                </h2>
                <p className="card-subtitle">
                  Active live visitor parameters database map metrics. <span style={{ color: "#4f46e5", fontWeight: "600" }}>👉  </span>
                </p>
              </div>
            </div>

            {!customers || customers.length === 0 ? (
              <div style={{ textAlign: "center", padding: "50px 20px", color: "#94a3b8", background: "#f8fafc", borderRadius: "16px", border: "1px dashed #cbd5e1", fontSize: "14px", fontWeight: "600" }}>
                📭 No target logs mapped under the specified query pipeline.
              </div>
            ) : (
              <div className="dynamic-dashboard-grid">
                {customers.map((item, idx) => (
                  <div
                    key={idx}
                    className="audit-profile-card"
                    onClick={() => openCustomerDetails && openCustomerDetails(item)}
                  >
                    {/* Top Row: Avatar + Name + Tier */}
                    <div>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px", gap: "8px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0 }}>
                          <div style={{ width: "32px", height: "32px", borderRadius: "50%", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "13px", fontWeight: "700", color: "#475569", flexShrink: 0 }}>
                            {(item.name || "A")[0].toUpperCase()}
                          </div>
                          <div style={{ minWidth: 0 }}>
                            <div style={{ fontSize: "14px", fontWeight: "700", color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {item.name || "Anonymous Member"}
                            </div>
                            <div style={{ fontSize: "11px", fontFamily: "monospace", color: "#64748b", marginTop: "1px" }}>
                              {item.mobile || "—"}
                            </div>
                          </div>
                        </div>
                      </div>
                      Retention
                      {/* Middle Row: Engagement Level */}
                      <div style={{ marginBottom: "14px" }}>
                        <span className={`status-pill ${Number(item.total_visits) > 0 ? "status-pill-active" : "status-pill-neutral"}`}>
                          📌 {item.total_visits || 0} Engagement Visits
                        </span>
                      </div>
                    </div>

                    {/* Bottom Row: Rewards Visual Split & Loyalty Badge */}
                    <div style={{ borderTop: "1px dashed #e2e8f0", paddingTop: "12px", marginTop: "auto" }}>
                      <div style={{ display: "flex", gap: "8px", marginBottom: "10px" }}>
                        <div className="reward-box">
                          <div style={{ fontSize: "10px", fontWeight: "600", color: "#64748b", textTransform: "uppercase" }}>Unused</div>
                          <div style={{ fontSize: "15px", fontWeight: "800", color: Number(item.unused_rewards) > 0 ? "#ea580c" : "#94a3b8", marginTop: "2px" }}>
                            {item.unused_rewards || 0}
                          </div>
                        </div>
                        <div className="reward-box">
                          <div style={{ fontSize: "10px", fontWeight: "600", color: "#64748b", textTransform: "uppercase" }}>Claimed</div>
                          <div style={{ fontSize: "15px", fontWeight: "800", color: Number(item.used_rewards) > 0 ? "#16a34a" : "#94a3b8", marginTop: "2px" }}>
                            {item.used_rewards || 0}
                          </div>
                        </div>
                      </div>

                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span style={{ fontSize: "11px", color: "#94a3b8", fontWeight: "500" }}>Standing Status</span>
                        <span style={{ fontSize: "11px", fontWeight: "700", background: "#f8fafc", padding: "3px 8px", borderRadius: "6px", border: "1px solid #e2e8f0", color: "#334155" }}>
                          {item.loyalty_status || "Standard Tier"}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>


          {/* ================= SECTION 2: TESTIMONIALS STREAM ================= */}
          <div className="custom-dashboard-card">
            <div className="card-header-wrapper">
              <div>
                <h2 className="card-title">Storefront Testimonials Stream</h2>
                <p className="card-subtitle">Live storefront testimonials and verified metrics streaming instantly.</p>
              </div>
              <span className="mobile-full-badge" style={{
                display: "inline-flex",
                alignItems: "center",
                fontSize: "13px",
                fontWeight: "700",
                background: "#fef9c3",
                color: "#854d0e",
                padding: "6px 14px",
                borderRadius: "100px",
                whiteSpace: "nowrap",
                border: "1px solid #fef08a",
                alignSelf: "flex-start"
              }}>
                ⭐ {reviewsSummary?.total_reviews || 0} Feedbacks
              </span>
            </div>

            {!allReviews || allReviews.length === 0 ? (
              <div style={{ textAlign: "center", padding: "50px 20px", color: "#94a3b8", background: "#f8fafc", borderRadius: "16px", border: "1px dashed #cbd5e1", fontSize: "14px", fontWeight: "600" }}>
                📭 No store ratings or customer feedback parsed yet.
              </div>
            ) : (
              <div className="dynamic-dashboard-grid">
                {allReviews.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      background: "#ffffff",
                      borderRadius: "16px",
                      padding: "16px",
                      border: "1px solid #e2e8f0",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      minHeight: "150px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.01)"
                    }}
                  >
                    <div>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px", gap: "8px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", minWidth: 0 }}>
                          <div style={{ width: "28px", height: "28px", borderRadius: "50%", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", fontWeight: "700", color: "#64748b", flexShrink: 0 }}>
                            {(item.customer_name || "A")[0].toUpperCase()}
                          </div>
                          <span style={{ fontSize: "14px", fontWeight: "700", color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {item.customer_name || "Anonymous Guest"}
                          </span>
                        </div>
                        <span style={{
                          fontSize: "10px",
                          fontWeight: "600",
                          color: "#64748b",
                          background: "#f8fafc",
                          padding: "3px 8px",
                          borderRadius: "6px",
                          border: "1px solid #e2e8f0",
                          whiteSpace: "nowrap",
                          flexShrink: 0
                        }}>
                          {item.mobile ? `+91 ${item.mobile}` : "System Log"}
                        </span>
                      </div>

                      <p style={{ fontSize: "13px", margin: "0 0 16px 0", lineHeight: "1.5", color: "#475569", fontStyle: "italic" }}>
                        "{item.review || "No custom log commentary written."}"
                      </p>
                    </div>

                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderTop: "1px dashed #f1f5f9",
                      paddingTop: "12px",
                      marginTop: "auto"
                    }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                        {typeof renderStars === 'function' && renderStars(item.rating)}
                      </div>
                      <span style={{ fontSize: "11px", fontWeight: "700", color: "#475569", background: "#f1f5f9", padding: "2px 6px", borderRadius: "4px" }}>
                        {item.rating} / 5
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

        </main>
      </div>
    </>
  );
}

// import React, { useState, useEffect } from "react";
 
// export default function MerchantFeedbackLog() {
//   // Extract Dynamic Merchant ID safely
  
// const getDynamicMerchantId = () => {
//     try {
//       const savedDataString = localStorage.getItem("marchentdata");
//       if (savedDataString) {
//         const cleanDataStr = savedDataString.replace("DATABASE CONNECTED", "").trim();
//         const parsed = JSON.parse(cleanDataStr);
//         if (parsed?.merchant?.user_id) {
//           return parsed.merchant.user_id;
//         }
//       }
//     } catch (e) {
//       console.error("Error reading initial userData from localStorage:", e);
//     }
//     return "CMV9A117EAC";
//   };
 
//   const MERCHANT_ID = getDynamicMerchantId();

//   // Subscription Control State
//   const [isSubscribed, setIsSubscribed] = useState(true);

//   // Naya Filter State: 'today', 'week', ya 'month' select karne ke liye
//   const [salesFilter, setSalesFilter] = useState("today");
   
//   // States initialized matching your exact flat API keys
//   const [analytics, setAnalytics] = useState(() => {
//     const saved = localStorage.getItem(`analytics_${MERCHANT_ID}`);
//     console.log('here is details',saved)
//     return saved ? JSON.parse(saved) : {
//       success: false,
//       plan_name: "",
//       plan_status: "",
//       total_customers: 0,
//       returning_customers: 0,
//       new_customers: 0,
//       returning_ratio: "0%",
//       total_visits: 0,
//       today_visits: 0,
//       redeemed_rewards: 0,
//       sales_today: 0,
//       sales_week: 0,
//       sales_month: 0,
//       sales_lifetime: 0,
//       sales_average: 0,
//       recent_sales: []
//     };
//   });

//   const [customers, setCustomers] = useState(() => {
//     const saved = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : [];
//   });

//   const [reviewsSummary, setReviewsSummary] = useState(() => {
//     const saved = localStorage.getItem(`reviews_summary_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : { total_reviews: 0, average_rating: 0 };
//   });

//   const [allReviews, setAllReviews] = useState(() => {
//     const saved = localStorage.getItem(`all_reviews_${MERCHANT_ID}`);
//     return saved ? JSON.parse(saved) : [];
//   });

//   const [searchMobile, setSearchMobile] = useState("");
//   const [isSearching, setIsSearching] = useState(false);

//   // Modal Control States for Active Customer Details
//   const [selectedCustomer, setSelectedCustomer] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const [loading, setLoading] = useState(() => {
//     const cacheExists = localStorage.getItem(`analytics_${MERCHANT_ID}`);
//     return !cacheExists;
//   });

//   const cleanAndParseJson = (text) => {
//     const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//     return JSON.parse(cleanString);
//   };

//   // 1. Fetch Dashboard Analytics Engine
//   const fetchAnalytics = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/merchant_dashboard_analytics.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       console.log('hereis merchan',resText)
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         if (data.plan_status === "inactive" || data.is_subscribed === false) {
//           setIsSubscribed(false);
//         } else {
//           setIsSubscribed(true);
//         }
//         setAnalytics(data);
//         localStorage.setItem(`analytics_${MERCHANT_ID}`, JSON.stringify(data));
//       }
//     } catch (error){
//       console.error("Error fetching analytics metrics:", error);
//     } 
//   }; 

//   // 2. Fetch Customer Audit Trail
//   const fetchCustomerAuditTrail = async () => {
//     try {
//       const formdata = new FormData( );
//       formdata.append("customer_id", "CMVC497B3A688");
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/customer_audit_trail.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow" 
//       }); 
//       const resText = await response.text();
//       console.log('hereis merchan',resText)
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         const customersData = data.customers || [];
//         setCustomers(customersData);
//         if (!isSearching) {
//           localStorage.setItem(`audit_trail_${MERCHANT_ID}`, JSON.stringify(customersData));
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching audit trail pools:", error);
//     }
//   };

//   // 3. Fetch Customer Reviews & Ratings
//   const fetchAllReviews = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);

//       const response = await fetch("https://countmyvisit.com/Apis/get_reviews.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         setReviewsSummary({
//           total_reviews: data.total_reviews || 0,
//           average_rating: data.average_rating || 0
//         }); 
//         setAllReviews(data.reviews || []);

//         localStorage.setItem(`reviews_summary_${MERCHANT_ID}`, JSON.stringify({
//           total_reviews: data.total_reviews || 0,
//           average_rating: data.average_rating || 0
//         }));
//         localStorage.setItem(`all_reviews_${MERCHANT_ID}`, JSON.stringify(data.reviews || []));
//       }
//     } catch (error) {
//       console.error("Error fetching shopkeeper reviews:", error);
//     }
//   };

//   // 4. Handle Live Search Filters
//   const handleSearch = async (e) => {
//     e.preventDefault();
//     if (!searchMobile.trim()) {
//       setIsSearching(false);
//       const savedTrail = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//       if (savedTrail) {
//         setCustomers(JSON.parse(savedTrail));
//       } else {
//         fetchCustomerAuditTrail();
//       }
//       return;
//     }

//     setIsSearching(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       formdata.append("mobile", searchMobile.trim());

//       const response = await fetch(`https://countmyvisit.com/Apis/customer_search.php?mobile=${searchMobile.trim()}&merchant_id=${MERCHANT_ID}`, {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success && data.customer) {
//         const singleCustomer = {
//           customer_id: data.customer.customer_id || "N/A",
//           name: data.customer.name,
//           mobile: data.customer.mobile,
//           total_visits: data.customer.total_visits,
//           used_rewards: data.customer.used_rewards,
//           unused_rewards: data.customer.unused_rewards,
//           loyalty_status: data.customer.loyalty_status
//         };
//         setCustomers([singleCustomer]);
//       } else {
//         setCustomers([]);
//       }
//     } catch (error) {
//       console.error("Search pipeline fault:", error);
//       setCustomers([]);
//     }
//   };

//   // Open full details profile modal
//   const openCustomerDetails = (customer) => {
//     // Find matching rating/review if available for this specific user via customer_id or phone match fallback
//     const matchedReview = allReviews.find(
//       (r) => r.customer_id === customer.customer_id || r.mobile === customer.mobile
//     );

//     setSelectedCustomer({
//       ...customer,
//       rating: matchedReview ? matchedReview.rating : "No Rating Yet",
//       review_text: matchedReview ? matchedReview.review : "No review message recorded for this user."
//     });
//     setIsModalOpen(true);
//   };

//   useEffect(() => {
//     const triggerDataHydration = async () => {
//       await Promise.all([fetchAnalytics(), fetchCustomerAuditTrail(), fetchAllReviews()]);
//       setLoading(false);
//     };
//     triggerDataHydration();
//   }, [MERCHANT_ID]);

//   // Star Generator Utility
//   const renderStars = (rating) => {
//     if (isNaN(rating)) return "—";
//     const count = Math.round(Number(rating || 0));
//     return "★".repeat(count) + "☆".repeat(5 - count);
//   };

//   if (loading) {
//     return (
//       <div className="loader-container">
//         <style>{`
//           .loader-container { display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100vh; background: #f8fafc; color: #1e293b; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
//           .spinner { width: 44px; height: 44px; border: 3px solid rgba(255, 140, 66, 0.1); border-left-color: #ff8c42; border-radius: 50%; animation: spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite; margin-bottom: 16px; }
//           .loader-text { font-weight: 600; font-size: 14px; color: #64748b; letter-spacing: 0.5px; }
//           @keyframes spin { to { transform: rotate(360deg); } }
//         `}</style>
//         <div className="spinner"></div>
//         <p className="loader-text">SYNCING SECURE DATA PIECE...</p>
//       </div>
//     );
//   }

//   return (
//     <>
//       <style>{`
//         * { margin: 0; padding: 0; box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
//         body { background: #f8fafc; color: #1e293b; -webkit-font-smoothing: antialiased; }
//         .merchant-page { min-height: 100vh; padding: 24px; background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); position: relative; }
        
//         /* SUBSCRIPTION PLATFORM SYSTEM WALL */
//         .subscription-lock-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(241, 245, 249, 0.9); backdrop-filter: blur(16px); z-index: 9999; display: flex; justify-content: center; align-items: center; padding: 24px; }
//         .lock-card { background: #ffffff; border: 1px solid #e2e8f0; padding: 40px; border-radius: 24px; max-width: 480px; width: 100%; text-align: center; box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08); }
//         .lock-icon-box { width: 56px; height: 56px; background: #fee2e2; border-radius: 16px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px auto; color: #ef4444; }
//         .lock-card h2 { font-size: 22px; font-weight: 800; color: #0f172a; margin-bottom: 10px; }
//         .lock-card p { color: #64748b; font-size: 14px; line-height: 1.5; margin-bottom: 28px; }

//         /* Subscription Alert Trackers */
//         .sub-status-bar { display: flex; justify-content: space-between; align-items: center; padding: 14px 24px; border-radius: 16px; margin-bottom: 24px; font-weight: 600; font-size: 15px; box-shadow: 0 4px 15px rgba(0,0,0,0.02); gap: 12px; }
//         .sub-active-bar { background: #ecfdf5; border: 1px solid #a7f3d0; color: #065f46; }
//         .sub-expired-bar { background: #fef2f2; border: 1px solid #fecaca; color: #991b1b; }
//         .sub-days-count { background: #10b981; color: white; padding: 4px 12px; border-radius: 20px; font-size: 13px; }
        
//         /* Premium Dynamic Navigation Bar */
//         .premium-nav { display: flex; justify-content: space-between; align-items: center; background: #ffffff; padding: 16px 32px; border-radius: 20px; box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.05); margin-bottom: 24px; border: 1px solid rgba(255, 255, 255, 0.8); }
//         .nav-brand { font-size: 22px; font-weight: 800; background: linear-gradient(135deg, #ff8c42, #ff5e62); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
//         .nav-btn { padding: 10px 20px; font-size: 14px; font-weight: 600; border-radius: 12px; cursor: pointer; transition: all 0.2s ease; border: none; display: flex; align-items: center; gap: 8px; }
//         .btn-secondary-nav { background: #f1f5f9; color: #475569; }
//         .btn-secondary-nav:hover { background: #e2e8f0; color: #0f172a; }

//         /* Dashboard Top Info Card */
//         .top-header { background: #ffffff; padding: 24px 30px; border-radius: 24px; box-shadow: 0 10px 30px rgba(0,0,0,0.02); display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; border-left: 6px solid #ff8c42; gap: 16px; }
//         .merchant-title { font-size: 26px; font-weight: 800; color: #0f172a; }
//         .merchant-sub { font-size: 14px; color: #64748b; margin-top: 4px; }
//         .merchant-logo { width: 54px; height: 54px; border-radius: 16px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; display: flex; align-items: center; justify-content: center; font-size: 20px; font-weight: 700; box-shadow: 0 10px 20px rgba(255,94,98,0.2); flex-shrink: 0; }
        
//         /* Grid Rules Layout */
//         .main-grid { display: grid; grid-template-columns: 1fr; gap: 24px; }
//         .metrics-summary-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 20px; margin-bottom: 4px; }

//         .card { background: white; border-radius: 24px; padding: 24px; box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04); border: 1px solid #e2e8f0; }
//         .card h2 { font-size: 18px; margin-bottom: 6px; color: #0f172a; font-weight: 700; }
//         .card p { color: #64748b; font-size: 13.5px; margin-bottom: 18px; }
        
//         .metric-huge { font-size: 34px; font-weight: 800; color: #0f172a; letter-spacing: -1px; margin-bottom: 4px; }
//         .metric-star-color { color: #f59e0b; }
        
//         .metric-progress-track { background: #f1f5f9; height: 6px; border-radius: 10px; overflow: hidden; margin-top: 12px; }
//         .metric-progress-bar { height: 100%; border-radius: 10px; transition: width 0.5s ease; }
//         .bg-coral { background: linear-gradient(90deg, #ff8c42, #ff5e62); }
//         .bg-gold { background: linear-gradient(90deg, #f59e0b, #eab308); }
//         .bg-neutral-zero { background: #cbd5e1; width: 0% !important; }

//         /* Inputs Control styling */
//         .search-engine-box { background: white; border-radius: 20px; padding: 20px; border: 1px solid #e2e8f0; margin-bottom: 4px; }
//         .search-flex-row { display: flex; gap: 12px; }
//         .input-group { flex: 1; }
//         .input-group input { width: 100%; height: 48px; border: 1px solid #cbd5e1; background: #f8fafc; border-radius: 12px; padding: 0 16px; font-size: 14px; outline: none; transition: all 0.25s ease; }
//         .input-group input:focus { background: white; border-color: #ff8c42; box-shadow: 0 0 0 4px rgba(255,140,66,0.15); }
        
//         .save-btn { height: 48px; padding: 0 24px; border: none; border-radius: 12px; background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 4px 12px rgba(255, 94, 98, 0.2); white-space: nowrap; }
//         .save-btn:hover { transform: translateY(-1px); opacity: 0.95; }
        
//         /* Tables Core Engine */
//         .table-container { overflow-x: auto; border-radius: 16px; border: 1px solid #e2e8f0; background: white; }
//         table { width: 100%; border-collapse: collapse; min-width: 750px; text-align: left; }
//         th { background: #f8fafc; color: #475569; padding: 14px 20px; font-size: 12px; font-weight: 700; border-bottom: 2px solid #e2e8f0; text-transform: uppercase; letter-spacing: 0.5px; }
//         td { padding: 16px 20px; border-bottom: 1px solid #f1f5f9; color: #334155; font-size: 14px; }
        
//         /* Clickable Row Animation Effect */
//         .clickable-row { cursor: pointer; transition: all 0.2s ease; }
//         .clickable-row:hover { background: #f0f4f8; transform: scale(0.998); }
        
//         /* Badges & Actions UI */
//         .badge { display: inline-block; padding: 4px 10px; border-radius: 20px; font-size: 12px; font-weight: 700; }
//         .badge-neutral { background: #f1f5f9; color: #475569; }
//         .badge-active { background: #ecfdf5; color: #047857; border: 1px solid #a7f3d0; }
//         .badge-star { background: #fffbeb; color: #b45309; border: 1px solid #fde68a; font-family: monospace; }
        
//         /* Store Reviews Panel Design Upgrades */
//         .review-panel-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 16px; }
//         .review-row-card { background: #ffffff; border: 1px solid #e2e8f0; padding: 18px; border-radius: 16px; display: flex; flex-direction: column; justify-content: space-between; box-shadow: 0 4px 12px rgba(0,0,0,0.01); }
//         .review-header-flex { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
//         .review-user-name { font-weight: 700; color: #0f172a; font-size: 14px; }
//         .review-user-phone { font-size: 12px; color: #94a3b8; font-family: monospace; }
//         .review-text-content { font-size: 13.5px; color: #475569; line-height: 1.5; font-style: italic; margin-bottom: 12px; }
//         .review-stars-indicator { color: #f59e0b; font-size: 13px; font-weight: bold; }

//         /* ABSOLUTE MODAL PROFILE POPUP DESIGN */
//         .modal-blur-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(15, 23, 42, 0.4); backdrop-filter: blur(8px); z-index: 10000; display: flex; justify-content: center; align-items: center; padding: 20px; }
//         .modal-profile-box { background: #ffffff; width: 100%; max-width: 520px; border-radius: 24px; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15); border: 1px solid #e2e8f0; overflow: hidden; animation: modalSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
//         .modal-hero-header { background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%); color: white; padding: 24px; position: relative; }
//         .modal-hero-title { font-size: 20px; font-weight: 800; margin-bottom: 4px; letter-spacing: -0.3px; }
//         .modal-hero-subtitle { color: #94a3b8; font-size: 13px; font-family: monospace; }
//         .modal-close-btn { position: absolute; top: 22px; right: 22px; background: rgba(255, 255, 255, 0.1); border: none; color: white; width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 16px; font-weight: bold; transition: background 0.2s; }
//         .modal-close-btn:hover { background: rgba(255, 255, 255, 0.2); }
        
//         .modal-body-content { padding: 24px; }
//         .modal-insights-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin-bottom: 20px; }
//         .insight-data-card { background: #f8fafc; border: 1px solid #e2e8f0; padding: 14px; border-radius: 12px; }
//         .insight-label { font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px; }
//         .insight-value { font-size: 16px; font-weight: 800; color: #0f172a; }
        
//         .modal-rating-segment { background: #fffbeb; border: 1px solid #fde68a; border-radius: 14px; padding: 16px; }
//         .modal-rating-stars { color: #f59e0b; font-size: 16px; margin-bottom: 6px; font-weight: bold; }
//         .modal-review-msg { font-size: 13.5px; color: #b45309; font-style: italic; line-height: 1.5; }

//         .empty-placeholder { padding: 40px; text-align: center; color: #94a3b8; font-size: 14px; font-weight: 500; }

//         @keyframes modalSlideUp {
//           from { transform: translateY(20px); opacity: 0; }
//           to { transform: translateY(0); opacity: 1; }
//         }

//         /* MOBILE RESPONSIVE OPTIMIZATION OVERRIDES */
//         @media(max-width: 768px) {
//           .merchant-page { padding: 14px; }
//           .premium-nav { padding: 14px 20px; flex-direction: column; gap: 12px; text-align: center; }
//           .top-header { padding: 18px; flex-direction: column; text-align: center; }
//           .search-flex-row { flex-direction: column; gap: 10px; }
//           .save-btn { width: 100%; }
//           .metrics-summary-row { grid-template-columns: 1fr 1fr; gap: 12px; }
//           .metric-huge { font-size: 26px; }
//           .card { padding: 16px; border-radius: 18px; }
//           .modal-insights-grid { grid-template-columns: 1fr; gap: 10px; }
//           .sub-status-bar { flex-direction: column; text-align: center; font-size: 13px; padding: 12px; }
//         }
//       `}</style>
       
//       {/* SUBSCRIPTION SECURITY LOCK OVERLAY */}
//       {!isSubscribed && (
//         <div className="subscription-lock-overlay">
//           <div className="lock-card">
//             <div className="lock-icon-box">
//               <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
//                 <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//                 <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//               </svg>
//             </div>
//             <h2>Premium Subscription Locked</h2>
//             <p>Your current merchant plan activation status is inactive. Please process plan validation to access telemetry logs and analytics data.</p>
//             <button className="save-btn" style={{ width: '100%' }} onClick={() => alert("Initiating Core Payment Gateway...")}>
//               Activate Premium Plan
//             </button>
//           </div>
//         </div>
//       )}

//       {/* DYNAMIC FULL INSIGHT CUSTOMER PROFILE POPUP (MODAL) */}
//       {isModalOpen && selectedCustomer && (
//         <div className="modal-blur-overlay" onClick={() => setIsModalOpen(false)}>
//           <div className="modal-profile-box" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-hero-header">
//               <button className="modal-close-btn" onClick={() => setIsModalOpen(false)}>✕</button>
//               <div className="modal-hero-title">{selectedCustomer.name || "Anonymous Member"}</div>
//               <div className="modal-hero-subtitle">ID: {selectedCustomer.customer_id || "N/A"}</div>
//             </div>

//             <div className="modal-body-content">
//               <div className="modal-insights-grid">
//                 <div className="insight-data-card">
//                   <div className="insight-label">Mobile Number</div>
//                   <div className="insight-value">{selectedCustomer.mobile || "—"}</div>
//                 </div>
//                 <div className="insight-data-card">
//                   <div className="insight-label">Loyalty Tier Standing</div>
//                   <div className="insight-value" style={{ color: '#ff8c42' }}>{selectedCustomer.loyalty_status || "Standard Tier"}</div>
//                 </div>
//                 <div className="insight-data-card">
//                   <div className="insight-label">Total Visits</div>
//                   <div className="insight-value">{selectedCustomer.total_visits || 0} Engagement Logs</div>
//                 </div>
//                 <div className="insight-data-card">
//                   <div className="insight-label">Total Visits</div>
//                   <div className="insight-value">{selectedCustomer.total_visits || 0} Engagement Logs</div>
//                 </div>
//                 <div className="insight-data-card">
//                   <div className="insight-label">Claimed vs Unused Rewards</div>
//                   <div className="insight-value" style={{ fontSize: '14px' }}>
//                     <span style={{ color: '#10b981' }}>{selectedCustomer.used_rewards || 0} Used</span> / <span style={{ color: '#ff8c42' }}>{selectedCustomer.unused_rewards || 0} Pending</span>
//                   </div>
//                 </div>
//               </div>

//               {/* Verified Customer Feedback Engine Section */}
//               <div className="modal-rating-segment">
//                 <div className="insight-label" style={{ color: '#b45309' }}>Storefront Feedback Assessment</div>
//                 <div className="modal-rating-stars">
//                   {isNaN(selectedCustomer.rating) ? "No Star Rating" : renderStars(selectedCustomer.rating)}
//                   <span style={{ fontSize: '12px', color: '#64748b', marginLeft: '6px' }}>({selectedCustomer.rating})</span>
//                 </div>
//                 <p className="modal-review-msg">"{selectedCustomer.review_text}"</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="merchant-page">

//         {/* PREMIUM NAVIGATION */}
//         <nav className="premium-nav">
//           <div className="nav-logo-side">
//             <span className="nav-brand">CountMyVisit</span>
//           </div>
//           <div className="nav-actions">
//             <span className="badge badge-neutral" style={{ fontFamily: 'monospace' }}>ID: {MERCHANT_ID}</span>
//           </div>
//         </nav>

//         {/* STATUS ACCELERATOR BAR */}
//         <div className={`sub-status-bar ${isSubscribed ? "sub-active-bar" : "sub-expired-bar"}`}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//             <span className="sub-days-count">{isSubscribed ? "Active" : "Locked"}</span>
//             <span>Premium Merchant Analytics Channel Stream</span>
//           </div>
//         </div>

//         {/* TOP COMPONENT HEADER */}
//         <header className="top-header">
//           <div>
//             <div className="merchant-title">Merchant Dashboard Logs</div>
//             <div className="merchant-sub">Operational metrics, real-time reviews, and visitor profiles</div>
//           </div>
//           <div className="merchant-logo">M</div>
//         </header>

//         {/* DYNAMIC METRIC MATRIX ROW */}
//         <div className="metrics-summary-row">
//           <div className="card">
//             <h2>Total Customers</h2>
//             <div className="metric-huge">{analytics.customers.total || 0}</div>
//             <div className="metric-progress-track">
//               <div className="metric-progress-bar bg-coral" style={{ width: '100%' }}></div>
//             </div>
//           </div>

//           <div className="card">
//             <h2> Today Visits</h2>
//             <div className="metric-huge">{analytics.visits.today || 0}</div>
//             <div className="metric-progress-track">
//               <div className="metric-progress-bar bg-coral" style={{ width: '100%' }}></div>
//             </div>
//           </div>
//           <div className="card">
//             <h2>Today Sale</h2>
//             <div className="metric-huge">{analytics.sales.today || 0} ₹/-</div>
//             <div className="metric-progress-track">
//               <div className="metric-progress-bar bg-coral" style={{ width: '100%' }}></div>
//             </div>
//           </div>

//           <div className="card">
//             <h2>Average Rating</h2>
//             <div className="metric-huge metric-star-color">
//               {reviewsSummary.average_rating} <span style={{ fontSize: '22px' }}>★</span>
//             </div>
//             <div className="metric-progress-track">
//               <div className="metric-progress-bar bg-gold" style={{ width: `${(reviewsSummary.average_rating / 5) * 100}%` }}></div>
//             </div>
//           </div>


//           <div className="card">

//             <h2>Retention Score</h2>

//             <div className="metric-huge">{analytics.customers.returning_ratio}%</div>

//             <div className="metric-progress-track">

//               <div className="metric-progress-bar bg-coral" style={{ width: `${analytics.returning_ratio}%` }}></div>

//             </div>

//           </div>

//         </div>
//          {/* SEARCH FILTER INTEGRATION BOX */}
//         <div className="search-engine-box">
//           <form onSubmit={handleSearch} className="search-flex-row">
//             <div className="input-group">
//               <input
//                 type="text"
//                 placeholder="Search precise customer profile logs via mobile number..."
//                 value={searchMobile}
//                 onChange={(e) => setSearchMobile(e.target.value)}
//               />
//             </div>
//             <button type="submit" className="save-btn">Query System Logs</button>
//             {isSearching && (
//               <button
//                 type="button"
//                 className="nav-btn btn-secondary-nav"
//                 onClick={() => {
//                   setSearchMobile("");
//                   setIsSearching(false);
//                   const savedTrail = localStorage.getItem(`audit_trail_${MERCHANT_ID}`);
//                   if (savedTrail) {
//                     setCustomers(JSON.parse(savedTrail));
//                   } else {
//                     fetchCustomerAuditTrail();
//                   }
//                 }}
//               >
//                 Reset
//               </button>
//             )}
//           </form>
//         </div>

//         {/* CORE WORKSPACE GRID */}
//         <main className="main-grid" style={{
//           display: "flex",
//           flexDirection: "column",
//           gap: "28px",
//           padding: "16px",
//           maxWidth: "1280px",
//           width: "100%",
//           margin: "0 auto",
//           boxSizing: "border-box",
//           fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//           background: "#f8fafc"
//         }}>

//           {/* CSS Styles injection for total responsiveness */}
//           <style>{`
//     /* Global Card Structure */
//     .custom-dashboard-card {
//       background: #ffffff;
//       border-radius: 24px;
//       padding: 24px;
//       border: 1px solid #e2e8f0;
//       box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.01), 0 8px 10px -6px rgba(0, 0, 0, 0.01);
//     }
    
//     .card-header-wrapper {
//       display: flex;
//       justify-content: space-between;
//       align-items: flex-start;
//       gap: 16px;
//       margin-bottom: 20px;
//     }

//     .card-title {
//       font-size: 20px;
//       font-weight: 800;
//       color: #0f172a;
//       margin: 0;
//       letter-spacing: -0.5px;
//     }

//     .card-subtitle {
//       font-size: 13.5px;
//       color: #64748b;
//       margin: 4px 0 0 0;
//       line-height: 1.5;
//     }

//     /* Unified Response Grids */
//     .dynamic-dashboard-grid {
//       display: grid;
//       grid-template-columns: repeat(4, 1fr); /* Computer / Desktop: 4 Columns */
//       gap: 16px;
//       max-height: 520px;
//       overflow-y: auto;
//       padding-right: 6px;
//       padding-bottom: 6px;
//     }

//     /* Modern Minimalist Scrollbar */
//     .dynamic-dashboard-grid::-webkit-scrollbar {
//       width: 6px;
//     }
//     .dynamic-dashboard-grid::-webkit-scrollbar-track {
//       background: #f1f5f9;
//       border-radius: 8px;
//     }
//     .dynamic-dashboard-grid::-webkit-scrollbar-thumb {
//       background: #cbd5e1;
//       border-radius: 8px;
//     }
//     .dynamic-dashboard-grid::-webkit-scrollbar-thumb:hover {
//       background: #94a3b8;
//     }

//     /* Audit Customer Clickable Card Item */
//     .audit-profile-card {
//       background: #ffffff;
//       border: 1px solid #e2e8f0;
//       border-radius: 16px;
//       padding: 16px;
//       display: flex;
//       flex-direction: column;
//       justify-content: space-between;
//       cursor: pointer;
//       transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
//     }
//     .audit-profile-card:hover {
//       transform: translateY(-2px);
//       border-color: #cbd5e1;
//       box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
//     }

//     /* Utilities & Badges */
//     .status-pill {
//       display: inline-flex;
//       align-items: center;
//       padding: 4px 10px;
//       border-radius: 8px;
//       font-size: 12px;
//       font-weight: 600;
//     }
//     .status-pill-active { background: #e0f2fe; color: #0369a1; }
//     .status-pill-neutral { background: #f1f5f9; color: #475569; }

//     .reward-box {
//       background: #f8fafc;
//       border-radius: 10px;
//       padding: 8px 12px;
//       text-align: center;
//       flex: 1;
//       border: 1px solid #f1f5f9;
//     }

//     /* ================= BREAKPOINTS (Laptop, Tab, Mobile) ================= */

//     @media (max-width: 1120px) {
//       .dynamic-dashboard-grid {
//         grid-template-columns: repeat(3, 1fr) !important; /* 3 Columns on smaller screens */
//       }
//     }

//     @media (max-width: 768px) {
//       .custom-dashboard-card { padding: 20px; }
//       .dynamic-dashboard-grid {
//         grid-template-columns: repeat(2, 1fr) !important; /* 2 Columns on Tablet */
//         gap: 12px;
//         max-height: 460px;
//       }
//     }

//     @media (max-width: 480px) {
//       .custom-dashboard-card { padding: 16px; border-radius: 16px; }
//       .card-header-wrapper { flex-direction: column; align-items: stretch; gap: 10px; }
//       .mobile-full-badge { width: 100%; text-align: center; justify-content: center; }
//       .dynamic-dashboard-grid {
//         grid-template-columns: 1fr !important; /* 1 Column on Mobile Phones */
//         max-height: 400px;
//         gap: 12px;
//       }
//     }

//     * {
//   -webkit-user-select: none;  /* Safari */
//   -moz-user-select: none;     /* Firefox */
//   -ms-user-select: none;      /* IE10+ */
//   user-select: none;          /* Standard */
//   -webkit-user-drag: none;    /* इमेजेस या एलिमेंट्स को ड्रैग करने से रोकने के लिए */
// }
//   `}</style>

//           {/* ================= SECTION 1: CUSTOMER AUDIT LOG (UPDATED TO GRID CARDS) ================= */}
//           <div className="custom-dashboard-card">
//             <div className="card-header-wrapper">
//               <div>
//                 <h2 className="card-title">
//                   {isSearching ? "Filtered Profile Results" : "Customer Retention Audit Log"}
//                 </h2>
//                 <p className="card-subtitle">
//                   Active live visitor parameters database map metrics. <span style={{ color: "#4f46e5", fontWeight: "600" }}>👉  </span>
//                 </p>
//               </div>
//             </div>

//             {!customers || customers.length === 0 ? (
//               <div style={{ textAlign: "center", padding: "50px 20px", color: "#94a3b8", background: "#f8fafc", borderRadius: "16px", border: "1px dashed #cbd5e1", fontSize: "14px", fontWeight: "600" }}>
//                 📭 No target logs mapped under the specified query pipeline.
//               </div>
//             ) : (
//               <div className="dynamic-dashboard-grid">
//                 {customers.map((item, idx) => (
//                   <div
//                     key={idx}
//                     className="audit-profile-card"
//                     onClick={() => openCustomerDetails && openCustomerDetails(item)}
//                   >
//                     {/* Top Row: Avatar + Name + Tier */}
//                     <div>
//                       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px", gap: "8px" }}>
//                         <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0 }}>
//                           <div style={{ width: "32px", height: "32px", borderRadius: "50%", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "13px", fontWeight: "700", color: "#475569", flexShrink: 0 }}>
//                             {(item.name || "A")[0].toUpperCase()}
//                           </div>
//                           <div style={{ minWidth: 0 }}>
//                             <div style={{ fontSize: "14px", fontWeight: "700", color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                               {item.name || "Anonymous Member"}
//                             </div>
//                             <div style={{ fontSize: "11px", fontFamily: "monospace", color: "#64748b", marginTop: "1px" }}>
//                               {item.mobile || "—"}
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       Retention
//                       {/* Middle Row: Engagement Level */}
//                       <div style={{ marginBottom: "14px" }}>
//                         <span className={`status-pill ${Number(item.total_visits) > 0 ? "status-pill-active" : "status-pill-neutral"}`}>
//                           📌 {item.total_visits || 0} Engagement Visits
//                         </span>
//                       </div>
//                     </div>

//                     {/* Bottom Row: Rewards Visual Split & Loyalty Badge */}
//                     <div style={{ borderTop: "1px dashed #e2e8f0", paddingTop: "12px", marginTop: "auto" }}>
//                       <div style={{ display: "flex", gap: "8px", marginBottom: "10px" }}>
//                         <div className="reward-box">
//                           <div style={{ fontSize: "10px", fontWeight: "600", color: "#64748b", textTransform: "uppercase" }}>Unused</div>
//                           <div style={{ fontSize: "15px", fontWeight: "800", color: Number(item.unused_rewards) > 0 ? "#ea580c" : "#94a3b8", marginTop: "2px" }}>
//                             {item.unused_rewards || 0}
//                           </div>
//                         </div>
//                         <div className="reward-box">
//                           <div style={{ fontSize: "10px", fontWeight: "600", color: "#64748b", textTransform: "uppercase" }}>Claimed</div>
//                           <div style={{ fontSize: "15px", fontWeight: "800", color: Number(item.used_rewards) > 0 ? "#16a34a" : "#94a3b8", marginTop: "2px" }}>
//                             {item.used_rewards || 0}
//                           </div>
//                         </div>
//                       </div>

//                       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                         <span style={{ fontSize: "11px", color: "#94a3b8", fontWeight: "500" }}>Standing Status</span>
//                         <span style={{ fontSize: "11px", fontWeight: "700", background: "#f8fafc", padding: "3px 8px", borderRadius: "6px", border: "1px solid #e2e8f0", color: "#334155" }}>
//                           {item.loyalty_status || "Standard Tier"}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>


//           {/* ================= SECTION 2: TESTIMONIALS STREAM ================= */}
//           <div className="custom-dashboard-card">
//             <div className="card-header-wrapper">
//               <div>
//                 <h2 className="card-title">Storefront Testimonials Stream</h2>
//                 <p className="card-subtitle">Live storefront testimonials and verified metrics streaming instantly.</p>
//               </div>
//               <span className="mobile-full-badge" style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 fontSize: "13px",
//                 fontWeight: "700",
//                 background: "#fef9c3",
//                 color: "#854d0e",
//                 padding: "6px 14px",
//                 borderRadius: "100px",
//                 whiteSpace: "nowrap",
//                 border: "1px solid #fef08a",
//                 alignSelf: "flex-start"
//               }}>
//                 ⭐ {reviewsSummary?.total_reviews || 0} Feedbacks
//               </span>
//             </div>

//             {!allReviews || allReviews.length === 0 ? (
//               <div style={{ textAlign: "center", padding: "50px 20px", color: "#94a3b8", background: "#f8fafc", borderRadius: "16px", border: "1px dashed #cbd5e1", fontSize: "14px", fontWeight: "600" }}>
//                 📭 No store ratings or customer feedback parsed yet.
//               </div>
//             ) : (
//               <div className="dynamic-dashboard-grid">
//                 {allReviews.map((item) => (
//                   <div
//                     key={item.id}
//                     style={{
//                       background: "#ffffff",
//                       borderRadius: "16px",
//                       padding: "16px",
//                       border: "1px solid #e2e8f0",
//                       display: "flex",
//                       flexDirection: "column",
//                       justifyContent: "space-between",
//                       minHeight: "150px",
//                       boxShadow: "0 2px 4px rgba(0,0,0,0.01)"
//                     }}
//                   >
//                     <div>
//                       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px", gap: "8px" }}>
//                         <div style={{ display: "flex", alignItems: "center", gap: "8px", minWidth: 0 }}>
//                           <div style={{ width: "28px", height: "28px", borderRadius: "50%", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", fontWeight: "700", color: "#64748b", flexShrink: 0 }}>
//                             {(item.customer_name || "A")[0].toUpperCase()}
//                           </div>
//                           <span style={{ fontSize: "14px", fontWeight: "700", color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                             {item.customer_name || "Anonymous Guest"}
//                           </span>
//                         </div>
//                         <span style={{
//                           fontSize: "10px",
//                           fontWeight: "600",
//                           color: "#64748b",
//                           background: "#f8fafc",
//                           padding: "3px 8px",
//                           borderRadius: "6px",
//                           border: "1px solid #e2e8f0",
//                           whiteSpace: "nowrap",
//                           flexShrink: 0
//                         }}>
//                           {item.mobile ? `+91 ${item.mobile}` : "System Log"}
//                         </span>
//                       </div>

//                       <p style={{ fontSize: "13px", margin: "0 0 16px 0", lineHeight: "1.5", color: "#475569", fontStyle: "italic" }}>
//                         "{item.review || "No custom log commentary written."}"
//                       </p>
//                     </div>

//                     <div style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "space-between",
//                       borderTop: "1px dashed #f1f5f9",
//                       paddingTop: "12px",
//                       marginTop: "auto"
//                     }}>
//                       <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
//                         {typeof renderStars === 'function' && renderStars(item.rating)}
//                       </div>
//                       <span style={{ fontSize: "11px", fontWeight: "700", color: "#475569", background: "#f1f5f9", padding: "2px 6px", borderRadius: "4px" }}>
//                         {item.rating} / 5
//                       </span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>

//         </main>
//       </div>
//     </>
//   );
// }

// import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";

// const API_BASE = "https://countmyvisit.com/Apis";
// const FALLBACK_MERCHANT_ID = "CMV9A117EAC";
// const REFRESH_MS = 60000; // live refresh every 60s

// const PERIODS = [
//   { key: "today", label: "Today" },
//   { key: "week", label: "This Week" },
//   { key: "month", label: "This Month" },
// ];

// /* ---------------- helpers ---------------- */
// const safeGet = (key, fallback) => {
//   try {
//     const v = localStorage.getItem(key);
//     return v ? JSON.parse(v) : fallback;
//   } catch (e) {
//     return fallback;
//   }
// };
// const safeSet = (key, value) => {
//   try {
//     localStorage.setItem(key, JSON.stringify(value));
//   } catch (e) {
//     console.warn("localStorage write failed:", key, e);
//   }
// };

// // API kabhi kabhi JSON se pehle text bhejti hai ("DATABASE CONNECTED") -> sirf JSON nikalo
// const parseApiText = (text) => {
//   const start = text.indexOf("{");
//   const end = text.lastIndexOf("}");
//   if (start === -1 || end === -1) {
//     throw new Error("JSON not found in response: " + text.slice(0, 200));
//   }
//   return JSON.parse(text.slice(start, end + 1));
// };

// const num = (v) => {
//   const n = parseFloat(String(v ?? 0).replace(/[^0-9.-]/g, ""));
//   return isNaN(n) ? 0 : n;
// };

// const inr = (n) => "₹" + num(n).toLocaleString("en-IN", { maximumFractionDigits: 2 });

// const todayIST = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" }); // YYYY-MM-DD

// const parseDate = (s) => {
//   const [y, m, d] = String(s).slice(0, 10).split("-").map(Number);
//   return new Date(y, (m || 1) - 1, d || 1);
// };

// const rangeLabel = (period, p) => {
//   if (!p?.from) return "";
//   const start = parseDate(p.from);
//   const end = parseDate(p.to);
//   end.setDate(end.getDate() - 1);
//   if (period === "today") {
//     return start.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short", year: "numeric" });
//   }
//   if (period === "month") {
//     return start.toLocaleDateString("en-IN", { month: "long", year: "numeric" });
//   }
//   const f = (d) => d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
//   return `${f(start)} – ${f(end)}`;
// };

// const getMerchantId = () => {
//   try {
//     const raw = localStorage.getItem("marchentdata");
//     if (raw) {
//       const parsed = parseApiText(raw);
//       if (parsed?.merchant?.user_id) return parsed.merchant.user_id;
//     }
//   } catch (e) {
//     console.error("Error reading marchentdata from localStorage:", e);
//   }
//   return FALLBACK_MERCHANT_ID;
// };

// /* ---- merchant_dashboard_analytics.php -> customers / plan / rewards ---- */
// const normalizeAnalytics = (d = {}) => {
//   const c = d.customers || {};
//   const status = d.subscription?.status ?? d.plan_status ?? d.plan?.status ?? "";
//   return {
//     planName: d.subscription?.plan_name ?? d.plan_name ?? "",
//     planStatus: status,
//     isSubscribed: !(status === "inactive" || status === "expired" || d.is_subscribed === false),
//     totalCustomers: num(c.total ?? d.total_customers),
//     returningCustomers: num(c.returning ?? d.returning_customers),
//     newCustomers: num(c.new ?? d.new_customers),
//     returningRatio: num(c.returning_ratio ?? d.returning_ratio),
//     totalVisits: num(d.visits?.total ?? d.total_visits),
//     redeemedRewards: num(d.rewards?.redeemed ?? d.redeemed_rewards),
//     lifetimeSales: num(d.sales?.lifetime ?? d.sales_lifetime),
//   };
// };
// const EMPTY_ANALYTICS = normalizeAnalytics({});

// /* ---- visit_sale_today.php -> today / week / month visits + sales ---- */
// const normPeriod = (p = {}, fbVisits = 0, fbSale = 0) => ({
//   visits: num(p.visits ?? fbVisits),
//   unique: num(p.unique_customers),
//   newC: num(p.new_customers),
//   returningC: num(p.returning_customers),
//   bills: num(p.bills),
//   billTotal: num(p.bill_total),
//   discount: num(p.discount_total),
//   sale: num(p.sale ?? fbSale),
//   from: p.from || "",
//   to: p.to || "",
// });
// const normDay = (d = {}) => ({ date: d.date || "", day: d.day || "", visits: num(d.visits), sale: num(d.sale) });

// const normalizeStats = (d = {}) => ({
//   date: d.date || "",
//   source: d.visits_source || "",
//   periods: {
//     today: normPeriod(d.periods?.today, d.visits?.today, d.sales?.today),
//     week: normPeriod(d.periods?.week, d.visits?.week, d.sales?.week),
//     month: normPeriod(d.periods?.month, d.visits?.month, d.sales?.month),
//   },
//   daily: {
//     week: (d.daily?.week || []).map(normDay),
//     month: (d.daily?.month || []).map(normDay),
//   },
//   todayRows: d.today_rows || [],
// });
// const EMPTY_STATS = normalizeStats({});

// const logApi = (label, url, rawText, parsed) => {
//   console.groupCollapsed(`[API] ${label}`);
//   console.log("URL:", url);
//   console.log("Raw response:", rawText);
//   console.log("Parsed JSON:", parsed);
//   console.groupEnd();
// };

// /* ---------------- component ---------------- */
// export default function MerchantFeedbackLog() {
//   const MERCHANT_ID = useMemo(getMerchantId, []);
//   const KEY = {
//     analytics: `analytics_v3_${MERCHANT_ID}`,
//     stats: `period_stats_v1_${MERCHANT_ID}`,
//     trail: `audit_trail_${MERCHANT_ID}`,
//     summary: `reviews_summary_${MERCHANT_ID}`,
//     reviews: `all_reviews_${MERCHANT_ID}`,
//   };

//   const [isSubscribed, setIsSubscribed] = useState(true);
//   const [period, setPeriod] = useState("today");
//   const [chartMetric, setChartMetric] = useState("visits"); // 'visits' | 'sale'
//   const [selectedDate, setSelectedDate] = useState(""); // "" = aaj (auto)

//   const [analytics, setAnalytics] = useState(() => safeGet(KEY.analytics, EMPTY_ANALYTICS));
//   const [stats, setStats] = useState(() => safeGet(KEY.stats, EMPTY_STATS));
//   const [customers, setCustomers] = useState(() => safeGet(KEY.trail, []));
//   const [reviewsSummary, setReviewsSummary] = useState(() =>
//     safeGet(KEY.summary, { total_reviews: 0, average_rating: 0 })
//   );
//   const [allReviews, setAllReviews] = useState(() => safeGet(KEY.reviews, []));

//   const [searchMobile, setSearchMobile] = useState("");
//   const [isSearching, setIsSearching] = useState(false);
//   const [selectedCustomer, setSelectedCustomer] = useState(null);
//   const [loading, setLoading] = useState(() => !localStorage.getItem(KEY.analytics));
//   const [statsLoading, setStatsLoading] = useState(false);

//   const isSearchingRef = useRef(false);
//   useEffect(() => {
//     isSearchingRef.current = isSearching;
//   }, [isSearching]);

//   /* 1. Analytics (customers, plan, rewards) */
//   const fetchAnalytics = useCallback(async () => {
//     const url = `${API_BASE}/merchant_dashboard_analytics.php`;
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       console.log("🏪 MERCHANT_ID sent:", MERCHANT_ID);
//       const res = await fetch(url, { method: "POST", body: formdata, redirect: "follow" });
//       const text = await res.text();
//       const data = parseApiText(text);
//       logApi("Analytics", url, text, data);

//       if (data.success) {
//         const a = normalizeAnalytics(data);
//         setAnalytics(a);
//         setIsSubscribed(a.isSubscribed);
//         safeSet(KEY.analytics, a);
//         console.group("📊 ANALYTICS");
//         console.log("👥 Customers (total / new / returning):", a.totalCustomers, a.newCustomers, a.returningCustomers);
//         console.log("🔁 Retention %:", a.returningRatio);
//         console.log("🎁 Redeemed rewards:", a.redeemedRewards);
//         console.log("🧾 Plan:", a.planName, "|", a.planStatus, "| subscribed:", a.isSubscribed);
//         console.groupEnd();
//       } else {
//         console.warn("Analytics success=false:", data.message, data);
//         if (/subscription/i.test(data.message || "")) setIsSubscribed(false);
//       }
//     } catch (error) {
//       console.error("Error fetching analytics:", error);
//     }
//   }, [MERCHANT_ID]);

//   /* 2. Today / Week / Month visits + sales */
//   const fetchPeriodStats = useCallback(async () => {
//     const url = `${API_BASE}/visit_sale_today.php`;
//     setStatsLoading(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       if (selectedDate) formdata.append("date", selectedDate);
//       const res = await fetch(url, { method: "POST", body: formdata, redirect: "follow" });
//       const text = await res.text();
//       const data = parseApiText(text);
//       logApi("Visits & Sales (today/week/month)", url, text, data);

//       if (data.success) {
//         const s = normalizeStats(data);
//         setStats(s);
//         if (!selectedDate) safeSet(KEY.stats, s); // sirf aaj ka cache karo

//         console.group(`📅 VISITS & SALES | date: ${s.date} | source: ${s.source}`);
//         console.log("📅 TODAY VISITS:", s.periods.today.visits, "| TODAY SALE:", s.periods.today.sale);
//         console.table({
//           today: { visits: s.periods.today.visits, unique: s.periods.today.unique, sale: s.periods.today.sale },
//           week: { visits: s.periods.week.visits, unique: s.periods.week.unique, sale: s.periods.week.sale },
//           month: { visits: s.periods.month.visits, unique: s.periods.month.unique, sale: s.periods.month.sale },
//         });
//         console.log("📆 Daily (week):");
//         console.table(s.daily.week);
//         console.log("🧾 Day rows:");
//         console.table(s.todayRows);
//         console.groupEnd();
//       } else {
//         console.warn("Visits/Sales success=false:", data.message, data);
//       }
//     } catch (error) {
//       console.error("Error fetching visits & sales:", error);
//     } finally {
//       setStatsLoading(false);
//     }
//   }, [MERCHANT_ID, selectedDate]);

//   /* 3. Customer audit trail */
//   const fetchCustomerAuditTrail = useCallback(async () => {
//     const url = `${API_BASE}/customer_audit_trail.php`;
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       const res = await fetch(url, { method: "POST", body: formdata, redirect: "follow" });
//       const text = await res.text();
//       const data = parseApiText(text);
//       logApi("Customer Audit Trail", url, text, data);

//       if (data.success) {
//         const list = data.customers || [];
//         console.group(`👥 CUSTOMER DETAILS (${list.length})`);
//         console.table(list);
//         console.groupEnd();
//         safeSet(KEY.trail, list);
//         setCustomers((prev) => (isSearchingRef.current ? prev : list));
//       }
//     } catch (error) {
//       console.error("Error fetching audit trail:", error);
//     }
//   }, [MERCHANT_ID]);

//   /* 4. Reviews */
//   const fetchAllReviews = useCallback(async () => {
//     const url = `${API_BASE}/get_reviews.php`;
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       const res = await fetch(url, { method: "POST", body: formdata, redirect: "follow" });
//       const text = await res.text();
//       const data = parseApiText(text);
//       logApi("Reviews", url, text, data);

//       if (data.success) {
//         const summary = { total_reviews: data.total_reviews || 0, average_rating: num(data.average_rating) };
//         const list = data.reviews || [];
//         setReviewsSummary(summary);
//         setAllReviews(list);
//         safeSet(KEY.summary, summary);
//         safeSet(KEY.reviews, list);
//         console.group(`⭐ REVIEWS (${summary.total_reviews}) | avg ${summary.average_rating}`);
//         console.table(list);
//         console.groupEnd();
//       }
//     } catch (error) {
//       console.error("Error fetching reviews:", error);
//     }
//   }, [MERCHANT_ID]);

//   /* load: analytics + customers + reviews (+ auto refresh) */
//   useEffect(() => {
//     let alive = true;
//     const loadAll = async () => {
//       await Promise.all([fetchAnalytics(), fetchCustomerAuditTrail(), fetchAllReviews()]);
//       if (alive) setLoading(false);
//     };
//     loadAll();
//     const timer = setInterval(loadAll, REFRESH_MS);
//     return () => {
//       alive = false;
//       clearInterval(timer);
//     };
//   }, [fetchAnalytics, fetchCustomerAuditTrail, fetchAllReviews]);

//   /* load: visits & sales (date badalne par dobara) */
//   useEffect(() => {
//     fetchPeriodStats();
//     const timer = setInterval(fetchPeriodStats, REFRESH_MS);
//     return () => clearInterval(timer);
//   }, [fetchPeriodStats]);

//   /* search */
//   const resetSearch = () => {
//     setSearchMobile("");
//     setIsSearching(false);
//     const saved = safeGet(KEY.trail, null);
//     if (saved) setCustomers(saved);
//     else fetchCustomerAuditTrail();
//   };

//   const handleSearch = async (e) => {
//     e.preventDefault();
//     const mobile = searchMobile.trim();
//     if (!mobile) return resetSearch();

//     setIsSearching(true);
//     const url = `${API_BASE}/customer_search.php?mobile=${encodeURIComponent(mobile)}&merchant_id=${encodeURIComponent(MERCHANT_ID)}`;
//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", MERCHANT_ID);
//       formdata.append("mobile", mobile);
//       const res = await fetch(url, { method: "POST", body: formdata, redirect: "follow" });
//       const text = await res.text();
//       const data = parseApiText(text);
//       logApi("Customer Search", url, text, data);

//       if (data.success && data.customer) {
//         const c = data.customer;
//         setCustomers([
//           {
//             customer_id: c.customer_id || "N/A",
//             name: c.name,
//             mobile: c.mobile,
//             total_visits: c.total_visits,
//             used_rewards: c.used_rewards,
//             unused_rewards: c.unused_rewards,
//             loyalty_status: c.loyalty_status,
//           },
//         ]);
//       } else {
//         setCustomers([]);
//       }
//     } catch (error) {
//       console.error("Search error:", error);
//       setCustomers([]);
//     }
//   };

//   const openCustomerDetails = (customer) => {
//     const matched = allReviews.find(
//       (r) =>
//         (customer.customer_id && r.customer_id && r.customer_id === customer.customer_id) ||
//         (customer.mobile && r.mobile && String(r.mobile) === String(customer.mobile))
//     );
//     const details = {
//       ...customer,
//       rating: matched ? num(matched.rating) : null,
//       review_text: matched?.review || "No review message recorded for this user.",
//     };
//     console.log("🧑 CUSTOMER DETAILS OPENED:", details);
//     setSelectedCustomer(details);
//   };

//   const renderStars = (rating) => {
//     const n = Math.min(5, Math.max(0, Math.round(num(rating))));
//     return "★".repeat(n) + "☆".repeat(5 - n);
//   };

//   /* derived */
//   const todayStr = todayIST();
//   const p = stats.periods[period] || normPeriod({});
//   const avgBill = p.bills > 0 ? p.sale / p.bills : 0;
//   const retention = Math.min(100, Math.max(0, analytics.returningRatio));
//   const days = period === "week" ? stats.daily.week : period === "month" ? stats.daily.month : [];
//   const maxVal = Math.max(1, ...days.map((d) => d[chartMetric]));
//   const nameOf = (customerId) => customers.find((c) => c.customer_id === customerId)?.name;

//   if (loading) {
//     return (
//       <div className="loader-container">
//         <style>{`
//           .loader-container { display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background:#f8fafc; font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif; }
//           .spinner { width:44px; height:44px; border:3px solid rgba(255,140,66,.1); border-left-color:#ff8c42; border-radius:50%; animation:spin .8s linear infinite; margin-bottom:16px; }
//           .loader-text { font-weight:600; font-size:14px; color:#64748b; }
//           @keyframes spin { to { transform:rotate(360deg); } }
//         `}</style>
//         <div className="spinner"></div>
//         <p className="loader-text">Loading dashboard...</p>
//       </div>
//     );
//   }

//   return (
//     <>
//       <style>{`
//         * { margin:0; padding:0; box-sizing:border-box; font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif; -webkit-user-select:none; user-select:none; -webkit-user-drag:none; }
//         input, textarea { -webkit-user-select:text; user-select:text; }
//         body { background:#f8fafc; color:#1e293b; -webkit-font-smoothing:antialiased; }
//         .merchant-page { min-height:100vh; padding:24px; background:linear-gradient(135deg,#f1f5f9 0%,#e2e8f0 100%); }
//         .page-inner { max-width:1280px; margin:0 auto; width:100%; }

//         /* subscription lock */
//         .subscription-lock-overlay { position:fixed; inset:0; background:rgba(241,245,249,.9); backdrop-filter:blur(16px); z-index:9999; display:flex; justify-content:center; align-items:center; padding:24px; }
//         .lock-card { background:#fff; border:1px solid #e2e8f0; padding:40px; border-radius:24px; max-width:480px; width:100%; text-align:center; box-shadow:0 20px 40px rgba(15,23,42,.08); }
//         .lock-icon-box { width:56px; height:56px; background:#fee2e2; border-radius:16px; display:flex; align-items:center; justify-content:center; margin:0 auto 20px; color:#ef4444; }
//         .lock-card h2 { font-size:22px; font-weight:800; color:#0f172a; margin-bottom:10px; }
//         .lock-card p { color:#64748b; font-size:14px; line-height:1.5; margin-bottom:28px; }

//         .sub-status-bar { display:flex; justify-content:space-between; align-items:center; padding:14px 24px; border-radius:16px; margin-bottom:20px; font-weight:600; font-size:15px; gap:12px; }
//         .sub-active-bar { background:#ecfdf5; border:1px solid #a7f3d0; color:#065f46; }
//         .sub-expired-bar { background:#fef2f2; border:1px solid #fecaca; color:#991b1b; }
//         .sub-days-count { background:#10b981; color:#fff; padding:4px 12px; border-radius:20px; font-size:13px; }
//         .sub-expired-bar .sub-days-count { background:#ef4444; }

//         .premium-nav { display:flex; justify-content:space-between; align-items:center; background:#fff; padding:16px 32px; border-radius:20px; box-shadow:0 4px 20px -2px rgba(15,23,42,.05); margin-bottom:20px; gap:12px; }
//         .nav-brand { font-size:22px; font-weight:800; background:linear-gradient(135deg,#ff8c42,#ff5e62); -webkit-background-clip:text; -webkit-text-fill-color:transparent; }
//         .nav-btn { padding:10px 20px; font-size:14px; font-weight:600; border-radius:12px; cursor:pointer; border:none; }
//         .btn-secondary-nav { background:#f1f5f9; color:#475569; }
//         .btn-secondary-nav:hover { background:#e2e8f0; color:#0f172a; }

//         .top-header { background:#fff; padding:22px 28px; border-radius:24px; box-shadow:0 10px 30px rgba(0,0,0,.02); display:flex; justify-content:space-between; align-items:center; margin-bottom:20px; border-left:6px solid #ff8c42; gap:16px; }
//         .merchant-title { font-size:26px; font-weight:800; color:#0f172a; }
//         .merchant-sub { font-size:14px; color:#64748b; margin-top:4px; }
//         .merchant-logo { width:54px; height:54px; border-radius:16px; background:linear-gradient(135deg,#ff8c42,#ff5e62); color:#fff; display:flex; align-items:center; justify-content:center; font-size:20px; font-weight:700; flex-shrink:0; }

//         .badge { display:inline-block; padding:4px 10px; border-radius:20px; font-size:12px; font-weight:700; }
//         .badge-neutral { background:#f1f5f9; color:#475569; }

//         /* performance (today / week / month) */
//         .perf-card { background:#fff; border-radius:24px; padding:24px; border:1px solid #e2e8f0; box-shadow:0 10px 30px rgba(15,23,42,.04); margin-bottom:20px; }
//         .perf-head { display:flex; justify-content:space-between; align-items:flex-start; gap:16px; flex-wrap:wrap; margin-bottom:18px; }
//         .perf-title { font-size:20px; font-weight:800; color:#0f172a; letter-spacing:-.4px; }
//         .perf-range { font-size:13.5px; color:#64748b; margin-top:4px; }
//         .perf-controls { display:flex; gap:10px; align-items:center; flex-wrap:wrap; }
//         .tabs { display:inline-flex; background:#f1f5f9; border-radius:14px; padding:4px; gap:4px; }
//         .tab-btn { border:none; background:transparent; padding:8px 16px; border-radius:10px; font-size:13px; font-weight:700; color:#475569; cursor:pointer; white-space:nowrap; }
//         .tab-btn.active { background:linear-gradient(135deg,#ff8c42,#ff5e62); color:#fff; box-shadow:0 4px 10px rgba(255,94,98,.25); }
//         .date-input { height:38px; border:1px solid #cbd5e1; background:#f8fafc; border-radius:10px; padding:0 10px; font-size:13px; color:#334155; outline:none; }
//         .date-input:focus { border-color:#ff8c42; box-shadow:0 0 0 3px rgba(255,140,66,.15); }

//         .stat-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:14px; }
//         .stat-box { background:#f8fafc; border:1px solid #e2e8f0; border-radius:16px; padding:16px; min-width:0; }
//         .stat-box.big { background:linear-gradient(135deg,#fff7ed,#fff1f2); border-color:#fed7aa; }
//         .stat-label { font-size:12px; font-weight:700; color:#64748b; text-transform:uppercase; letter-spacing:.4px; margin-bottom:6px; }
//         .stat-value { font-size:30px; font-weight:800; color:#0f172a; letter-spacing:-.8px; line-height:1.1; overflow-wrap:anywhere; }
//         .stat-note { font-size:12px; color:#64748b; margin-top:6px; }
//         .source-note { font-size:12px; color:#94a3b8; margin-top:12px; }

//         /* chart */
//         .chart-head { display:flex; justify-content:space-between; align-items:center; gap:12px; flex-wrap:wrap; margin:22px 0 12px; }
//         .chart-title { font-size:15px; font-weight:800; color:#0f172a; }
//         .chart-scroll { overflow-x:auto; padding-bottom:6px; }
//         .bar-chart { display:flex; align-items:flex-end; gap:8px; height:190px; min-width:100%; }
//         .bar-chart-month { min-width:620px; gap:5px; }
//         .bar-col { flex:1; display:flex; flex-direction:column; align-items:center; justify-content:flex-end; height:100%; min-width:0; }
//         .bar-value { font-size:11px; font-weight:700; color:#475569; height:16px; white-space:nowrap; }
//         .bar-track { width:100%; flex:1; display:flex; align-items:flex-end; background:#f1f5f9; border-radius:8px; overflow:hidden; }
//         .bar-fill { width:100%; border-radius:8px 8px 0 0; background:linear-gradient(180deg,#ff8c42,#ff5e62); transition:height .4s ease; }
//         .bar-col.active .bar-label { color:#ea580c; font-weight:800; }
//         .bar-label { font-size:11px; color:#94a3b8; margin-top:6px; font-weight:600; }

//         /* day bills list */
//         .txn-list { display:flex; flex-direction:column; gap:8px; margin-top:6px; }
//         .txn-row { display:flex; justify-content:space-between; align-items:center; gap:12px; padding:12px 14px; border:1px solid #e2e8f0; border-radius:14px; background:#fff; }
//         .txn-left { min-width:0; }
//         .txn-name { font-size:14px; font-weight:700; color:#0f172a; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
//         .txn-meta { font-size:12px; color:#64748b; font-family:monospace; margin-top:2px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
//         .txn-amount { font-size:15px; font-weight:800; color:#16a34a; white-space:nowrap; }

//         /* summary cards */
//         .metrics-summary-row { display:grid; grid-template-columns:repeat(auto-fit,minmax(190px,1fr)); gap:16px; margin-bottom:20px; }
//         .card { background:#fff; border-radius:24px; padding:22px; box-shadow:0 10px 30px rgba(15,23,42,.04); border:1px solid #e2e8f0; }
//         .card h2 { font-size:15px; margin-bottom:8px; color:#475569; font-weight:700; }
//         .metric-huge { font-size:30px; font-weight:800; color:#0f172a; letter-spacing:-1px; margin-bottom:4px; }
//         .metric-note { font-size:12px; color:#64748b; margin-top:6px; }
//         .metric-star-color { color:#f59e0b; }
//         .metric-progress-track { background:#f1f5f9; height:6px; border-radius:10px; overflow:hidden; margin-top:12px; }
//         .metric-progress-bar { height:100%; border-radius:10px; transition:width .5s ease; }
//         .bg-coral { background:linear-gradient(90deg,#ff8c42,#ff5e62); }
//         .bg-gold { background:linear-gradient(90deg,#f59e0b,#eab308); }

//         /* search */
//         .search-engine-box { background:#fff; border-radius:20px; padding:20px; border:1px solid #e2e8f0; margin-bottom:20px; }
//         .search-flex-row { display:flex; gap:12px; }
//         .input-group { flex:1; }
//         .input-group input { width:100%; height:48px; border:1px solid #cbd5e1; background:#f8fafc; border-radius:12px; padding:0 16px; font-size:14px; outline:none; }
//         .input-group input:focus { background:#fff; border-color:#ff8c42; box-shadow:0 0 0 4px rgba(255,140,66,.15); }
//         .save-btn { height:48px; padding:0 24px; border:none; border-radius:12px; background:linear-gradient(135deg,#ff8c42,#ff5e62); color:#fff; font-size:14px; font-weight:600; cursor:pointer; white-space:nowrap; }
//         .save-btn:hover { opacity:.92; }

//         /* modal */
//         .modal-blur-overlay { position:fixed; inset:0; background:rgba(15,23,42,.4); backdrop-filter:blur(8px); z-index:10000; display:flex; justify-content:center; align-items:center; padding:20px; }
//         .modal-profile-box { background:#fff; width:100%; max-width:520px; max-height:92vh; overflow-y:auto; border-radius:24px; box-shadow:0 25px 50px -12px rgba(0,0,0,.15); animation:modalSlideUp .3s ease; }
//         .modal-hero-header { background:linear-gradient(135deg,#0f172a,#1e293b); color:#fff; padding:24px; position:relative; }
//         .modal-hero-title { font-size:20px; font-weight:800; margin-bottom:4px; padding-right:40px; }
//         .modal-hero-subtitle { color:#94a3b8; font-size:13px; font-family:monospace; }
//         .modal-close-btn { position:absolute; top:22px; right:22px; background:rgba(255,255,255,.1); border:none; color:#fff; width:32px; height:32px; border-radius:50%; cursor:pointer; font-size:16px; }
//         .modal-close-btn:hover { background:rgba(255,255,255,.2); }
//         .modal-body-content { padding:24px; }
//         .modal-insights-grid { display:grid; grid-template-columns:1fr 1fr; gap:14px; margin-bottom:20px; }
//         .insight-data-card { background:#f8fafc; border:1px solid #e2e8f0; padding:14px; border-radius:12px; }
//         .insight-label { font-size:11px; font-weight:700; color:#64748b; text-transform:uppercase; margin-bottom:4px; }
//         .insight-value { font-size:16px; font-weight:800; color:#0f172a; }
//         .modal-rating-segment { background:#fffbeb; border:1px solid #fde68a; border-radius:14px; padding:16px; }
//         .modal-rating-stars { color:#f59e0b; font-size:16px; margin-bottom:6px; font-weight:bold; }
//         .modal-review-msg { font-size:13.5px; color:#b45309; font-style:italic; line-height:1.5; }
//         @keyframes modalSlideUp { from { transform:translateY(20px); opacity:0; } to { transform:translateY(0); opacity:1; } }

//         /* lists */
//         .main-grid { display:flex; flex-direction:column; gap:24px; }
//         .custom-dashboard-card { background:#fff; border-radius:24px; padding:24px; border:1px solid #e2e8f0; }
//         .card-header-wrapper { display:flex; justify-content:space-between; align-items:flex-start; gap:16px; margin-bottom:20px; }
//         .card-title { font-size:20px; font-weight:800; color:#0f172a; letter-spacing:-.5px; }
//         .card-subtitle { font-size:13.5px; color:#64748b; margin-top:4px; line-height:1.5; }
//         .dynamic-dashboard-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:16px; max-height:520px; overflow-y:auto; padding-right:6px; padding-bottom:6px; }
//         .dynamic-dashboard-grid::-webkit-scrollbar { width:6px; }
//         .dynamic-dashboard-grid::-webkit-scrollbar-track { background:#f1f5f9; border-radius:8px; }
//         .dynamic-dashboard-grid::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:8px; }
//         .audit-profile-card { background:#fff; border:1px solid #e2e8f0; border-radius:16px; padding:16px; display:flex; flex-direction:column; justify-content:space-between; cursor:pointer; transition:transform .2s, box-shadow .2s, border-color .2s; }
//         .audit-profile-card:hover { transform:translateY(-2px); border-color:#cbd5e1; box-shadow:0 4px 12px rgba(0,0,0,.03); }
//         .review-card { background:#fff; border:1px solid #e2e8f0; border-radius:16px; padding:16px; display:flex; flex-direction:column; justify-content:space-between; min-height:150px; }
//         .status-pill { display:inline-flex; align-items:center; padding:4px 10px; border-radius:8px; font-size:12px; font-weight:600; }
//         .status-pill-active { background:#e0f2fe; color:#0369a1; }
//         .status-pill-neutral { background:#f1f5f9; color:#475569; }
//         .reward-box { background:#f8fafc; border-radius:10px; padding:8px 12px; text-align:center; flex:1; border:1px solid #f1f5f9; }
//         .empty-box { text-align:center; padding:40px 20px; color:#94a3b8; background:#f8fafc; border-radius:16px; border:1px dashed #cbd5e1; font-size:14px; font-weight:600; }

//         /* responsive */
//         @media (max-width:1120px) { .dynamic-dashboard-grid { grid-template-columns:repeat(3,1fr); } }
//         @media (max-width:768px) {
//           .merchant-page { padding:14px; }
//           .premium-nav { padding:14px 18px; flex-direction:column; text-align:center; }
//           .top-header { padding:18px; flex-direction:column; text-align:center; }
//           .search-flex-row { flex-direction:column; gap:10px; }
//           .save-btn { width:100%; }
//           .perf-card { padding:18px; border-radius:20px; }
//           .perf-head { flex-direction:column; align-items:stretch; }
//           .perf-controls { justify-content:space-between; }
//           .tabs { width:100%; }
//           .tab-btn { flex:1; padding:8px 6px; }
//           .stat-grid { grid-template-columns:1fr 1fr; gap:10px; }
//           .stat-value { font-size:24px; }
//           .metrics-summary-row { grid-template-columns:1fr 1fr; gap:12px; }
//           .metric-huge { font-size:24px; }
//           .card { padding:16px; border-radius:18px; }
//           .modal-insights-grid { grid-template-columns:1fr; gap:10px; }
//           .sub-status-bar { flex-direction:column; text-align:center; font-size:13px; padding:12px; }
//           .dynamic-dashboard-grid { grid-template-columns:repeat(2,1fr); gap:12px; max-height:460px; }
//         }
//         @media (max-width:480px) {
//           .custom-dashboard-card { padding:16px; border-radius:16px; }
//           .card-header-wrapper { flex-direction:column; align-items:stretch; gap:10px; }
//           .dynamic-dashboard-grid { grid-template-columns:1fr; max-height:400px; }
//           .perf-controls { flex-direction:column; align-items:stretch; }
//           .date-input { width:100%; }
//         }
//       `}</style>

//       {/* Subscription lock */}
//       {!isSubscribed && (
//         <div className="subscription-lock-overlay">
//           <div className="lock-card">
//             <div className="lock-icon-box">
//               <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
//                 <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//                 <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//               </svg>
//             </div>
//             <h2>Premium Subscription Locked</h2>
//             <p>Your merchant plan is inactive. Activate your plan to see analytics and customer logs.</p>
//             <button className="save-btn" style={{ width: "100%" }} onClick={() => alert("Initiating Core Payment Gateway...")}>
//               Activate Premium Plan
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Customer details modal */}
//       {selectedCustomer && (
//         <div className="modal-blur-overlay" onClick={() => setSelectedCustomer(null)}>
//           <div className="modal-profile-box" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-hero-header">
//               <button className="modal-close-btn" onClick={() => setSelectedCustomer(null)}>✕</button>
//               <div className="modal-hero-title">{selectedCustomer.name || "Anonymous Member"}</div>
//               <div className="modal-hero-subtitle">ID: {selectedCustomer.customer_id || "N/A"}</div>
//             </div>
//             <div className="modal-body-content">
//               <div className="modal-insights-grid">
//                 <div className="insight-data-card">
//                   <div className="insight-label">Mobile Number</div>
//                   <div className="insight-value">{selectedCustomer.mobile || "—"}</div>
//                 </div>
//                 <div className="insight-data-card">
//                   <div className="insight-label">Loyalty Tier</div>
//                   <div className="insight-value" style={{ color: "#ff8c42" }}>{selectedCustomer.loyalty_status || "Standard Tier"}</div>
//                 </div>
//                 <div className="insight-data-card">
//                   <div className="insight-label">Total Visits</div>
//                   <div className="insight-value">{selectedCustomer.total_visits || 0}</div>
//                 </div>
//                 <div className="insight-data-card">
//                   <div className="insight-label">Used / Pending Rewards</div>
//                   <div className="insight-value" style={{ fontSize: "14px" }}>
//                     <span style={{ color: "#10b981" }}>{selectedCustomer.used_rewards || 0} Used</span> /{" "}
//                     <span style={{ color: "#ff8c42" }}>{selectedCustomer.unused_rewards || 0} Pending</span>
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-rating-segment">
//                 <div className="insight-label" style={{ color: "#b45309" }}>Customer Feedback</div>
//                 <div className="modal-rating-stars">
//                   {selectedCustomer.rating === null ? (
//                     "No Star Rating"
//                   ) : (
//                     <>
//                       {renderStars(selectedCustomer.rating)}
//                       <span style={{ fontSize: "12px", color: "#64748b", marginLeft: "6px" }}>({selectedCustomer.rating})</span>
//                     </>
//                   )}
//                 </div>
//                 <p className="modal-review-msg">"{selectedCustomer.review_text}"</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="merchant-page">
//         <div className="page-inner">
//           <nav className="premium-nav">
//             <span className="nav-brand">CountMyVisit</span>
//             <span className="badge badge-neutral" style={{ fontFamily: "monospace" }}>ID: {MERCHANT_ID}</span>
//           </nav>

//           <div className={`sub-status-bar ${isSubscribed ? "sub-active-bar" : "sub-expired-bar"}`}>
//             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//               <span className="sub-days-count">{isSubscribed ? "Active" : "Locked"}</span>
//               <span>{analytics.planName ? `${analytics.planName} plan` : "Premium Merchant Analytics"}</span>
//             </div>
//           </div>

//           <header className="top-header">
//             <div>
//               <div className="merchant-title">Merchant Dashboard</div>
//               <div className="merchant-sub">Visits, sales, reviews and customer profiles</div>
//             </div>
//             <div className="merchant-logo">M</div>
//           </header>

//           {/* ================= VISITS & SALES: TODAY / WEEK / MONTH ================= */}
//           <section className="perf-card">
//             <div className="perf-head">
//               <div>
//                 <div className="perf-title">Visits &amp; Sales</div>
//                 <div className="perf-range">
//                   {rangeLabel(period, p)}
//                   {statsLoading ? " · updating..." : ""}
//                 </div>
//               </div>
//               <div className="perf-controls">
//                 <div className="tabs">
//                   {PERIODS.map((t) => (
//                     <button key={t.key} type="button" className={`tab-btn ${period === t.key ? "active" : ""}`} onClick={() => setPeriod(t.key)}>
//                       {t.label}
//                     </button>
//                   ))}
//                 </div>
//                 <input
//                   type="date"
//                   className="date-input"
//                   max={todayStr}
//                   value={selectedDate || todayStr}
//                   onChange={(e) => {
//                     const v = e.target.value;
//                     setSelectedDate(!v || v === todayStr ? "" : v);
//                   }}
//                 />
//                 {selectedDate && (
//                   <button type="button" className="nav-btn btn-secondary-nav" style={{ padding: "8px 14px" }} onClick={() => setSelectedDate("")}>
//                     Today
//                   </button>
//                 )}
//               </div>
//             </div>

//             <div className="stat-grid">
//               <div className="stat-box big">
//                 <div className="stat-label">Visits</div>
//                 <div className="stat-value">{p.visits}</div>
//                 <div className="stat-note">{p.unique} unique customers</div>
//               </div>
//               <div className="stat-box big">
//                 <div className="stat-label">Sale</div>
//                 <div className="stat-value">{inr(p.sale)}</div>
//                 <div className="stat-note">{p.bills} bills{p.discount > 0 ? ` · ${inr(p.discount)} discount` : ""}</div>
//               </div>
//               <div className="stat-box">
//                 <div className="stat-label">Average Bill</div>
//                 <div className="stat-value">{inr(avgBill)}</div>
//                 <div className="stat-note">Bill total {inr(p.billTotal)}</div>
//               </div>
//               <div className="stat-box">
//                 <div className="stat-label">New Customers</div>
//                 <div className="stat-value">{p.newC}</div>
//                 <div className="stat-note">First visit in this period</div>
//               </div>
//               <div className="stat-box">
//                 <div className="stat-label">Returning</div>
//                 <div className="stat-value">{p.returningC}</div>
//                 <div className="stat-note">Came back again</div>
//               </div>
//               <div className="stat-box">
//                 <div className="stat-label">Unique Customers</div>
//                 <div className="stat-value">{p.unique}</div>
//                 <div className="stat-note">Different people</div>
//               </div>
//             </div>

//             {/* Today -> bills list, Week/Month -> daily chart */}
//             {period === "today" ? (
//               <>
//                 <div className="chart-head">
//                   <div className="chart-title">Bills on {stats.date || todayStr}</div>
//                 </div>
//                 {stats.todayRows.length === 0 ? (
//                   <div className="empty-box">📭 No visits recorded on this date.</div>
//                 ) : (
//                   <div className="txn-list">
//                     {stats.todayRows.map((r) => (
//                       <div className="txn-row" key={r.id ?? `${r.customer_id}-${r.created_at}`}>
//                         <div className="txn-left">
//                           <div className="txn-name">{nameOf(r.customer_id) || r.customer_id}</div>
//                           <div className="txn-meta">
//                             {String(r.created_at || "").slice(11, 16)} · {r.customer_id}
//                           </div>
//                         </div>
//                         <div className="txn-amount">{inr(r.payable_amount)}</div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </>
//             ) : (
//               <>
//                 <div className="chart-head">
//                   <div className="chart-title">Day-by-day {chartMetric === "visits" ? "visits" : "sales"}</div>
//                   <div className="tabs">
//                     <button type="button" className={`tab-btn ${chartMetric === "visits" ? "active" : ""}`} onClick={() => setChartMetric("visits")}>Visits</button>
//                     <button type="button" className={`tab-btn ${chartMetric === "sale" ? "active" : ""}`} onClick={() => setChartMetric("sale")}>Sale</button>
//                   </div>
//                 </div>
//                 {days.length === 0 ? (
//                   <div className="empty-box">📭 No data for this period.</div>
//                 ) : (
//                   <div className="chart-scroll">
//                     <div className={`bar-chart ${period === "month" ? "bar-chart-month" : ""}`}>
//                       {days.map((d) => {
//                         const val = d[chartMetric];
//                         const h = val > 0 ? Math.max(6, (val / maxVal) * 100) : 0;
//                         return (
//                           <div
//                             className={`bar-col ${d.date === stats.date ? "active" : ""}`}
//                             key={d.date}
//                             title={`${d.date}: ${d.visits} visits, ${inr(d.sale)}`}
//                           >
//                             <div className="bar-value">{val > 0 ? (chartMetric === "sale" ? Math.round(val) : val) : ""}</div>
//                             <div className="bar-track">
//                               <div className="bar-fill" style={{ height: `${h}%` }}></div>
//                             </div>
//                             <div className="bar-label">{period === "week" ? d.day : d.date.slice(8)}</div>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 )}
//               </>
//             )}
//             <div className="source-note">
//               {stats.source === "visit_logs" ? "Visits counted from visit log." : "Visits counted from billing records."}
//             </div>
//           </section>

//           {/* Summary cards */}
//           <div className="metrics-summary-row">
//             <div className="card">
//               <h2>Total Customers</h2>
//               <div className="metric-huge">{analytics.totalCustomers}</div>
//               <div className="metric-note">{analytics.newCustomers} new · {analytics.returningCustomers} returning</div>
//               <div className="metric-progress-track"><div className="metric-progress-bar bg-coral" style={{ width: "100%" }}></div></div>
//             </div>
//             <div className="card">
//               <h2>Retention Score</h2>
//               <div className="metric-huge">{analytics.returningRatio}%</div>
//               <div className="metric-progress-track"><div className="metric-progress-bar bg-coral" style={{ width: `${retention}%` }}></div></div>
//             </div>
//             <div className="card">
//               <h2>Average Rating</h2>
//               <div className="metric-huge metric-star-color">
//                 {reviewsSummary.average_rating} <span style={{ fontSize: "20px" }}>★</span>
//               </div>
//               <div className="metric-progress-track">
//                 <div className="metric-progress-bar bg-gold" style={{ width: `${Math.min(100, (num(reviewsSummary.average_rating) / 5) * 100)}%` }}></div>
//               </div>
//             </div>
//             <div className="card">
//               <h2>All-time Visits</h2>
//               <div className="metric-huge">{analytics.totalVisits}</div>
//               <div className="metric-note">{analytics.redeemedRewards} rewards redeemed</div>
//             </div>
//             <div className="card">
//               <h2>Lifetime Sales</h2>
//               <div className="metric-huge">{inr(analytics.lifetimeSales)}</div>
//             </div>
//           </div>

//           {/* Search */}
//           <div className="search-engine-box">
//             <form onSubmit={handleSearch} className="search-flex-row">
//               <div className="input-group">
//                 <input
//                   type="tel"
//                   placeholder="Search customer by mobile number..."
//                   value={searchMobile}
//                   onChange={(e) => setSearchMobile(e.target.value)}
//                 />
//               </div>
//               <button type="submit" className="save-btn">Search</button>
//               {isSearching && (
//                 <button type="button" className="nav-btn btn-secondary-nav" onClick={resetSearch}>Reset</button>
//               )}
//             </form>
//           </div>

//           <main className="main-grid">
//             {/* Customers */}
//             <div className="custom-dashboard-card">
//               <div className="card-header-wrapper">
//                 <div>
//                   <h2 className="card-title">{isSearching ? "Search Results" : "Customer Retention Log"}</h2>
//                   <p className="card-subtitle">Tap a customer to see full details.</p>
//                 </div>
//               </div>

//               {customers.length === 0 ? (
//                 <div className="empty-box">📭 No customers found.</div>
//               ) : (
//                 <div className="dynamic-dashboard-grid">
//                   {customers.map((item, idx) => (
//                     <div key={item.customer_id || idx} className="audit-profile-card" onClick={() => openCustomerDetails(item)}>
//                       <div>
//                         <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12, minWidth: 0 }}>
//                           <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: "#475569", flexShrink: 0 }}>
//                             {(item.name || "A")[0].toUpperCase()}
//                           </div>
//                           <div style={{ minWidth: 0 }}>
//                             <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                               {item.name || "Anonymous Member"}
//                             </div>
//                             <div style={{ fontSize: 11, fontFamily: "monospace", color: "#64748b", marginTop: 1 }}>{item.mobile || "—"}</div>
//                           </div>
//                         </div>
//                         <div style={{ marginBottom: 14 }}>
//                           <span className={`status-pill ${num(item.total_visits) > 0 ? "status-pill-active" : "status-pill-neutral"}`}>
//                             📌 {item.total_visits || 0} Visits
//                           </span>
//                         </div>
//                       </div>

//                       <div style={{ borderTop: "1px dashed #e2e8f0", paddingTop: 12, marginTop: "auto" }}>
//                         <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
//                           <div className="reward-box">
//                             <div style={{ fontSize: 10, fontWeight: 600, color: "#64748b", textTransform: "uppercase" }}>Unused</div>
//                             <div style={{ fontSize: 15, fontWeight: 800, color: num(item.unused_rewards) > 0 ? "#ea580c" : "#94a3b8", marginTop: 2 }}>{item.unused_rewards || 0}</div>
//                           </div>
//                           <div className="reward-box">
//                             <div style={{ fontSize: 10, fontWeight: 600, color: "#64748b", textTransform: "uppercase" }}>Claimed</div>
//                             <div style={{ fontSize: 15, fontWeight: 800, color: num(item.used_rewards) > 0 ? "#16a34a" : "#94a3b8", marginTop: 2 }}>{item.used_rewards || 0}</div>
//                           </div>
//                         </div>
//                         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                           <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 500 }}>Status</span>
//                           <span style={{ fontSize: 11, fontWeight: 700, background: "#f8fafc", padding: "3px 8px", borderRadius: 6, border: "1px solid #e2e8f0", color: "#334155" }}>
//                             {item.loyalty_status || "Standard Tier"}
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>

//             {/* Reviews */}
//             <div className="custom-dashboard-card">
//               <div className="card-header-wrapper">
//                 <div>
//                   <h2 className="card-title">Customer Reviews</h2>
//                   <p className="card-subtitle">Latest ratings and feedback from your customers.</p>
//                 </div>
//                 <span style={{ display: "inline-flex", alignItems: "center", fontSize: 13, fontWeight: 700, background: "#fef9c3", color: "#854d0e", padding: "6px 14px", borderRadius: 100, whiteSpace: "nowrap", border: "1px solid #fef08a" }}>
//                   ⭐ {reviewsSummary.total_reviews || 0} Feedbacks
//                 </span>
//               </div>

//               {allReviews.length === 0 ? (
//                 <div className="empty-box">📭 No reviews yet.</div>
//               ) : (
//                 <div className="dynamic-dashboard-grid">
//                   {allReviews.map((item, idx) => (
//                     <div key={item.id ?? idx} className="review-card">
//                       <div>
//                         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, gap: 8 }}>
//                           <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
//                             <div style={{ width: 28, height: 28, borderRadius: "50%", background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, color: "#64748b", flexShrink: 0 }}>
//                               {(item.customer_name || "A")[0].toUpperCase()}
//                             </div>
//                             <span style={{ fontSize: 14, fontWeight: 700, color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                               {item.customer_name || "Anonymous Guest"}
//                             </span>
//                           </div>
//                           <span style={{ fontSize: 10, fontWeight: 600, color: "#64748b", background: "#f8fafc", padding: "3px 8px", borderRadius: 6, border: "1px solid #e2e8f0", whiteSpace: "nowrap", flexShrink: 0 }}>
//                             {item.mobile ? `+91 ${item.mobile}` : "—"}
//                           </span>
//                         </div>
//                         <p style={{ fontSize: 13, margin: "0 0 16px", lineHeight: 1.5, color: "#475569", fontStyle: "italic" }}>
//                           "{item.review || "No comment written."}"
//                         </p>
//                       </div>
//                       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderTop: "1px dashed #f1f5f9", paddingTop: 12, marginTop: "auto" }}>
//                         <span style={{ color: "#f59e0b", fontSize: 13 }}>{renderStars(item.rating)}</span>
//                         <span style={{ fontSize: 11, fontWeight: 700, color: "#475569", background: "#f1f5f9", padding: "2px 6px", borderRadius: 4 }}>
//                           {item.rating} / 5
//                         </span>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </main>
//         </div>
//       </div>
//     </>
//   );
// }
